export default [
  {
    "pantone":"100-c",
    "hex":"#f6eb61"
  },
  {
    "pantone":"101-c",
    "hex":"#f7ea48"
  },
  {
    "pantone":"102-c",
    "hex":"#fce300"
  },
  {
    "pantone":"103-c",
    "hex":"#c5a900"
  },
  {
    "pantone":"104-c",
    "hex":"#af9800"
  },
  {
    "pantone":"105-c",
    "hex":"#897a27"
  },
  {
    "pantone":"7401-c",
    "hex":"#f5e1a4"
  },
  {
    "pantone":"7402-c",
    "hex":"#ecd898"
  },
  {
    "pantone":"7403-c",
    "hex":"#eed484"
  },
  {
    "pantone":"7404-c",
    "hex":"#f4da40"
  },
  {
    "pantone":"7405-c",
    "hex":"#f2cd00"
  },
  {
    "pantone":"7406-c",
    "hex":"#f1c400"
  },
  {
    "pantone":"7407-c",
    "hex":"#cba052"
  },
  {
    "pantone":"106-c",
    "hex":"#f9e547"
  },
  {
    "pantone":"107-c",
    "hex":"#fbe122"
  },
  {
    "pantone":"108-c",
    "hex":"#fedb00"
  },
  {
    "pantone":"109-c",
    "hex":"#ffd100"
  },
  {
    "pantone":"110-c",
    "hex":"#daaa00"
  },
  {
    "pantone":"111-c",
    "hex":"#aa8a00"
  },
  {
    "pantone":"112-c",
    "hex":"#9c8412"
  },
  {
    "pantone":"113-c",
    "hex":"#fae053"
  },
  {
    "pantone":"114-c",
    "hex":"#fbdd40"
  },
  {
    "pantone":"115-c",
    "hex":"#fdda24"
  },
  {
    "pantone":"116-c",
    "hex":"#ffcd00"
  },
  {
    "pantone":"117-c",
    "hex":"#c99700"
  },
  {
    "pantone":"118-c",
    "hex":"#ac8400"
  },
  {
    "pantone":"119-c",
    "hex":"#897322"
  },
  {
    "pantone":"127-c",
    "hex":"#f3dd6d"
  },
  {
    "pantone":"128-c",
    "hex":"#f3d54e"
  },
  {
    "pantone":"129-c",
    "hex":"#f3d03e"
  },
  {
    "pantone":"130-c",
    "hex":"#f2a900"
  },
  {
    "pantone":"131-c",
    "hex":"#cc8a00"
  },
  {
    "pantone":"132-c",
    "hex":"#a07400"
  },
  {
    "pantone":"133-c",
    "hex":"#6c571b"
  },
  {
    "pantone":"1205-c",
    "hex":"#f8e08e"
  },
  {
    "pantone":"1215-c",
    "hex":"#fbd872"
  },
  {
    "pantone":"1225-c",
    "hex":"#ffc845"
  },
  {
    "pantone":"1235-c",
    "hex":"#ffb81c"
  },
  {
    "pantone":"1245-c",
    "hex":"#c69214"
  },
  {
    "pantone":"1255-c",
    "hex":"#ad841f"
  },
  {
    "pantone":"1265-c",
    "hex":"#886b25"
  },
  {
    "pantone":"120-c",
    "hex":"#fbdb65"
  },
  {
    "pantone":"121-c",
    "hex":"#fdd757"
  },
  {
    "pantone":"122-c",
    "hex":"#fed141"
  },
  {
    "pantone":"123-c",
    "hex":"#ffc72c"
  },
  {
    "pantone":"124-c",
    "hex":"#eaaa00"
  },
  {
    "pantone":"125-c",
    "hex":"#b58500"
  },
  {
    "pantone":"126-c",
    "hex":"#9a7611"
  },
  {
    "pantone":"7548-c",
    "hex":"#ffc600"
  },
  {
    "pantone":"7549-c",
    "hex":"#ffb500"
  },
  {
    "pantone":"7550-c",
    "hex":"#d19000"
  },
  {
    "pantone":"7551-c",
    "hex":"#b47e00"
  },
  {
    "pantone":"7552-c",
    "hex":"#73531d"
  },
  {
    "pantone":"7553-c",
    "hex":"#5a4522"
  },
  {
    "pantone":"7554-c",
    "hex":"#4b3d2a"
  },
  {
    "pantone":"7555-c",
    "hex":"#d29f13"
  },
  {
    "pantone":"7556-c",
    "hex":"#b78b20"
  },
  {
    "pantone":"7557-c",
    "hex":"#9f7d23"
  },
  {
    "pantone":"7558-c",
    "hex":"#967126"
  },
  {
    "pantone":"7559-c",
    "hex":"#8f6a2a"
  },
  {
    "pantone":"7560-c",
    "hex":"#7d622e"
  },
  {
    "pantone":"7561-c",
    "hex":"#6c5d34"
  },
  {
    "pantone":"134-c",
    "hex":"#fdd26e"
  },
  {
    "pantone":"135-c",
    "hex":"#ffc658"
  },
  {
    "pantone":"136-c",
    "hex":"#ffbf3f"
  },
  {
    "pantone":"137-c",
    "hex":"#ffa300"
  },
  {
    "pantone":"138-c",
    "hex":"#de7c00"
  },
  {
    "pantone":"139-c",
    "hex":"#af6d04"
  },
  {
    "pantone":"140-c",
    "hex":"#74531c"
  },
  {
    "pantone":"1345-c",
    "hex":"#fdd086"
  },
  {
    "pantone":"1355-c",
    "hex":"#ffc56e"
  },
  {
    "pantone":"1365-c",
    "hex":"#ffb549"
  },
  {
    "pantone":"1375-c",
    "hex":"#ff9e1b"
  },
  {
    "pantone":"1385-c",
    "hex":"#d57800"
  },
  {
    "pantone":"1395-c",
    "hex":"#996017"
  },
  {
    "pantone":"1405-c",
    "hex":"#6e4c1e"
  },
  {
    "pantone":"141-c",
    "hex":"#f2c75c"
  },
  {
    "pantone":"142-c",
    "hex":"#f1be48"
  },
  {
    "pantone":"143-c",
    "hex":"#f1b434"
  },
  {
    "pantone":"144-c",
    "hex":"#ed8b00"
  },
  {
    "pantone":"145-c",
    "hex":"#cf7f00"
  },
  {
    "pantone":"146-c",
    "hex":"#a76d11"
  },
  {
    "pantone":"147-c",
    "hex":"#715c2a"
  },
  {
    "pantone":"7408-c",
    "hex":"#f6be00"
  },
  {
    "pantone":"7409-c",
    "hex":"#f0b323"
  },
  {
    "pantone":"7410-c",
    "hex":"#fead77"
  },
  {
    "pantone":"7411-c",
    "hex":"#e6a65d"
  },
  {
    "pantone":"7412-c",
    "hex":"#d38235"
  },
  {
    "pantone":"7413-c",
    "hex":"#dc8633"
  },
  {
    "pantone":"7414-c",
    "hex":"#c16c18"
  },
  {
    "pantone":"7562-c",
    "hex":"#bd9b60"
  },
  {
    "pantone":"7563-c",
    "hex":"#d69a2d"
  },
  {
    "pantone":"7564-c",
    "hex":"#db8a06"
  },
  {
    "pantone":"7565-c",
    "hex":"#cd7925"
  },
  {
    "pantone":"7566-c",
    "hex":"#ad6433"
  },
  {
    "pantone":"7567-c",
    "hex":"#89532f"
  },
  {
    "pantone":"7568-c",
    "hex":"#775135"
  },
  {
    "pantone":"7569-c",
    "hex":"#d78825"
  },
  {
    "pantone":"7570-c",
    "hex":"#d3832b"
  },
  {
    "pantone":"7571-c",
    "hex":"#c67d30"
  },
  {
    "pantone":"7572-c",
    "hex":"#b67233"
  },
  {
    "pantone":"7573-c",
    "hex":"#a7662b"
  },
  {
    "pantone":"7574-c",
    "hex":"#9e6a38"
  },
  {
    "pantone":"7575-c",
    "hex":"#835d32"
  },
  {
    "pantone":"712-c",
    "hex":"#fcc89b"
  },
  {
    "pantone":"713-c",
    "hex":"#fdbe87"
  },
  {
    "pantone":"714-c",
    "hex":"#fdaa63"
  },
  {
    "pantone":"715-c",
    "hex":"#f68d2e"
  },
  {
    "pantone":"716-c",
    "hex":"#ea7600"
  },
  {
    "pantone":"717-c",
    "hex":"#d45d00"
  },
  {
    "pantone":"718-c",
    "hex":"#be4d00"
  },
  {
    "pantone":"148-c",
    "hex":"#fecb8b"
  },
  {
    "pantone":"149-c",
    "hex":"#ffc27b"
  },
  {
    "pantone":"150-c",
    "hex":"#ffb25b"
  },
  {
    "pantone":"151-c",
    "hex":"#ff8200"
  },
  {
    "pantone":"152-c",
    "hex":"#e57200"
  },
  {
    "pantone":"153-c",
    "hex":"#be6a14"
  },
  {
    "pantone":"154-c",
    "hex":"#9b5a1a"
  },
  {
    "pantone":"155-c",
    "hex":"#efd19f"
  },
  {
    "pantone":"156-c",
    "hex":"#efbe7d"
  },
  {
    "pantone":"157-c",
    "hex":"#eca154"
  },
  {
    "pantone":"158-c",
    "hex":"#e87722"
  },
  {
    "pantone":"159-c",
    "hex":"#cb6015"
  },
  {
    "pantone":"160-c",
    "hex":"#a1561c"
  },
  {
    "pantone":"161-c",
    "hex":"#603d20"
  },
  {
    "pantone":"1485-c",
    "hex":"#ffae62"
  },
  {
    "pantone":"1495-c",
    "hex":"#ff8f1c"
  },
  {
    "pantone":"1505-c",
    "hex":"#ff6900"
  },
  {
    "pantone":"1525-c",
    "hex":"#b94700"
  },
  {
    "pantone":"1535-c",
    "hex":"#94450b"
  },
  {
    "pantone":"1545-c",
    "hex":"#653819"
  },
  {
    "pantone":"1555-c",
    "hex":"#ffb990"
  },
  {
    "pantone":"1565-c",
    "hex":"#ffa06a"
  },
  {
    "pantone":"1575-c",
    "hex":"#ff7f32"
  },
  {
    "pantone":"1585-c",
    "hex":"#ff6a13"
  },
  {
    "pantone":"1595-c",
    "hex":"#d86018"
  },
  {
    "pantone":"1605-c",
    "hex":"#a65523"
  },
  {
    "pantone":"1615-c",
    "hex":"#8b4720"
  },
  {
    "pantone":"162-c",
    "hex":"#ffbe9f"
  },
  {
    "pantone":"163-c",
    "hex":"#ff9d6e"
  },
  {
    "pantone":"164-c",
    "hex":"#ff7f41"
  },
  {
    "pantone":"165-c",
    "hex":"#ff671f"
  },
  {
    "pantone":"166-c",
    "hex":"#e35205"
  },
  {
    "pantone":"167-c",
    "hex":"#be531c"
  },
  {
    "pantone":"168-c",
    "hex":"#73381d"
  },
  {
    "pantone":"7576-c",
    "hex":"#db864e"
  },
  {
    "pantone":"7577-c",
    "hex":"#e07e3c"
  },
  {
    "pantone":"7578-c",
    "hex":"#dc6b2f"
  },
  {
    "pantone":"7579-c",
    "hex":"#dc582a"
  },
  {
    "pantone":"7580-c",
    "hex":"#c05131"
  },
  {
    "pantone":"7581-c",
    "hex":"#864a33"
  },
  {
    "pantone":"7582-c",
    "hex":"#674736"
  },
  {
    "pantone":"1625-c",
    "hex":"#ffa38b"
  },
  {
    "pantone":"1635-c",
    "hex":"#ff8d6d"
  },
  {
    "pantone":"1645-c",
    "hex":"#ff6a39"
  },
  {
    "pantone":"1655-c",
    "hex":"#fc4c02"
  },
  {
    "pantone":"1665-c",
    "hex":"#dc4405"
  },
  {
    "pantone":"1675-c",
    "hex":"#a9431e"
  },
  {
    "pantone":"1685-c",
    "hex":"#833921"
  },
  {
    "pantone":"169-c",
    "hex":"#ffb3ab"
  },
  {
    "pantone":"170-c",
    "hex":"#ff8674"
  },
  {
    "pantone":"171-c",
    "hex":"#ff5c39"
  },
  {
    "pantone":"172-c",
    "hex":"#fa4616"
  },
  {
    "pantone":"173-c",
    "hex":"#cf4520"
  },
  {
    "pantone":"174-c",
    "hex":"#963821"
  },
  {
    "pantone":"175-c",
    "hex":"#6b3529"
  },
  {
    "pantone":"7583-c",
    "hex":"#c4622d"
  },
  {
    "pantone":"7584-c",
    "hex":"#ba5826"
  },
  {
    "pantone":"7585-c",
    "hex":"#af5c37"
  },
  {
    "pantone":"7586-c",
    "hex":"#9e5330"
  },
  {
    "pantone":"7587-c",
    "hex":"#924c2e"
  },
  {
    "pantone":"7588-c",
    "hex":"#7b4d35"
  },
  {
    "pantone":"7589-c",
    "hex":"#5c4738"
  },
  {
    "pantone":"7590-c",
    "hex":"#d4b59e"
  },
  {
    "pantone":"7591-c",
    "hex":"#c07d59"
  },
  {
    "pantone":"7592-c",
    "hex":"#b15533"
  },
  {
    "pantone":"7593-c",
    "hex":"#9d432c"
  },
  {
    "pantone":"7594-c",
    "hex":"#7c3a2d"
  },
  {
    "pantone":"7595-c",
    "hex":"#6b3d2e"
  },
  {
    "pantone":"7596-c",
    "hex":"#5c3d31"
  },
  {
    "pantone":"7597-c",
    "hex":"#d14124"
  },
  {
    "pantone":"7598-c",
    "hex":"#bd472a"
  },
  {
    "pantone":"7599-c",
    "hex":"#b33d26"
  },
  {
    "pantone":"7600-c",
    "hex":"#8d3f2b"
  },
  {
    "pantone":"7601-c",
    "hex":"#83412c"
  },
  {
    "pantone":"7602-c",
    "hex":"#7b4931"
  },
  {
    "pantone":"7603-c",
    "hex":"#674230"
  },
  {
    "pantone":"7604-c",
    "hex":"#e4d5d3"
  },
  {
    "pantone":"7605-c",
    "hex":"#e1bbb4"
  },
  {
    "pantone":"7606-c",
    "hex":"#d6938a"
  },
  {
    "pantone":"7607-c",
    "hex":"#c26e60"
  },
  {
    "pantone":"7608-c",
    "hex":"#a4493d"
  },
  {
    "pantone":"7609-c",
    "hex":"#823b34"
  },
  {
    "pantone":"7610-c",
    "hex":"#683431"
  },
  {
    "pantone":"7611-c",
    "hex":"#ddbcb0"
  },
  {
    "pantone":"7612-c",
    "hex":"#ca9a8e"
  },
  {
    "pantone":"7613-c",
    "hex":"#bc8a7e"
  },
  {
    "pantone":"7614-c",
    "hex":"#a37f74"
  },
  {
    "pantone":"7615-c",
    "hex":"#866761"
  },
  {
    "pantone":"7616-c",
    "hex":"#6b4c4c"
  },
  {
    "pantone":"7617-c",
    "hex":"#583d3e"
  },
  {
    "pantone":"7520-c",
    "hex":"#eabeb0"
  },
  {
    "pantone":"7521-c",
    "hex":"#c09c83"
  },
  {
    "pantone":"7522-c",
    "hex":"#b46a55"
  },
  {
    "pantone":"7523-c",
    "hex":"#ab5c57"
  },
  {
    "pantone":"7524-c",
    "hex":"#a45248"
  },
  {
    "pantone":"7525-c",
    "hex":"#9a6a4f"
  },
  {
    "pantone":"7526-c",
    "hex":"#8a391b"
  },
  {
    "pantone":"489-c",
    "hex":"#ecc3b2"
  },
  {
    "pantone":"488-c",
    "hex":"#ecbaa8"
  },
  {
    "pantone":"487-c",
    "hex":"#eaa794"
  },
  {
    "pantone":"486-c",
    "hex":"#e8927c"
  },
  {
    "pantone":"485-c",
    "hex":"#da291c"
  },
  {
    "pantone":"484-c",
    "hex":"#9a3324"
  },
  {
    "pantone":"483-c",
    "hex":"#653024"
  },
  {
    "pantone":"176-c",
    "hex":"#ffb1bb"
  },
  {
    "pantone":"177-c",
    "hex":"#ff808b"
  },
  {
    "pantone":"178-c",
    "hex":"#ff585d"
  },
  {
    "pantone":"179-c",
    "hex":"#e03c31"
  },
  {
    "pantone":"180-c",
    "hex":"#be3a34"
  },
  {
    "pantone":"181-c",
    "hex":"#81312f"
  },
  {
    "pantone":"1765-c",
    "hex":"#ffa3b5"
  },
  {
    "pantone":"1775-c",
    "hex":"#ff8da1"
  },
  {
    "pantone":"1785-c",
    "hex":"#f8485e"
  },
  {
    "pantone":"1788-c",
    "hex":"#ee2737"
  },
  {
    "pantone":"1795-c",
    "hex":"#d22630"
  },
  {
    "pantone":"1805-c",
    "hex":"#af272f"
  },
  {
    "pantone":"1815-c",
    "hex":"#7c2529"
  },
  {
    "pantone":"1767-c",
    "hex":"#fcafc0"
  },
  {
    "pantone":"1777-c",
    "hex":"#fb637e"
  },
  {
    "pantone":"1787-c",
    "hex":"#f4364c"
  },
  {
    "pantone":"1797-c",
    "hex":"#cb333b"
  },
  {
    "pantone":"1807-c",
    "hex":"#a4343a"
  },
  {
    "pantone":"1817-c",
    "hex":"#643335"
  },
  {
    "pantone":"7618-c",
    "hex":"#c66e4e"
  },
  {
    "pantone":"7619-c",
    "hex":"#c04c36"
  },
  {
    "pantone":"7620-c",
    "hex":"#b7312c"
  },
  {
    "pantone":"7621-c",
    "hex":"#ab2328"
  },
  {
    "pantone":"7622-c",
    "hex":"#93272c"
  },
  {
    "pantone":"7623-c",
    "hex":"#8a2a2b"
  },
  {
    "pantone":"7624-c",
    "hex":"#802f2d"
  },
  {
    "pantone":"7625-c",
    "hex":"#e1523d"
  },
  {
    "pantone":"7626-c",
    "hex":"#c63527"
  },
  {
    "pantone":"7627-c",
    "hex":"#a72b2a"
  },
  {
    "pantone":"7628-c",
    "hex":"#9e2a2b"
  },
  {
    "pantone":"7629-c",
    "hex":"#6d3332"
  },
  {
    "pantone":"7630-c",
    "hex":"#633231"
  },
  {
    "pantone":"7631-c",
    "hex":"#572d2d"
  },
  {
    "pantone":"7415-c",
    "hex":"#e6baa8"
  },
  {
    "pantone":"7416-c",
    "hex":"#e56a54"
  },
  {
    "pantone":"7417-c",
    "hex":"#e04e39"
  },
  {
    "pantone":"7418-c",
    "hex":"#cd545b"
  },
  {
    "pantone":"7419-c",
    "hex":"#b04a5a"
  },
  {
    "pantone":"7420-c",
    "hex":"#9b2242"
  },
  {
    "pantone":"7421-c",
    "hex":"#651d32"
  },
  {
    "pantone":"182-c",
    "hex":"#fabbcb"
  },
  {
    "pantone":"183-c",
    "hex":"#fc9bb3"
  },
  {
    "pantone":"184-c",
    "hex":"#f65275"
  },
  {
    "pantone":"185-c",
    "hex":"#e4002b"
  },
  {
    "pantone":"186-c",
    "hex":"#c8102e"
  },
  {
    "pantone":"187-c",
    "hex":"#a6192e"
  },
  {
    "pantone":"188-c",
    "hex":"#76232f"
  },
  {
    "pantone":"196-c",
    "hex":"#ecc7cd"
  },
  {
    "pantone":"197-c",
    "hex":"#e89cae"
  },
  {
    "pantone":"198-c",
    "hex":"#df4661"
  },
  {
    "pantone":"199-c",
    "hex":"#d50032"
  },
  {
    "pantone":"200-c",
    "hex":"#ba0c2f"
  },
  {
    "pantone":"201-c",
    "hex":"#9d2235"
  },
  {
    "pantone":"202-c",
    "hex":"#862633"
  },
  {
    "pantone":"189-c",
    "hex":"#f8a3bc"
  },
  {
    "pantone":"190-c",
    "hex":"#f67599"
  },
  {
    "pantone":"191-c",
    "hex":"#ef426f"
  },
  {
    "pantone":"192-c",
    "hex":"#e40046"
  },
  {
    "pantone":"193-c",
    "hex":"#bf0d3e"
  },
  {
    "pantone":"194-c",
    "hex":"#9b2743"
  },
  {
    "pantone":"195-c",
    "hex":"#782f40"
  },
  {
    "pantone":"1895-c",
    "hex":"#f5b6cd"
  },
  {
    "pantone":"1905-c",
    "hex":"#f59bbb"
  },
  {
    "pantone":"1915-c",
    "hex":"#ef4a81"
  },
  {
    "pantone":"1925-c",
    "hex":"#e0004d"
  },
  {
    "pantone":"1935-c",
    "hex":"#c5003e"
  },
  {
    "pantone":"1945-c",
    "hex":"#a6093d"
  },
  {
    "pantone":"1955-c",
    "hex":"#8a1538"
  },
  {
    "pantone":"705-c",
    "hex":"#f5dadf"
  },
  {
    "pantone":"706-c",
    "hex":"#f7ced7"
  },
  {
    "pantone":"707-c",
    "hex":"#f9b5c4"
  },
  {
    "pantone":"708-c",
    "hex":"#f890a5"
  },
  {
    "pantone":"709-c",
    "hex":"#ef6079"
  },
  {
    "pantone":"710-c",
    "hex":"#e03e52"
  },
  {
    "pantone":"711-c",
    "hex":"#cb2c30"
  },
  {
    "pantone":"698-c",
    "hex":"#f2d4d7"
  },
  {
    "pantone":"699-c",
    "hex":"#f4c3cc"
  },
  {
    "pantone":"700-c",
    "hex":"#f2acb9"
  },
  {
    "pantone":"701-c",
    "hex":"#e68699"
  },
  {
    "pantone":"702-c",
    "hex":"#d25b73"
  },
  {
    "pantone":"703-c",
    "hex":"#b83a4b"
  },
  {
    "pantone":"704-c",
    "hex":"#9e2a2f"
  },
  {
    "pantone":"203-c",
    "hex":"#ecb3cb"
  },
  {
    "pantone":"204-c",
    "hex":"#e782a9"
  },
  {
    "pantone":"205-c",
    "hex":"#e0457b"
  },
  {
    "pantone":"206-c",
    "hex":"#ce0037"
  },
  {
    "pantone":"207-c",
    "hex":"#a50034"
  },
  {
    "pantone":"208-c",
    "hex":"#861f41"
  },
  {
    "pantone":"209-c",
    "hex":"#6f263d"
  },
  {
    "pantone":"210-c",
    "hex":"#f99fc9"
  },
  {
    "pantone":"211-c",
    "hex":"#f57eb6"
  },
  {
    "pantone":"212-c",
    "hex":"#f04e98"
  },
  {
    "pantone":"213-c",
    "hex":"#e31c79"
  },
  {
    "pantone":"214-c",
    "hex":"#ce0f69"
  },
  {
    "pantone":"215-c",
    "hex":"#ac145a"
  },
  {
    "pantone":"216-c",
    "hex":"#7d2248"
  },
  {
    "pantone":"7422-c",
    "hex":"#f4cdd4"
  },
  {
    "pantone":"7423-c",
    "hex":"#e06287"
  },
  {
    "pantone":"7424-c",
    "hex":"#e24585"
  },
  {
    "pantone":"7425-c",
    "hex":"#b52555"
  },
  {
    "pantone":"7426-c",
    "hex":"#a4123f"
  },
  {
    "pantone":"7427-c",
    "hex":"#971b2f"
  },
  {
    "pantone":"7428-c",
    "hex":"#6a2c3e"
  },
  {
    "pantone":"7632-c",
    "hex":"#d6c9ca"
  },
  {
    "pantone":"7633-c",
    "hex":"#c4a4a7"
  },
  {
    "pantone":"7634-c",
    "hex":"#c16784"
  },
  {
    "pantone":"7635-c",
    "hex":"#c63663"
  },
  {
    "pantone":"7636-c",
    "hex":"#bc204b"
  },
  {
    "pantone":"7637-c",
    "hex":"#912f46"
  },
  {
    "pantone":"7638-c",
    "hex":"#7e2d40"
  },
  {
    "pantone":"217-c",
    "hex":"#eabedb"
  },
  {
    "pantone":"218-c",
    "hex":"#e56db1"
  },
  {
    "pantone":"219-c",
    "hex":"#da1884"
  },
  {
    "pantone":"220-c",
    "hex":"#a50050"
  },
  {
    "pantone":"221-c",
    "hex":"#910048"
  },
  {
    "pantone":"222-c",
    "hex":"#6c1d45"
  },
  {
    "pantone":"7639-c",
    "hex":"#936d73"
  },
  {
    "pantone":"7640-c",
    "hex":"#934054"
  },
  {
    "pantone":"7641-c",
    "hex":"#8e2c48"
  },
  {
    "pantone":"7642-c",
    "hex":"#732e4a"
  },
  {
    "pantone":"7643-c",
    "hex":"#672e45"
  },
  {
    "pantone":"7644-c",
    "hex":"#582d40"
  },
  {
    "pantone":"7645-c",
    "hex":"#502b3a"
  },
  {
    "pantone":"223-c",
    "hex":"#ef95cf"
  },
  {
    "pantone":"224-c",
    "hex":"#eb6fbd"
  },
  {
    "pantone":"225-c",
    "hex":"#df1995"
  },
  {
    "pantone":"226-c",
    "hex":"#d0006f"
  },
  {
    "pantone":"227-c",
    "hex":"#aa0061"
  },
  {
    "pantone":"228-c",
    "hex":"#890c58"
  },
  {
    "pantone":"229-c",
    "hex":"#672146"
  },
  {
    "pantone":"230-c",
    "hex":"#f4a6d7"
  },
  {
    "pantone":"231-c",
    "hex":"#f277c6"
  },
  {
    "pantone":"232-c",
    "hex":"#e93cac"
  },
  {
    "pantone":"233-c",
    "hex":"#c6007e"
  },
  {
    "pantone":"234-c",
    "hex":"#a20067"
  },
  {
    "pantone":"235-c",
    "hex":"#840b55"
  },
  {
    "pantone":"670-c",
    "hex":"#ead3e2"
  },
  {
    "pantone":"671-c",
    "hex":"#e6bcd8"
  },
  {
    "pantone":"672-c",
    "hex":"#dfa0c9"
  },
  {
    "pantone":"673-c",
    "hex":"#d986ba"
  },
  {
    "pantone":"674-c",
    "hex":"#c6579a"
  },
  {
    "pantone":"675-c",
    "hex":"#ae2573"
  },
  {
    "pantone":"676-c",
    "hex":"#960051"
  },
  {
    "pantone":"677-c",
    "hex":"#e5cedb"
  },
  {
    "pantone":"678-c",
    "hex":"#e3c8d8"
  },
  {
    "pantone":"679-c",
    "hex":"#debed2"
  },
  {
    "pantone":"680-c",
    "hex":"#c996b6"
  },
  {
    "pantone":"681-c",
    "hex":"#b06c96"
  },
  {
    "pantone":"682-c",
    "hex":"#994878"
  },
  {
    "pantone":"683-c",
    "hex":"#7c2855"
  },
  {
    "pantone":"684-c",
    "hex":"#e4c6d4"
  },
  {
    "pantone":"685-c",
    "hex":"#dcb6c9"
  },
  {
    "pantone":"686-c",
    "hex":"#d0a1ba"
  },
  {
    "pantone":"687-c",
    "hex":"#be84a3"
  },
  {
    "pantone":"688-c",
    "hex":"#a76389"
  },
  {
    "pantone":"689-c",
    "hex":"#893b67"
  },
  {
    "pantone":"690-c",
    "hex":"#612141"
  },
  {
    "pantone":"510-c",
    "hex":"#ebbecb"
  },
  {
    "pantone":"509-c",
    "hex":"#e8b3c3"
  },
  {
    "pantone":"508-c",
    "hex":"#e4a9bb"
  },
  {
    "pantone":"507-c",
    "hex":"#d592aa"
  },
  {
    "pantone":"506-c",
    "hex":"#84344e"
  },
  {
    "pantone":"505-c",
    "hex":"#6f2c3f"
  },
  {
    "pantone":"504-c",
    "hex":"#572932"
  },
  {
    "pantone":"7429-c",
    "hex":"#e2bccb"
  },
  {
    "pantone":"7430-c",
    "hex":"#dca9bf"
  },
  {
    "pantone":"7431-c",
    "hex":"#c9809e"
  },
  {
    "pantone":"7432-c",
    "hex":"#b55c80"
  },
  {
    "pantone":"7433-c",
    "hex":"#a73a64"
  },
  {
    "pantone":"7434-c",
    "hex":"#9b3259"
  },
  {
    "pantone":"7435-c",
    "hex":"#872651"
  },
  {
    "pantone":"691-c",
    "hex":"#e9cdd0"
  },
  {
    "pantone":"692-c",
    "hex":"#e4bec3"
  },
  {
    "pantone":"693-c",
    "hex":"#d7a3ab"
  },
  {
    "pantone":"694-c",
    "hex":"#c48490"
  },
  {
    "pantone":"695-c",
    "hex":"#b46b7a"
  },
  {
    "pantone":"696-c",
    "hex":"#984856"
  },
  {
    "pantone":"697-c",
    "hex":"#893c47"
  },
  {
    "pantone":"496-c",
    "hex":"#f2c6cf"
  },
  {
    "pantone":"495-c",
    "hex":"#f1bdc8"
  },
  {
    "pantone":"494-c",
    "hex":"#e9a2b2"
  },
  {
    "pantone":"493-c",
    "hex":"#dc8699"
  },
  {
    "pantone":"492-c",
    "hex":"#8f3237"
  },
  {
    "pantone":"491-c",
    "hex":"#7f3035"
  },
  {
    "pantone":"490-c",
    "hex":"#5d2a2c"
  },
  {
    "pantone":"503-c",
    "hex":"#e9c4c7"
  },
  {
    "pantone":"502-c",
    "hex":"#e5bac1"
  },
  {
    "pantone":"501-c",
    "hex":"#daa5ad"
  },
  {
    "pantone":"500-c",
    "hex":"#c6858f"
  },
  {
    "pantone":"499-c",
    "hex":"#7a3e3a"
  },
  {
    "pantone":"498-c",
    "hex":"#6a3735"
  },
  {
    "pantone":"497-c",
    "hex":"#512f2e"
  },
  {
    "pantone":"5035-c",
    "hex":"#dfc2c3"
  },
  {
    "pantone":"5025-c",
    "hex":"#dbb7bb"
  },
  {
    "pantone":"5015-c",
    "hex":"#cca1a6"
  },
  {
    "pantone":"5005-c",
    "hex":"#b07c83"
  },
  {
    "pantone":"4995-c",
    "hex":"#9c6169"
  },
  {
    "pantone":"4985-c",
    "hex":"#874b52"
  },
  {
    "pantone":"4975-c",
    "hex":"#3f2021"
  },
  {
    "pantone":"236-c",
    "hex":"#f1a7dc"
  },
  {
    "pantone":"237-c",
    "hex":"#ec86d0"
  },
  {
    "pantone":"238-c",
    "hex":"#e45dbf"
  },
  {
    "pantone":"239-c",
    "hex":"#db3eb1"
  },
  {
    "pantone":"240-c",
    "hex":"#c5299b"
  },
  {
    "pantone":"241-c",
    "hex":"#af1685"
  },
  {
    "pantone":"242-c",
    "hex":"#80225f"
  },
  {
    "pantone":"2365-c",
    "hex":"#efbae1"
  },
  {
    "pantone":"2375-c",
    "hex":"#e277cd"
  },
  {
    "pantone":"2385-c",
    "hex":"#d539b5"
  },
  {
    "pantone":"2395-c",
    "hex":"#c800a1"
  },
  {
    "pantone":"2405-c",
    "hex":"#b0008e"
  },
  {
    "pantone":"2415-c",
    "hex":"#9e007e"
  },
  {
    "pantone":"2425-c",
    "hex":"#830065"
  },
  {
    "pantone":"243-c",
    "hex":"#eab8e4"
  },
  {
    "pantone":"244-c",
    "hex":"#e59bdc"
  },
  {
    "pantone":"245-c",
    "hex":"#dd7fd3"
  },
  {
    "pantone":"246-c",
    "hex":"#c724b1"
  },
  {
    "pantone":"247-c",
    "hex":"#bb16a3"
  },
  {
    "pantone":"248-c",
    "hex":"#a51890"
  },
  {
    "pantone":"249-c",
    "hex":"#80276c"
  },
  {
    "pantone":"7646-c",
    "hex":"#a56e87"
  },
  {
    "pantone":"7647-c",
    "hex":"#a83d72"
  },
  {
    "pantone":"7648-c",
    "hex":"#991e66"
  },
  {
    "pantone":"7649-c",
    "hex":"#8a1b61"
  },
  {
    "pantone":"7650-c",
    "hex":"#722257"
  },
  {
    "pantone":"7651-c",
    "hex":"#6a2a5b"
  },
  {
    "pantone":"7652-c",
    "hex":"#5e2751"
  },
  {
    "pantone":"250-c",
    "hex":"#e7bae4"
  },
  {
    "pantone":"251-c",
    "hex":"#dd9cdf"
  },
  {
    "pantone":"252-c",
    "hex":"#c964cf"
  },
  {
    "pantone":"253-c",
    "hex":"#ad1aac"
  },
  {
    "pantone":"254-c",
    "hex":"#981d97"
  },
  {
    "pantone":"255-c",
    "hex":"#72246c"
  },
  {
    "pantone":"517-c",
    "hex":"#ebc6df"
  },
  {
    "pantone":"516-c",
    "hex":"#e6bedd"
  },
  {
    "pantone":"515-c",
    "hex":"#e2acd7"
  },
  {
    "pantone":"514-c",
    "hex":"#d48bc8"
  },
  {
    "pantone":"513-c",
    "hex":"#93328e"
  },
  {
    "pantone":"512-c",
    "hex":"#833177"
  },
  {
    "pantone":"511-c",
    "hex":"#612c51"
  },
  {
    "pantone":"7436-c",
    "hex":"#eedaea"
  },
  {
    "pantone":"7437-c",
    "hex":"#ccaed0"
  },
  {
    "pantone":"7438-c",
    "hex":"#d59ed7"
  },
  {
    "pantone":"7439-c",
    "hex":"#b288b9"
  },
  {
    "pantone":"7440-c",
    "hex":"#a277a6"
  },
  {
    "pantone":"7441-c",
    "hex":"#9f5cc0"
  },
  {
    "pantone":"7442-c",
    "hex":"#963cbd"
  },
  {
    "pantone":"2562-c",
    "hex":"#d7a9e3"
  },
  {
    "pantone":"2572-c",
    "hex":"#c98bdb"
  },
  {
    "pantone":"2582-c",
    "hex":"#ac4fc6"
  },
  {
    "pantone":"2592-c",
    "hex":"#9b26b6"
  },
  {
    "pantone":"2602-c",
    "hex":"#87189d"
  },
  {
    "pantone":"2612-c",
    "hex":"#772583"
  },
  {
    "pantone":"2622-c",
    "hex":"#653165"
  },
  {
    "pantone":"7653-c",
    "hex":"#948794"
  },
  {
    "pantone":"7654-c",
    "hex":"#a2789c"
  },
  {
    "pantone":"7655-c",
    "hex":"#a15a95"
  },
  {
    "pantone":"7656-c",
    "hex":"#8e3a80"
  },
  {
    "pantone":"7657-c",
    "hex":"#6e2b62"
  },
  {
    "pantone":"7658-c",
    "hex":"#6a3460"
  },
  {
    "pantone":"7659-c",
    "hex":"#5d3754"
  },
  {
    "pantone":"524-c",
    "hex":"#d5c2d8"
  },
  {
    "pantone":"523-c",
    "hex":"#c9b1d0"
  },
  {
    "pantone":"522-c",
    "hex":"#ba9cc5"
  },
  {
    "pantone":"521-c",
    "hex":"#a57fb2"
  },
  {
    "pantone":"520-c",
    "hex":"#642f6c"
  },
  {
    "pantone":"519-c",
    "hex":"#59315f"
  },
  {
    "pantone":"518-c",
    "hex":"#4b3048"
  },
  {
    "pantone":"5245-c",
    "hex":"#dbcdd3"
  },
  {
    "pantone":"5235-c",
    "hex":"#d0bec7"
  },
  {
    "pantone":"5225-c",
    "hex":"#c6b0bc"
  },
  {
    "pantone":"5215-c",
    "hex":"#af95a6"
  },
  {
    "pantone":"5205-c",
    "hex":"#86647a"
  },
  {
    "pantone":"5195-c",
    "hex":"#66435a"
  },
  {
    "pantone":"5185-c",
    "hex":"#4a3041"
  },
  {
    "pantone":"5175-c",
    "hex":"#d8c8d1"
  },
  {
    "pantone":"5165-c",
    "hex":"#d3c0cd"
  },
  {
    "pantone":"5155-c",
    "hex":"#bfa5b8"
  },
  {
    "pantone":"5145-c",
    "hex":"#9b7793"
  },
  {
    "pantone":"5135-c",
    "hex":"#7e5475"
  },
  {
    "pantone":"5125-c",
    "hex":"#693c5e"
  },
  {
    "pantone":"5115-c",
    "hex":"#512a44"
  },
  {
    "pantone":"531-c",
    "hex":"#dfc8e7"
  },
  {
    "pantone":"530-c",
    "hex":"#d7b9e4"
  },
  {
    "pantone":"529-c",
    "hex":"#caa2dd"
  },
  {
    "pantone":"528-c",
    "hex":"#b580d1"
  },
  {
    "pantone":"527-c",
    "hex":"#8031a7"
  },
  {
    "pantone":"526-c",
    "hex":"#702f8a"
  },
  {
    "pantone":"525-c",
    "hex":"#572c5f"
  },
  {
    "pantone":"256-c",
    "hex":"#d6bfdd"
  },
  {
    "pantone":"257-c",
    "hex":"#c6a1cf"
  },
  {
    "pantone":"258-c",
    "hex":"#8c4799"
  },
  {
    "pantone":"259-c",
    "hex":"#6d2077"
  },
  {
    "pantone":"260-c",
    "hex":"#642667"
  },
  {
    "pantone":"261-c",
    "hex":"#5d285f"
  },
  {
    "pantone":"262-c",
    "hex":"#51284f"
  },
  {
    "pantone":"2563-c",
    "hex":"#cba3d8"
  },
  {
    "pantone":"2573-c",
    "hex":"#b884cb"
  },
  {
    "pantone":"2583-c",
    "hex":"#a05eb5"
  },
  {
    "pantone":"2593-c",
    "hex":"#84329b"
  },
  {
    "pantone":"2603-c",
    "hex":"#702082"
  },
  {
    "pantone":"2613-c",
    "hex":"#671e75"
  },
  {
    "pantone":"2623-c",
    "hex":"#5f2167"
  },
  {
    "pantone":"7660-c",
    "hex":"#9991a4"
  },
  {
    "pantone":"7661-c",
    "hex":"#8d6e97"
  },
  {
    "pantone":"7662-c",
    "hex":"#7a4183"
  },
  {
    "pantone":"7663-c",
    "hex":"#6b3077"
  },
  {
    "pantone":"7664-c",
    "hex":"#653279"
  },
  {
    "pantone":"7665-c",
    "hex":"#5e366e"
  },
  {
    "pantone":"7666-c",
    "hex":"#5c4e63"
  },
  {
    "pantone":"2567-c",
    "hex":"#c1a0da"
  },
  {
    "pantone":"2577-c",
    "hex":"#a77bca"
  },
  {
    "pantone":"2587-c",
    "hex":"#8246af"
  },
  {
    "pantone":"2597-c",
    "hex":"#5c068c"
  },
  {
    "pantone":"2607-c",
    "hex":"#500778"
  },
  {
    "pantone":"2617-c",
    "hex":"#470a68"
  },
  {
    "pantone":"2627-c",
    "hex":"#3c1053"
  },
  {
    "pantone":"263-c",
    "hex":"#d7c6e6"
  },
  {
    "pantone":"264-c",
    "hex":"#c1a7e2"
  },
  {
    "pantone":"265-c",
    "hex":"#9063cd"
  },
  {
    "pantone":"266-c",
    "hex":"#753bbd"
  },
  {
    "pantone":"267-c",
    "hex":"#5f259f"
  },
  {
    "pantone":"268-c",
    "hex":"#582c83"
  },
  {
    "pantone":"269-c",
    "hex":"#512d6d"
  },
  {
    "pantone":"2635-c",
    "hex":"#c5b4e3"
  },
  {
    "pantone":"2645-c",
    "hex":"#ad96dc"
  },
  {
    "pantone":"2655-c",
    "hex":"#9678d3"
  },
  {
    "pantone":"2665-c",
    "hex":"#7d55c7"
  },
  {
    "pantone":"2685-c",
    "hex":"#330072"
  },
  {
    "pantone":"2695-c",
    "hex":"#2e1a47"
  },
  {
    "pantone":"270-c",
    "hex":"#b4b5df"
  },
  {
    "pantone":"271-c",
    "hex":"#9595d2"
  },
  {
    "pantone":"272-c",
    "hex":"#7474c1"
  },
  {
    "pantone":"273-c",
    "hex":"#24135f"
  },
  {
    "pantone":"274-c",
    "hex":"#211551"
  },
  {
    "pantone":"275-c",
    "hex":"#201747"
  },
  {
    "pantone":"276-c",
    "hex":"#221c35"
  },
  {
    "pantone":"2705-c",
    "hex":"#a7a4e0"
  },
  {
    "pantone":"2715-c",
    "hex":"#8b84d7"
  },
  {
    "pantone":"2725-c",
    "hex":"#685bc7"
  },
  {
    "pantone":"2735-c",
    "hex":"#2e008b"
  },
  {
    "pantone":"2745-c",
    "hex":"#280071"
  },
  {
    "pantone":"2755-c",
    "hex":"#250e62"
  },
  {
    "pantone":"2765-c",
    "hex":"#201547"
  },
  {
    "pantone":"7667-c",
    "hex":"#6e7ca0"
  },
  {
    "pantone":"7668-c",
    "hex":"#686e9f"
  },
  {
    "pantone":"7669-c",
    "hex":"#615e9b"
  },
  {
    "pantone":"7670-c",
    "hex":"#565294"
  },
  {
    "pantone":"7671-c",
    "hex":"#514689"
  },
  {
    "pantone":"7672-c",
    "hex":"#4c4184"
  },
  {
    "pantone":"7673-c",
    "hex":"#535486"
  },
  {
    "pantone":"7443-c",
    "hex":"#dddae8"
  },
  {
    "pantone":"7444-c",
    "hex":"#b6b8dc"
  },
  {
    "pantone":"7445-c",
    "hex":"#a7a2c3"
  },
  {
    "pantone":"7446-c",
    "hex":"#8986ca"
  },
  {
    "pantone":"7447-c",
    "hex":"#5d4777"
  },
  {
    "pantone":"7448-c",
    "hex":"#4b384c"
  },
  {
    "pantone":"7449-c",
    "hex":"#41273b"
  },
  {
    "pantone":"7674-c",
    "hex":"#878cb4"
  },
  {
    "pantone":"7675-c",
    "hex":"#7c7fab"
  },
  {
    "pantone":"7676-c",
    "hex":"#7566a0"
  },
  {
    "pantone":"7677-c",
    "hex":"#6f5091"
  },
  {
    "pantone":"7678-c",
    "hex":"#68478d"
  },
  {
    "pantone":"7679-c",
    "hex":"#563d82"
  },
  {
    "pantone":"7680-c",
    "hex":"#523178"
  },
  {
    "pantone":"663-c",
    "hex":"#e5e1e6"
  },
  {
    "pantone":"664-c",
    "hex":"#e0dbe3"
  },
  {
    "pantone":"665-c",
    "hex":"#c6bcd0"
  },
  {
    "pantone":"666-c",
    "hex":"#a192b2"
  },
  {
    "pantone":"667-c",
    "hex":"#7c6992"
  },
  {
    "pantone":"668-c",
    "hex":"#614b79"
  },
  {
    "pantone":"669-c",
    "hex":"#3f2a56"
  },
  {
    "pantone":"5315-c",
    "hex":"#d8d7df"
  },
  {
    "pantone":"5305-c",
    "hex":"#c6c4d2"
  },
  {
    "pantone":"5295-c",
    "hex":"#b3b0c4"
  },
  {
    "pantone":"5285-c",
    "hex":"#8d89a5"
  },
  {
    "pantone":"5275-c",
    "hex":"#595478"
  },
  {
    "pantone":"5265-c",
    "hex":"#403a60"
  },
  {
    "pantone":"5255-c",
    "hex":"#1e1a34"
  },
  {
    "pantone":"538-c",
    "hex":"#c5cfda"
  },
  {
    "pantone":"537-c",
    "hex":"#bbc7d6"
  },
  {
    "pantone":"536-c",
    "hex":"#a2b2c8"
  },
  {
    "pantone":"535-c",
    "hex":"#8e9fbc"
  },
  {
    "pantone":"534-c",
    "hex":"#1b365d"
  },
  {
    "pantone":"533-c",
    "hex":"#1f2a44"
  },
  {
    "pantone":"532-c",
    "hex":"#1c1f2a"
  },
  {
    "pantone":"7541-c",
    "hex":"#d9e1e2"
  },
  {
    "pantone":"7542-c",
    "hex":"#a4bcc2"
  },
  {
    "pantone":"7543-c",
    "hex":"#98a4ae"
  },
  {
    "pantone":"7544-c",
    "hex":"#768692"
  },
  {
    "pantone":"7545-c",
    "hex":"#425563"
  },
  {
    "pantone":"7546-c",
    "hex":"#253746"
  },
  {
    "pantone":"7547-c",
    "hex":"#131e29"
  },
  {
    "pantone":"552-c",
    "hex":"#b9d3dc"
  },
  {
    "pantone":"551-c",
    "hex":"#a3c7d2"
  },
  {
    "pantone":"550-c",
    "hex":"#8db9ca"
  },
  {
    "pantone":"549-c",
    "hex":"#6ba4b8"
  },
  {
    "pantone":"548-c",
    "hex":"#003d4c"
  },
  {
    "pantone":"547-c",
    "hex":"#00313c"
  },
  {
    "pantone":"546-c",
    "hex":"#072b31"
  },
  {
    "pantone":"5455-c",
    "hex":"#bfced6"
  },
  {
    "pantone":"5445-c",
    "hex":"#b7c9d3"
  },
  {
    "pantone":"5435-c",
    "hex":"#a6bbc8"
  },
  {
    "pantone":"5425-c",
    "hex":"#7a99ac"
  },
  {
    "pantone":"5415-c",
    "hex":"#5b7f95"
  },
  {
    "pantone":"5405-c",
    "hex":"#4f758b"
  },
  {
    "pantone":"5395-c",
    "hex":"#081f2c"
  },
  {
    "pantone":"642-c",
    "hex":"#d1dde6"
  },
  {
    "pantone":"643-c",
    "hex":"#c6d6e3"
  },
  {
    "pantone":"644-c",
    "hex":"#9bb8d3"
  },
  {
    "pantone":"645-c",
    "hex":"#7da1c4"
  },
  {
    "pantone":"646-c",
    "hex":"#5e8ab4"
  },
  {
    "pantone":"647-c",
    "hex":"#236192"
  },
  {
    "pantone":"648-c",
    "hex":"#002e5d"
  },
  {
    "pantone":"649-c",
    "hex":"#dbe2e9"
  },
  {
    "pantone":"650-c",
    "hex":"#ced9e5"
  },
  {
    "pantone":"651-c",
    "hex":"#a7bcd6"
  },
  {
    "pantone":"652-c",
    "hex":"#7d9bc1"
  },
  {
    "pantone":"653-c",
    "hex":"#326295"
  },
  {
    "pantone":"654-c",
    "hex":"#003a70"
  },
  {
    "pantone":"655-c",
    "hex":"#002554"
  },
  {
    "pantone":"656-c",
    "hex":"#dde5ed"
  },
  {
    "pantone":"657-c",
    "hex":"#c8d8eb"
  },
  {
    "pantone":"658-c",
    "hex":"#b1c9e8"
  },
  {
    "pantone":"659-c",
    "hex":"#7ba4db"
  },
  {
    "pantone":"660-c",
    "hex":"#407ec9"
  },
  {
    "pantone":"661-c",
    "hex":"#003594"
  },
  {
    "pantone":"662-c",
    "hex":"#001a70"
  },
  {
    "pantone":"7450-c",
    "hex":"#bdc5db"
  },
  {
    "pantone":"7451-c",
    "hex":"#89abe3"
  },
  {
    "pantone":"7452-c",
    "hex":"#8094dd"
  },
  {
    "pantone":"7453-c",
    "hex":"#7ba6de"
  },
  {
    "pantone":"7454-c",
    "hex":"#5f8fb4"
  },
  {
    "pantone":"7455-c",
    "hex":"#3a5dae"
  },
  {
    "pantone":"7456-c",
    "hex":"#606eb2"
  },
  {
    "pantone":"2706-c",
    "hex":"#cbd3eb"
  },
  {
    "pantone":"2716-c",
    "hex":"#9faee5"
  },
  {
    "pantone":"2726-c",
    "hex":"#485cc7"
  },
  {
    "pantone":"2736-c",
    "hex":"#1e22aa"
  },
  {
    "pantone":"2746-c",
    "hex":"#171c8f"
  },
  {
    "pantone":"2756-c",
    "hex":"#151f6d"
  },
  {
    "pantone":"2766-c",
    "hex":"#141b4d"
  },
  {
    "pantone":"2708-c",
    "hex":"#b8ccea"
  },
  {
    "pantone":"2718-c",
    "hex":"#5c88da"
  },
  {
    "pantone":"2728-c",
    "hex":"#0047bb"
  },
  {
    "pantone":"2738-c",
    "hex":"#06038d"
  },
  {
    "pantone":"2748-c",
    "hex":"#001871"
  },
  {
    "pantone":"2758-c",
    "hex":"#001e62"
  },
  {
    "pantone":"2768-c",
    "hex":"#071d49"
  },
  {
    "pantone":"2707-c",
    "hex":"#c3d7ee"
  },
  {
    "pantone":"2717-c",
    "hex":"#a7c6ed"
  },
  {
    "pantone":"2727-c",
    "hex":"#307fe2"
  },
  {
    "pantone":"2747-c",
    "hex":"#001a72"
  },
  {
    "pantone":"2757-c",
    "hex":"#001e60"
  },
  {
    "pantone":"2767-c",
    "hex":"#13294b"
  },
  {
    "pantone":"277-c",
    "hex":"#abcae9"
  },
  {
    "pantone":"278-c",
    "hex":"#8bb8e8"
  },
  {
    "pantone":"279-c",
    "hex":"#418fde"
  },
  {
    "pantone":"280-c",
    "hex":"#012169"
  },
  {
    "pantone":"281-c",
    "hex":"#00205b"
  },
  {
    "pantone":"282-c",
    "hex":"#041e42"
  },
  {
    "pantone":"283-c",
    "hex":"#92c1e9"
  },
  {
    "pantone":"284-c",
    "hex":"#6cace4"
  },
  {
    "pantone":"285-c",
    "hex":"#0072ce"
  },
  {
    "pantone":"286-c",
    "hex":"#0033a0"
  },
  {
    "pantone":"287-c",
    "hex":"#003087"
  },
  {
    "pantone":"288-c",
    "hex":"#002d72"
  },
  {
    "pantone":"289-c",
    "hex":"#0c2340"
  },
  {
    "pantone":"7681-c",
    "hex":"#94a9cb"
  },
  {
    "pantone":"7682-c",
    "hex":"#6787b7"
  },
  {
    "pantone":"7683-c",
    "hex":"#426da9"
  },
  {
    "pantone":"7684-c",
    "hex":"#385e9d"
  },
  {
    "pantone":"7685-c",
    "hex":"#2c5697"
  },
  {
    "pantone":"7686-c",
    "hex":"#1d4f91"
  },
  {
    "pantone":"7687-c",
    "hex":"#1d428a"
  },
  {
    "pantone":"545-c",
    "hex":"#c6dae7"
  },
  {
    "pantone":"544-c",
    "hex":"#bdd6e6"
  },
  {
    "pantone":"543-c",
    "hex":"#a4c8e1"
  },
  {
    "pantone":"542-c",
    "hex":"#7bafd4"
  },
  {
    "pantone":"541-c",
    "hex":"#003c71"
  },
  {
    "pantone":"540-c",
    "hex":"#003057"
  },
  {
    "pantone":"539-c",
    "hex":"#00263a"
  },
  {
    "pantone":"290-c",
    "hex":"#b9d9eb"
  },
  {
    "pantone":"291-c",
    "hex":"#9bcbeb"
  },
  {
    "pantone":"292-c",
    "hex":"#69b3e7"
  },
  {
    "pantone":"293-c",
    "hex":"#003da5"
  },
  {
    "pantone":"294-c",
    "hex":"#002f6c"
  },
  {
    "pantone":"295-c",
    "hex":"#002855"
  },
  {
    "pantone":"296-c",
    "hex":"#041c2c"
  },
  {
    "pantone":"2905-c",
    "hex":"#8dc8e8"
  },
  {
    "pantone":"2915-c",
    "hex":"#62b5e5"
  },
  {
    "pantone":"2925-c",
    "hex":"#009cde"
  },
  {
    "pantone":"2935-c",
    "hex":"#0057b8"
  },
  {
    "pantone":"2945-c",
    "hex":"#004c97"
  },
  {
    "pantone":"2955-c",
    "hex":"#003865"
  },
  {
    "pantone":"2965-c",
    "hex":"#00263e"
  },
  {
    "pantone":"297-c",
    "hex":"#71c5e8"
  },
  {
    "pantone":"298-c",
    "hex":"#41b6e6"
  },
  {
    "pantone":"299-c",
    "hex":"#00a3e0"
  },
  {
    "pantone":"300-c",
    "hex":"#005eb8"
  },
  {
    "pantone":"301-c",
    "hex":"#004b87"
  },
  {
    "pantone":"302-c",
    "hex":"#003b5c"
  },
  {
    "pantone":"303-c",
    "hex":"#002a3a"
  },
  {
    "pantone":"7688-c",
    "hex":"#4698cb"
  },
  {
    "pantone":"7689-c",
    "hex":"#298fc2"
  },
  {
    "pantone":"7690-c",
    "hex":"#0076a8"
  },
  {
    "pantone":"7691-c",
    "hex":"#006298"
  },
  {
    "pantone":"7692-c",
    "hex":"#005587"
  },
  {
    "pantone":"7693-c",
    "hex":"#004976"
  },
  {
    "pantone":"7694-c",
    "hex":"#01426a"
  },
  {
    "pantone":"2975-c",
    "hex":"#99d6ea"
  },
  {
    "pantone":"2985-c",
    "hex":"#5bc2e7"
  },
  {
    "pantone":"2995-c",
    "hex":"#00a9e0"
  },
  {
    "pantone":"3005-c",
    "hex":"#0077c8"
  },
  {
    "pantone":"3015-c",
    "hex":"#00629b"
  },
  {
    "pantone":"3025-c",
    "hex":"#004f71"
  },
  {
    "pantone":"3035-c",
    "hex":"#003e51"
  },
  {
    "pantone":"7695-c",
    "hex":"#7ba7bc"
  },
  {
    "pantone":"7696-c",
    "hex":"#6399ae"
  },
  {
    "pantone":"7697-c",
    "hex":"#4e87a0"
  },
  {
    "pantone":"7698-c",
    "hex":"#41748d"
  },
  {
    "pantone":"7699-c",
    "hex":"#34657f"
  },
  {
    "pantone":"7700-c",
    "hex":"#165c7d"
  },
  {
    "pantone":"7701-c",
    "hex":"#005776"
  },
  {
    "pantone":"7457-c",
    "hex":"#bbdde6"
  },
  {
    "pantone":"7458-c",
    "hex":"#71b2c9"
  },
  {
    "pantone":"7459-c",
    "hex":"#4298b5"
  },
  {
    "pantone":"7460-c",
    "hex":"#0086bf"
  },
  {
    "pantone":"7461-c",
    "hex":"#007dba"
  },
  {
    "pantone":"7462-c",
    "hex":"#00558c"
  },
  {
    "pantone":"7463-c",
    "hex":"#002b49"
  },
  {
    "pantone":"304-c",
    "hex":"#9adbe8"
  },
  {
    "pantone":"305-c",
    "hex":"#59cbe8"
  },
  {
    "pantone":"306-c",
    "hex":"#00b5e2"
  },
  {
    "pantone":"307-c",
    "hex":"#006ba6"
  },
  {
    "pantone":"308-c",
    "hex":"#00587c"
  },
  {
    "pantone":"309-c",
    "hex":"#003b49"
  },
  {
    "pantone":"635-c",
    "hex":"#a4dbe8"
  },
  {
    "pantone":"636-c",
    "hex":"#8bd3e6"
  },
  {
    "pantone":"637-c",
    "hex":"#4ec3e0"
  },
  {
    "pantone":"638-c",
    "hex":"#00afd7"
  },
  {
    "pantone":"639-c",
    "hex":"#0095c8"
  },
  {
    "pantone":"640-c",
    "hex":"#0082ba"
  },
  {
    "pantone":"641-c",
    "hex":"#0067a0"
  },
  {
    "pantone":"7702-c",
    "hex":"#48a9c5"
  },
  {
    "pantone":"7703-c",
    "hex":"#009cbd"
  },
  {
    "pantone":"7704-c",
    "hex":"#0085ad"
  },
  {
    "pantone":"7705-c",
    "hex":"#007096"
  },
  {
    "pantone":"7706-c",
    "hex":"#006a8e"
  },
  {
    "pantone":"7707-c",
    "hex":"#00617f"
  },
  {
    "pantone":"7708-c",
    "hex":"#005670"
  },
  {
    "pantone":"628-c",
    "hex":"#b8dde1"
  },
  {
    "pantone":"629-c",
    "hex":"#9bd3dd"
  },
  {
    "pantone":"630-c",
    "hex":"#77c5d5"
  },
  {
    "pantone":"631-c",
    "hex":"#3eb1c8"
  },
  {
    "pantone":"632-c",
    "hex":"#0093b2"
  },
  {
    "pantone":"633-c",
    "hex":"#007396"
  },
  {
    "pantone":"634-c",
    "hex":"#005f83"
  },
  {
    "pantone":"310-c",
    "hex":"#6ad1e3"
  },
  {
    "pantone":"311-c",
    "hex":"#05c3de"
  },
  {
    "pantone":"312-c",
    "hex":"#00a9ce"
  },
  {
    "pantone":"313-c",
    "hex":"#0092bc"
  },
  {
    "pantone":"314-c",
    "hex":"#007fa3"
  },
  {
    "pantone":"315-c",
    "hex":"#00677f"
  },
  {
    "pantone":"316-c",
    "hex":"#004851"
  },
  {
    "pantone":"3105-c",
    "hex":"#68d2df"
  },
  {
    "pantone":"3115-c",
    "hex":"#00c1d5"
  },
  {
    "pantone":"3125-c",
    "hex":"#00aec7"
  },
  {
    "pantone":"3135-c",
    "hex":"#008eaa"
  },
  {
    "pantone":"3145-c",
    "hex":"#00778b"
  },
  {
    "pantone":"3155-c",
    "hex":"#006272"
  },
  {
    "pantone":"3165-c",
    "hex":"#004f59"
  },
  {
    "pantone":"7709-c",
    "hex":"#63b1bc"
  },
  {
    "pantone":"7710-c",
    "hex":"#00a7b5"
  },
  {
    "pantone":"7711-c",
    "hex":"#0097a9"
  },
  {
    "pantone":"7712-c",
    "hex":"#00859b"
  },
  {
    "pantone":"7713-c",
    "hex":"#007d8a"
  },
  {
    "pantone":"7714-c",
    "hex":"#007680"
  },
  {
    "pantone":"7715-c",
    "hex":"#006269"
  },
  {
    "pantone":"317-c",
    "hex":"#b1e4e3"
  },
  {
    "pantone":"318-c",
    "hex":"#88dbdf"
  },
  {
    "pantone":"319-c",
    "hex":"#2dccd3"
  },
  {
    "pantone":"320-c",
    "hex":"#009ca6"
  },
  {
    "pantone":"321-c",
    "hex":"#008c95"
  },
  {
    "pantone":"322-c",
    "hex":"#007377"
  },
  {
    "pantone":"323-c",
    "hex":"#005f61"
  },
  {
    "pantone":"7464-c",
    "hex":"#a0d1ca"
  },
  {
    "pantone":"7465-c",
    "hex":"#40c1ac"
  },
  {
    "pantone":"7466-c",
    "hex":"#00b0b9"
  },
  {
    "pantone":"7467-c",
    "hex":"#00a3ad"
  },
  {
    "pantone":"7468-c",
    "hex":"#007398"
  },
  {
    "pantone":"7469-c",
    "hex":"#005f86"
  },
  {
    "pantone":"7470-c",
    "hex":"#005a70"
  },
  {
    "pantone":"7471-c",
    "hex":"#7eddd3"
  },
  {
    "pantone":"7472-c",
    "hex":"#5cb8b2"
  },
  {
    "pantone":"7473-c",
    "hex":"#279989"
  },
  {
    "pantone":"7474-c",
    "hex":"#007681"
  },
  {
    "pantone":"7475-c",
    "hex":"#487a7b"
  },
  {
    "pantone":"7476-c",
    "hex":"#0d5257"
  },
  {
    "pantone":"7477-c",
    "hex":"#244c5a"
  },
  {
    "pantone":"5523-c",
    "hex":"#b6cfd0"
  },
  {
    "pantone":"5513-c",
    "hex":"#abc7ca"
  },
  {
    "pantone":"5503-c",
    "hex":"#94b7bb"
  },
  {
    "pantone":"5493-c",
    "hex":"#7fa9ae"
  },
  {
    "pantone":"5483-c",
    "hex":"#4f868e"
  },
  {
    "pantone":"5473-c",
    "hex":"#115e67"
  },
  {
    "pantone":"5463-c",
    "hex":"#07272d"
  },
  {
    "pantone":"7716-c",
    "hex":"#00968f"
  },
  {
    "pantone":"7717-c",
    "hex":"#00857d"
  },
  {
    "pantone":"7718-c",
    "hex":"#007672"
  },
  {
    "pantone":"7719-c",
    "hex":"#006d68"
  },
  {
    "pantone":"7720-c",
    "hex":"#00635b"
  },
  {
    "pantone":"7721-c",
    "hex":"#005e5d"
  },
  {
    "pantone":"7722-c",
    "hex":"#005151"
  },
  {
    "pantone":"324-c",
    "hex":"#9cdbd9"
  },
  {
    "pantone":"325-c",
    "hex":"#64ccc9"
  },
  {
    "pantone":"326-c",
    "hex":"#00b2a9"
  },
  {
    "pantone":"327-c",
    "hex":"#008675"
  },
  {
    "pantone":"328-c",
    "hex":"#007367"
  },
  {
    "pantone":"329-c",
    "hex":"#00685e"
  },
  {
    "pantone":"330-c",
    "hex":"#00534c"
  },
  {
    "pantone":"3242-c",
    "hex":"#71dbd4"
  },
  {
    "pantone":"3252-c",
    "hex":"#2ad2c9"
  },
  {
    "pantone":"3262-c",
    "hex":"#00bfb3"
  },
  {
    "pantone":"3272-c",
    "hex":"#00a499"
  },
  {
    "pantone":"3282-c",
    "hex":"#008578"
  },
  {
    "pantone":"3292-c",
    "hex":"#00594f"
  },
  {
    "pantone":"3302-c",
    "hex":"#004c45"
  },
  {
    "pantone":"3245-c",
    "hex":"#7ce0d3"
  },
  {
    "pantone":"3255-c",
    "hex":"#2cd5c4"
  },
  {
    "pantone":"3265-c",
    "hex":"#00c7b1"
  },
  {
    "pantone":"3275-c",
    "hex":"#00b398"
  },
  {
    "pantone":"3285-c",
    "hex":"#009681"
  },
  {
    "pantone":"3295-c",
    "hex":"#007864"
  },
  {
    "pantone":"3305-c",
    "hex":"#004e42"
  },
  {
    "pantone":"3248-c",
    "hex":"#6dcdb8"
  },
  {
    "pantone":"3258-c",
    "hex":"#49c5b1"
  },
  {
    "pantone":"3268-c",
    "hex":"#00ab8e"
  },
  {
    "pantone":"3278-c",
    "hex":"#009b77"
  },
  {
    "pantone":"3288-c",
    "hex":"#008264"
  },
  {
    "pantone":"3298-c",
    "hex":"#006a52"
  },
  {
    "pantone":"3308-c",
    "hex":"#034638"
  },
  {
    "pantone":"566-c",
    "hex":"#b9dcd2"
  },
  {
    "pantone":"565-c",
    "hex":"#a1d6ca"
  },
  {
    "pantone":"564-c",
    "hex":"#86c8bc"
  },
  {
    "pantone":"563-c",
    "hex":"#6bbbae"
  },
  {
    "pantone":"562-c",
    "hex":"#006f62"
  },
  {
    "pantone":"561-c",
    "hex":"#00594c"
  },
  {
    "pantone":"560-c",
    "hex":"#1d3c34"
  },
  {
    "pantone":"573-c",
    "hex":"#b5e3d8"
  },
  {
    "pantone":"572-c",
    "hex":"#a5dfd3"
  },
  {
    "pantone":"571-c",
    "hex":"#98dbce"
  },
  {
    "pantone":"570-c",
    "hex":"#6bcaba"
  },
  {
    "pantone":"569-c",
    "hex":"#00816d"
  },
  {
    "pantone":"568-c",
    "hex":"#006c5b"
  },
  {
    "pantone":"567-c",
    "hex":"#173f35"
  },
  {
    "pantone":"559-c",
    "hex":"#adcab8"
  },
  {
    "pantone":"558-c",
    "hex":"#9abeaa"
  },
  {
    "pantone":"557-c",
    "hex":"#85b09a"
  },
  {
    "pantone":"556-c",
    "hex":"#6fa287"
  },
  {
    "pantone":"555-c",
    "hex":"#28724f"
  },
  {
    "pantone":"554-c",
    "hex":"#205c40"
  },
  {
    "pantone":"553-c",
    "hex":"#284734"
  },
  {
    "pantone":"5595-c",
    "hex":"#bfcec2"
  },
  {
    "pantone":"5585-c",
    "hex":"#a7bdb1"
  },
  {
    "pantone":"5575-c",
    "hex":"#92aca0"
  },
  {
    "pantone":"5565-c",
    "hex":"#7f9c90"
  },
  {
    "pantone":"5555-c",
    "hex":"#5c7f71"
  },
  {
    "pantone":"5545-c",
    "hex":"#43695b"
  },
  {
    "pantone":"5535-c",
    "hex":"#183028"
  },
  {
    "pantone":"5665-c",
    "hex":"#bac5b9"
  },
  {
    "pantone":"5655-c",
    "hex":"#b0bdb0"
  },
  {
    "pantone":"5645-c",
    "hex":"#a3b2a4"
  },
  {
    "pantone":"5635-c",
    "hex":"#94a596"
  },
  {
    "pantone":"5625-c",
    "hex":"#708573"
  },
  {
    "pantone":"5615-c",
    "hex":"#5e7461"
  },
  {
    "pantone":"5605-c",
    "hex":"#22372b"
  },
  {
    "pantone":"5527-c",
    "hex":"#bcc9c5"
  },
  {
    "pantone":"5517-c",
    "hex":"#b1c0bc"
  },
  {
    "pantone":"5507-c",
    "hex":"#9db0ac"
  },
  {
    "pantone":"5497-c",
    "hex":"#829995"
  },
  {
    "pantone":"5487-c",
    "hex":"#5d7975"
  },
  {
    "pantone":"5477-c",
    "hex":"#3e5d58"
  },
  {
    "pantone":"5467-c",
    "hex":"#18332f"
  },
  {
    "pantone":"621-c",
    "hex":"#d1e0d7"
  },
  {
    "pantone":"622-c",
    "hex":"#b7cdc2"
  },
  {
    "pantone":"623-c",
    "hex":"#9ab9ad"
  },
  {
    "pantone":"624-c",
    "hex":"#789f90"
  },
  {
    "pantone":"625-c",
    "hex":"#507f70"
  },
  {
    "pantone":"626-c",
    "hex":"#285c4d"
  },
  {
    "pantone":"627-c",
    "hex":"#13322b"
  },
  {
    "pantone":"331-c",
    "hex":"#a7e6d7"
  },
  {
    "pantone":"332-c",
    "hex":"#8ce2d0"
  },
  {
    "pantone":"333-c",
    "hex":"#3cdbc0"
  },
  {
    "pantone":"334-c",
    "hex":"#009775"
  },
  {
    "pantone":"335-c",
    "hex":"#007b5f"
  },
  {
    "pantone":"336-c",
    "hex":"#00664f"
  },
  {
    "pantone":"337-c",
    "hex":"#8fd6bd"
  },
  {
    "pantone":"338-c",
    "hex":"#6eceb2"
  },
  {
    "pantone":"339-c",
    "hex":"#00b388"
  },
  {
    "pantone":"340-c",
    "hex":"#00965e"
  },
  {
    "pantone":"341-c",
    "hex":"#007a53"
  },
  {
    "pantone":"342-c",
    "hex":"#006747"
  },
  {
    "pantone":"343-c",
    "hex":"#115740"
  },
  {
    "pantone":"7723-c",
    "hex":"#50a684"
  },
  {
    "pantone":"7724-c",
    "hex":"#00966c"
  },
  {
    "pantone":"7725-c",
    "hex":"#008755"
  },
  {
    "pantone":"7726-c",
    "hex":"#007b4b"
  },
  {
    "pantone":"7727-c",
    "hex":"#006f44"
  },
  {
    "pantone":"7728-c",
    "hex":"#006845"
  },
  {
    "pantone":"7729-c",
    "hex":"#005844"
  },
  {
    "pantone":"3375-c",
    "hex":"#7ae1bf"
  },
  {
    "pantone":"3385-c",
    "hex":"#47d7ac"
  },
  {
    "pantone":"3395-c",
    "hex":"#00c389"
  },
  {
    "pantone":"3405-c",
    "hex":"#00af66"
  },
  {
    "pantone":"3415-c",
    "hex":"#007749"
  },
  {
    "pantone":"3425-c",
    "hex":"#006341"
  },
  {
    "pantone":"3435-c",
    "hex":"#154734"
  },
  {
    "pantone":"344-c",
    "hex":"#a0dab3"
  },
  {
    "pantone":"345-c",
    "hex":"#91d6ac"
  },
  {
    "pantone":"346-c",
    "hex":"#71cc98"
  },
  {
    "pantone":"347-c",
    "hex":"#009a44"
  },
  {
    "pantone":"348-c",
    "hex":"#00843d"
  },
  {
    "pantone":"349-c",
    "hex":"#046a38"
  },
  {
    "pantone":"350-c",
    "hex":"#2c5234"
  },
  {
    "pantone":"351-c",
    "hex":"#a2e4b8"
  },
  {
    "pantone":"352-c",
    "hex":"#8fe2b0"
  },
  {
    "pantone":"353-c",
    "hex":"#80e0a7"
  },
  {
    "pantone":"354-c",
    "hex":"#00b140"
  },
  {
    "pantone":"355-c",
    "hex":"#009639"
  },
  {
    "pantone":"356-c",
    "hex":"#007a33"
  },
  {
    "pantone":"357-c",
    "hex":"#215732"
  },
  {
    "pantone":"7478-c",
    "hex":"#9be3bf"
  },
  {
    "pantone":"7479-c",
    "hex":"#26d07c"
  },
  {
    "pantone":"7480-c",
    "hex":"#00bf6f"
  },
  {
    "pantone":"7481-c",
    "hex":"#00b74f"
  },
  {
    "pantone":"7482-c",
    "hex":"#009f4d"
  },
  {
    "pantone":"7483-c",
    "hex":"#275d38"
  },
  {
    "pantone":"7484-c",
    "hex":"#00573f"
  },
  {
    "pantone":"7730-c",
    "hex":"#4b9560"
  },
  {
    "pantone":"7731-c",
    "hex":"#228848"
  },
  {
    "pantone":"7732-c",
    "hex":"#007a3e"
  },
  {
    "pantone":"7733-c",
    "hex":"#007041"
  },
  {
    "pantone":"7734-c",
    "hex":"#286140"
  },
  {
    "pantone":"7735-c",
    "hex":"#36573b"
  },
  {
    "pantone":"7736-c",
    "hex":"#395542"
  },
  {
    "pantone":"7737-c",
    "hex":"#6ba539"
  },
  {
    "pantone":"7738-c",
    "hex":"#48a23f"
  },
  {
    "pantone":"7739-c",
    "hex":"#319b42"
  },
  {
    "pantone":"7740-c",
    "hex":"#3a913f"
  },
  {
    "pantone":"7741-c",
    "hex":"#44883e"
  },
  {
    "pantone":"7742-c",
    "hex":"#4a773c"
  },
  {
    "pantone":"7743-c",
    "hex":"#44693d"
  },
  {
    "pantone":"358-c",
    "hex":"#addc91"
  },
  {
    "pantone":"359-c",
    "hex":"#a1d884"
  },
  {
    "pantone":"360-c",
    "hex":"#6cc24a"
  },
  {
    "pantone":"361-c",
    "hex":"#43b02a"
  },
  {
    "pantone":"362-c",
    "hex":"#509e2f"
  },
  {
    "pantone":"363-c",
    "hex":"#4c8c2b"
  },
  {
    "pantone":"364-c",
    "hex":"#4a7729"
  },
  {
    "pantone":"7485-c",
    "hex":"#d0debb"
  },
  {
    "pantone":"7486-c",
    "hex":"#bce194"
  },
  {
    "pantone":"7487-c",
    "hex":"#8edd65"
  },
  {
    "pantone":"7488-c",
    "hex":"#78d64b"
  },
  {
    "pantone":"7489-c",
    "hex":"#74aa50"
  },
  {
    "pantone":"7490-c",
    "hex":"#719949"
  },
  {
    "pantone":"7491-c",
    "hex":"#79863c"
  },
  {
    "pantone":"365-c",
    "hex":"#c2e189"
  },
  {
    "pantone":"366-c",
    "hex":"#b7dd79"
  },
  {
    "pantone":"367-c",
    "hex":"#a4d65e"
  },
  {
    "pantone":"368-c",
    "hex":"#78be20"
  },
  {
    "pantone":"369-c",
    "hex":"#64a70b"
  },
  {
    "pantone":"370-c",
    "hex":"#658d1b"
  },
  {
    "pantone":"371-c",
    "hex":"#546223"
  },
  {
    "pantone":"372-c",
    "hex":"#d4eb8e"
  },
  {
    "pantone":"373-c",
    "hex":"#cdea80"
  },
  {
    "pantone":"374-c",
    "hex":"#c5e86c"
  },
  {
    "pantone":"375-c",
    "hex":"#97d700"
  },
  {
    "pantone":"376-c",
    "hex":"#84bd00"
  },
  {
    "pantone":"377-c",
    "hex":"#7a9a01"
  },
  {
    "pantone":"378-c",
    "hex":"#59621d"
  },
  {
    "pantone":"580-c",
    "hex":"#c4d6a4"
  },
  {
    "pantone":"579-c",
    "hex":"#bcd19b"
  },
  {
    "pantone":"578-c",
    "hex":"#b7ce95"
  },
  {
    "pantone":"577-c",
    "hex":"#a9c47f"
  },
  {
    "pantone":"576-c",
    "hex":"#789d4a"
  },
  {
    "pantone":"575-c",
    "hex":"#67823a"
  },
  {
    "pantone":"574-c",
    "hex":"#4e5b31"
  },
  {
    "pantone":"5807-c",
    "hex":"#d0d1ab"
  },
  {
    "pantone":"5797-c",
    "hex":"#c6c89b"
  },
  {
    "pantone":"5787-c",
    "hex":"#babd8b"
  },
  {
    "pantone":"5777-c",
    "hex":"#a2a569"
  },
  {
    "pantone":"5767-c",
    "hex":"#8a8d4a"
  },
  {
    "pantone":"5757-c",
    "hex":"#6d712e"
  },
  {
    "pantone":"5747-c",
    "hex":"#3d441e"
  },
  {
    "pantone":"5875-c",
    "hex":"#d2ce9e"
  },
  {
    "pantone":"5865-c",
    "hex":"#cbc793"
  },
  {
    "pantone":"5855-c",
    "hex":"#c0bb87"
  },
  {
    "pantone":"5845-c",
    "hex":"#afa96e"
  },
  {
    "pantone":"5835-c",
    "hex":"#a09958"
  },
  {
    "pantone":"5825-c",
    "hex":"#89813d"
  },
  {
    "pantone":"5815-c",
    "hex":"#555025"
  },
  {
    "pantone":"5803-c",
    "hex":"#c3c6a8"
  },
  {
    "pantone":"5793-c",
    "hex":"#b3b995"
  },
  {
    "pantone":"5783-c",
    "hex":"#a3aa83"
  },
  {
    "pantone":"5773-c",
    "hex":"#899064"
  },
  {
    "pantone":"5763-c",
    "hex":"#737b4c"
  },
  {
    "pantone":"5753-c",
    "hex":"#5e6738"
  },
  {
    "pantone":"5743-c",
    "hex":"#3e4827"
  },
  {
    "pantone":"7492-c",
    "hex":"#bfcc80"
  },
  {
    "pantone":"7493-c",
    "hex":"#bbc592"
  },
  {
    "pantone":"7494-c",
    "hex":"#9caf88"
  },
  {
    "pantone":"7495-c",
    "hex":"#8f993e"
  },
  {
    "pantone":"7496-c",
    "hex":"#76881d"
  },
  {
    "pantone":"7497-c",
    "hex":"#7a7256"
  },
  {
    "pantone":"7498-c",
    "hex":"#5b6236"
  },
  {
    "pantone":"7744-c",
    "hex":"#babc16"
  },
  {
    "pantone":"7745-c",
    "hex":"#abad23"
  },
  {
    "pantone":"7746-c",
    "hex":"#999b30"
  },
  {
    "pantone":"7747-c",
    "hex":"#888d30"
  },
  {
    "pantone":"7748-c",
    "hex":"#7c8034"
  },
  {
    "pantone":"7749-c",
    "hex":"#727337"
  },
  {
    "pantone":"7750-c",
    "hex":"#656635"
  },
  {
    "pantone":"379-c",
    "hex":"#e2e868"
  },
  {
    "pantone":"380-c",
    "hex":"#dbe442"
  },
  {
    "pantone":"381-c",
    "hex":"#cedc00"
  },
  {
    "pantone":"382-c",
    "hex":"#c4d600"
  },
  {
    "pantone":"383-c",
    "hex":"#a8ad00"
  },
  {
    "pantone":"384-c",
    "hex":"#949300"
  },
  {
    "pantone":"385-c",
    "hex":"#787121"
  },
  {
    "pantone":"386-c",
    "hex":"#e9ec6b"
  },
  {
    "pantone":"387-c",
    "hex":"#e3e935"
  },
  {
    "pantone":"388-c",
    "hex":"#e0e721"
  },
  {
    "pantone":"389-c",
    "hex":"#d0df00"
  },
  {
    "pantone":"390-c",
    "hex":"#b5bd00"
  },
  {
    "pantone":"391-c",
    "hex":"#9a9500"
  },
  {
    "pantone":"392-c",
    "hex":"#827a04"
  },
  {
    "pantone":"587-c",
    "hex":"#e3e48d"
  },
  {
    "pantone":"586-c",
    "hex":"#e0e27c"
  },
  {
    "pantone":"585-c",
    "hex":"#dbde70"
  },
  {
    "pantone":"584-c",
    "hex":"#d2d755"
  },
  {
    "pantone":"583-c",
    "hex":"#b7bf10"
  },
  {
    "pantone":"582-c",
    "hex":"#8e8c13"
  },
  {
    "pantone":"581-c",
    "hex":"#625d20"
  },
  {
    "pantone":"393-c",
    "hex":"#f0ec74"
  },
  {
    "pantone":"394-c",
    "hex":"#ede939"
  },
  {
    "pantone":"395-c",
    "hex":"#ece81a"
  },
  {
    "pantone":"396-c",
    "hex":"#e1e000"
  },
  {
    "pantone":"397-c",
    "hex":"#bfb800"
  },
  {
    "pantone":"398-c",
    "hex":"#ada400"
  },
  {
    "pantone":"399-c",
    "hex":"#a09200"
  },
  {
    "pantone":"3935-c",
    "hex":"#f3ea5d"
  },
  {
    "pantone":"3945-c",
    "hex":"#f3e500"
  },
  {
    "pantone":"3955-c",
    "hex":"#efdf00"
  },
  {
    "pantone":"3965-c",
    "hex":"#eedc00"
  },
  {
    "pantone":"3975-c",
    "hex":"#bba600"
  },
  {
    "pantone":"3985-c",
    "hex":"#9a8700"
  },
  {
    "pantone":"3995-c",
    "hex":"#685c20"
  },
  {
    "pantone":"600-c",
    "hex":"#f1eb9c"
  },
  {
    "pantone":"601-c",
    "hex":"#f0e991"
  },
  {
    "pantone":"602-c",
    "hex":"#f0e87b"
  },
  {
    "pantone":"603-c",
    "hex":"#ede04b"
  },
  {
    "pantone":"604-c",
    "hex":"#eada24"
  },
  {
    "pantone":"605-c",
    "hex":"#e1cd00"
  },
  {
    "pantone":"606-c",
    "hex":"#cfb500"
  },
  {
    "pantone":"607-c",
    "hex":"#ebe49a"
  },
  {
    "pantone":"608-c",
    "hex":"#e9e186"
  },
  {
    "pantone":"609-c",
    "hex":"#e6de77"
  },
  {
    "pantone":"610-c",
    "hex":"#e1d555"
  },
  {
    "pantone":"611-c",
    "hex":"#d7c826"
  },
  {
    "pantone":"612-c",
    "hex":"#c4b000"
  },
  {
    "pantone":"613-c",
    "hex":"#b39b00"
  },
  {
    "pantone":"461-c",
    "hex":"#e9df97"
  },
  {
    "pantone":"460-c",
    "hex":"#e4d77e"
  },
  {
    "pantone":"459-c",
    "hex":"#decd63"
  },
  {
    "pantone":"458-c",
    "hex":"#d9c756"
  },
  {
    "pantone":"457-c",
    "hex":"#b89d18"
  },
  {
    "pantone":"456-c",
    "hex":"#a28e2a"
  },
  {
    "pantone":"455-c",
    "hex":"#695b24"
  },
  {
    "pantone":"614-c",
    "hex":"#dcd59a"
  },
  {
    "pantone":"615-c",
    "hex":"#d6cf8d"
  },
  {
    "pantone":"616-c",
    "hex":"#d0c883"
  },
  {
    "pantone":"617-c",
    "hex":"#c0b561"
  },
  {
    "pantone":"618-c",
    "hex":"#ac9f3c"
  },
  {
    "pantone":"619-c",
    "hex":"#9f912a"
  },
  {
    "pantone":"620-c",
    "hex":"#8a7b19"
  },
  {
    "pantone":"7751-c",
    "hex":"#cab64b"
  },
  {
    "pantone":"7752-c",
    "hex":"#cfb023"
  },
  {
    "pantone":"7753-c",
    "hex":"#c1a01e"
  },
  {
    "pantone":"7754-c",
    "hex":"#a08629"
  },
  {
    "pantone":"7755-c",
    "hex":"#897630"
  },
  {
    "pantone":"7756-c",
    "hex":"#736635"
  },
  {
    "pantone":"7757-c",
    "hex":"#675e33"
  },
  {
    "pantone":"7758-c",
    "hex":"#d4c304"
  },
  {
    "pantone":"7759-c",
    "hex":"#c4b200"
  },
  {
    "pantone":"7760-c",
    "hex":"#91852c"
  },
  {
    "pantone":"7761-c",
    "hex":"#747136"
  },
  {
    "pantone":"7762-c",
    "hex":"#5d6439"
  },
  {
    "pantone":"7763-c",
    "hex":"#585c3b"
  },
  {
    "pantone":"7764-c",
    "hex":"#535435"
  },
  {
    "pantone":"7765-c",
    "hex":"#bbb323"
  },
  {
    "pantone":"7766-c",
    "hex":"#b4a91f"
  },
  {
    "pantone":"7767-c",
    "hex":"#aa9d2e"
  },
  {
    "pantone":"7768-c",
    "hex":"#8f7e35"
  },
  {
    "pantone":"7769-c",
    "hex":"#716135"
  },
  {
    "pantone":"7770-c",
    "hex":"#635939"
  },
  {
    "pantone":"7771-c",
    "hex":"#4e4934"
  },
  {
    "pantone":"4545-c",
    "hex":"#d5cb9f"
  },
  {
    "pantone":"4535-c",
    "hex":"#cfc493"
  },
  {
    "pantone":"4525-c",
    "hex":"#c5b783"
  },
  {
    "pantone":"4515-c",
    "hex":"#b3a369"
  },
  {
    "pantone":"4505-c",
    "hex":"#998542"
  },
  {
    "pantone":"4495-c",
    "hex":"#8c7732"
  },
  {
    "pantone":"4485-c",
    "hex":"#614f25"
  },
  {
    "pantone":"454-c",
    "hex":"#cac7a7"
  },
  {
    "pantone":"453-c",
    "hex":"#bfbb98"
  },
  {
    "pantone":"452-c",
    "hex":"#b0aa7e"
  },
  {
    "pantone":"451-c",
    "hex":"#9b945f"
  },
  {
    "pantone":"450-c",
    "hex":"#594a25"
  },
  {
    "pantone":"449-c",
    "hex":"#524727"
  },
  {
    "pantone":"448-c",
    "hex":"#4a412a"
  },
  {
    "pantone":"7499-c",
    "hex":"#f1e6b2"
  },
  {
    "pantone":"7500-c",
    "hex":"#dfd1a7"
  },
  {
    "pantone":"7501-c",
    "hex":"#d9c89e"
  },
  {
    "pantone":"7502-c",
    "hex":"#ceb888"
  },
  {
    "pantone":"7503-c",
    "hex":"#a89968"
  },
  {
    "pantone":"7504-c",
    "hex":"#94795d"
  },
  {
    "pantone":"7505-c",
    "hex":"#816040"
  },
  {
    "pantone":"468-c",
    "hex":"#ddcba4"
  },
  {
    "pantone":"467-c",
    "hex":"#d3bc8d"
  },
  {
    "pantone":"466-c",
    "hex":"#c6aa76"
  },
  {
    "pantone":"465-c",
    "hex":"#b9975b"
  },
  {
    "pantone":"464-c",
    "hex":"#8b5b29"
  },
  {
    "pantone":"463-c",
    "hex":"#744f28"
  },
  {
    "pantone":"462-c",
    "hex":"#5c462b"
  },
  {
    "pantone":"7506-c",
    "hex":"#efdbb2"
  },
  {
    "pantone":"7507-c",
    "hex":"#fcd299"
  },
  {
    "pantone":"7508-c",
    "hex":"#e1b87f"
  },
  {
    "pantone":"7509-c",
    "hex":"#d6a461"
  },
  {
    "pantone":"7510-c",
    "hex":"#c6893f"
  },
  {
    "pantone":"7511-c",
    "hex":"#b77729"
  },
  {
    "pantone":"7512-c",
    "hex":"#a6631b"
  },
  {
    "pantone":"719-c",
    "hex":"#edc8a3"
  },
  {
    "pantone":"720-c",
    "hex":"#e7b78a"
  },
  {
    "pantone":"721-c",
    "hex":"#dda46f"
  },
  {
    "pantone":"722-c",
    "hex":"#c88242"
  },
  {
    "pantone":"723-c",
    "hex":"#b36924"
  },
  {
    "pantone":"724-c",
    "hex":"#934d11"
  },
  {
    "pantone":"725-c",
    "hex":"#7d3f16"
  },
  {
    "pantone":"475-c",
    "hex":"#f3cfb3"
  },
  {
    "pantone":"474-c",
    "hex":"#f1c6a7"
  },
  {
    "pantone":"473-c",
    "hex":"#f0bf9b"
  },
  {
    "pantone":"472-c",
    "hex":"#e59e6d"
  },
  {
    "pantone":"471-c",
    "hex":"#b86125"
  },
  {
    "pantone":"470-c",
    "hex":"#a45a2a"
  },
  {
    "pantone":"469-c",
    "hex":"#693f23"
  },
  {
    "pantone":"726-c",
    "hex":"#e0c09f"
  },
  {
    "pantone":"727-c",
    "hex":"#d9b48f"
  },
  {
    "pantone":"728-c",
    "hex":"#cda077"
  },
  {
    "pantone":"729-c",
    "hex":"#b58150"
  },
  {
    "pantone":"730-c",
    "hex":"#9e652e"
  },
  {
    "pantone":"731-c",
    "hex":"#774212"
  },
  {
    "pantone":"732-c",
    "hex":"#623412"
  },
  {
    "pantone":"4685-c",
    "hex":"#e0c6ad"
  },
  {
    "pantone":"4675-c",
    "hex":"#dcbfa6"
  },
  {
    "pantone":"4665-c",
    "hex":"#cda788"
  },
  {
    "pantone":"4655-c",
    "hex":"#bf9474"
  },
  {
    "pantone":"4645-c",
    "hex":"#ad7c59"
  },
  {
    "pantone":"4635-c",
    "hex":"#946037"
  },
  {
    "pantone":"4625-c",
    "hex":"#4f2c1d"
  },
  {
    "pantone":"7513-c",
    "hex":"#e1b7a7"
  },
  {
    "pantone":"7514-c",
    "hex":"#d5a286"
  },
  {
    "pantone":"7515-c",
    "hex":"#c58b68"
  },
  {
    "pantone":"7516-c",
    "hex":"#99552b"
  },
  {
    "pantone":"7517-c",
    "hex":"#85431e"
  },
  {
    "pantone":"7518-c",
    "hex":"#6d4f47"
  },
  {
    "pantone":"7519-c",
    "hex":"#5e4b3c"
  },
  {
    "pantone":"4755-c",
    "hex":"#d7c4b7"
  },
  {
    "pantone":"4745-c",
    "hex":"#cdb5a7"
  },
  {
    "pantone":"4735-c",
    "hex":"#c0a392"
  },
  {
    "pantone":"4725-c",
    "hex":"#ae8a79"
  },
  {
    "pantone":"4715-c",
    "hex":"#956c58"
  },
  {
    "pantone":"4705-c",
    "hex":"#7c4d3a"
  },
  {
    "pantone":"4695-c",
    "hex":"#5b3427"
  },
  {
    "pantone":"482-c",
    "hex":"#dbc8b6"
  },
  {
    "pantone":"481-c",
    "hex":"#d3bba8"
  },
  {
    "pantone":"480-c",
    "hex":"#c6a992"
  },
  {
    "pantone":"479-c",
    "hex":"#aa8066"
  },
  {
    "pantone":"478-c",
    "hex":"#703f2a"
  },
  {
    "pantone":"477-c",
    "hex":"#623b2a"
  },
  {
    "pantone":"476-c",
    "hex":"#4e3629"
  },
  {
    "pantone":"7527-c",
    "hex":"#d6d2c4"
  },
  {
    "pantone":"7528-c",
    "hex":"#c5b9ac"
  },
  {
    "pantone":"7529-c",
    "hex":"#b7a99a"
  },
  {
    "pantone":"7530-c",
    "hex":"#a39382"
  },
  {
    "pantone":"7531-c",
    "hex":"#7a6855"
  },
  {
    "pantone":"7532-c",
    "hex":"#63513d"
  },
  {
    "pantone":"7533-c",
    "hex":"#473729"
  },
  {
    "pantone":"7534-c",
    "hex":"#d1ccbd"
  },
  {
    "pantone":"7535-c",
    "hex":"#b7b09c"
  },
  {
    "pantone":"7536-c",
    "hex":"#a69f88"
  },
  {
    "pantone":"7537-c",
    "hex":"#a7aca2"
  },
  {
    "pantone":"7538-c",
    "hex":"#949a90"
  },
  {
    "pantone":"7539-c",
    "hex":"#8e9089"
  },
  {
    "pantone":"7540-c",
    "hex":"#4b4f54"
  },
  {
    "pantone":"427-c",
    "hex":"#d0d3d4"
  },
  {
    "pantone":"428-c",
    "hex":"#c1c6c8"
  },
  {
    "pantone":"429-c",
    "hex":"#a2aaad"
  },
  {
    "pantone":"430-c",
    "hex":"#7c878e"
  },
  {
    "pantone":"431-c",
    "hex":"#5b6770"
  },
  {
    "pantone":"432-c",
    "hex":"#333f48"
  },
  {
    "pantone":"433-c",
    "hex":"#1d252d"
  },
  {
    "pantone":"420-c",
    "hex":"#c7c9c7"
  },
  {
    "pantone":"421-c",
    "hex":"#b2b4b2"
  },
  {
    "pantone":"422-c",
    "hex":"#9ea2a2"
  },
  {
    "pantone":"423-c",
    "hex":"#898d8d"
  },
  {
    "pantone":"424-c",
    "hex":"#707372"
  },
  {
    "pantone":"425-c",
    "hex":"#54585a"
  },
  {
    "pantone":"426-c",
    "hex":"#25282a"
  },
  {
    "pantone":"441-c",
    "hex":"#bec6c4"
  },
  {
    "pantone":"442-c",
    "hex":"#a2acab"
  },
  {
    "pantone":"443-c",
    "hex":"#919d9d"
  },
  {
    "pantone":"444-c",
    "hex":"#717c7d"
  },
  {
    "pantone":"445-c",
    "hex":"#505759"
  },
  {
    "pantone":"446-c",
    "hex":"#3f4444"
  },
  {
    "pantone":"447-c",
    "hex":"#373a36"
  },
  {
    "pantone":"413-c",
    "hex":"#babbb1"
  },
  {
    "pantone":"414-c",
    "hex":"#a8a99e"
  },
  {
    "pantone":"415-c",
    "hex":"#919388"
  },
  {
    "pantone":"416-c",
    "hex":"#7e7f74"
  },
  {
    "pantone":"417-c",
    "hex":"#65665c"
  },
  {
    "pantone":"418-c",
    "hex":"#51534a"
  },
  {
    "pantone":"419-c",
    "hex":"#212322"
  },
  {
    "pantone":"400-c",
    "hex":"#c4bfb6"
  },
  {
    "pantone":"401-c",
    "hex":"#afa9a0"
  },
  {
    "pantone":"402-c",
    "hex":"#9d968d"
  },
  {
    "pantone":"403-c",
    "hex":"#8c857b"
  },
  {
    "pantone":"404-c",
    "hex":"#776e64"
  },
  {
    "pantone":"405-c",
    "hex":"#696158"
  },
  {
    "pantone":"406-c",
    "hex":"#c4bcb7"
  },
  {
    "pantone":"407-c",
    "hex":"#b2a8a2"
  },
  {
    "pantone":"408-c",
    "hex":"#978c87"
  },
  {
    "pantone":"409-c",
    "hex":"#857874"
  },
  {
    "pantone":"410-c",
    "hex":"#746661"
  },
  {
    "pantone":"411-c",
    "hex":"#5e514d"
  },
  {
    "pantone":"412-c",
    "hex":"#382f2d"
  },
  {
    "pantone":"434-c",
    "hex":"#d0c4c5"
  },
  {
    "pantone":"435-c",
    "hex":"#c1b2b6"
  },
  {
    "pantone":"436-c",
    "hex":"#ab989d"
  },
  {
    "pantone":"437-c",
    "hex":"#7b6469"
  },
  {
    "pantone":"438-c",
    "hex":"#584446"
  },
  {
    "pantone":"439-c",
    "hex":"#453536"
  },
  {
    "pantone":"440-c",
    "hex":"#382e2c"
  },
  {
    "pantone":"warm-gray-1-c",
    "hex":"#d7d2cb"
  },
  {
    "pantone":"warm-gray-2-c",
    "hex":"#cbc4bc"
  },
  {
    "pantone":"warm-gray-3-c",
    "hex":"#bfb8af"
  },
  {
    "pantone":"warm-gray-4-c",
    "hex":"#b6ada5"
  },
  {
    "pantone":"warm-gray-5-c",
    "hex":"#aca39a"
  },
  {
    "pantone":"warm-gray-6-c",
    "hex":"#a59c94"
  },
  {
    "pantone":"warm-gray-7-c",
    "hex":"#968c83"
  },
  {
    "pantone":"warm-gray-8-c",
    "hex":"#8c8279"
  },
  {
    "pantone":"warm-gray-9-c",
    "hex":"#83786f"
  },
  {
    "pantone":"warm-gray-10-c",
    "hex":"#796e65"
  },
  {
    "pantone":"warm-gray-11-c",
    "hex":"#6e6259"
  },
  {
    "pantone":"cool-gray-1-c",
    "hex":"#d9d9d6"
  },
  {
    "pantone":"cool-gray-2-c",
    "hex":"#d0d0ce"
  },
  {
    "pantone":"cool-gray-3-c",
    "hex":"#c8c9c7"
  },
  {
    "pantone":"cool-gray-4-c",
    "hex":"#bbbcbc"
  },
  {
    "pantone":"cool-gray-5-c",
    "hex":"#b1b3b3"
  },
  {
    "pantone":"cool-gray-6-c",
    "hex":"#a7a8aa"
  },
  {
    "pantone":"cool-gray-7-c",
    "hex":"#97999b"
  },
  {
    "pantone":"cool-gray-8-c",
    "hex":"#888b8d"
  },
  {
    "pantone":"cool-gray-9-c",
    "hex":"#75787b"
  },
  {
    "pantone":"cool-gray-10-c",
    "hex":"#63666a"
  },
  {
    "pantone":"cool-gray-11-c",
    "hex":"#53565a"
  },
  {
    "pantone":"black-2-c",
    "hex":"#332f21"
  },
  {
    "pantone":"black-3-c",
    "hex":"#212721"
  },
  {
    "pantone":"black-4-c",
    "hex":"#31261d"
  },
  {
    "pantone":"black-5-c",
    "hex":"#3e2b2e"
  },
  {
    "pantone":"black-6-c",
    "hex":"#101820"
  },
  {
    "pantone":"black-7-c",
    "hex":"#3d3935"
  },
  {
    "pantone":"yellow-c",
    "hex":"#fedd00"
  },
  {
    "pantone":"yellow-012-c",
    "hex":"#ffd700"
  },
  {
    "pantone":"orange-021-c",
    "hex":"#fe5000"
  },
  {
    "pantone":"warm-red-c",
    "hex":"#f9423a"
  },
  {
    "pantone":"red-032-c",
    "hex":"#ef3340"
  },
  {
    "pantone":"rubine-red-c",
    "hex":"#ce0058"
  },
  {
    "pantone":"rhodamine-red-c",
    "hex":"#e10098"
  },
  {
    "pantone":"purple-c",
    "hex":"#bb29bb"
  },
  {
    "pantone":"violet-c",
    "hex":"#440099"
  },
  {
    "pantone":"blue-072-c",
    "hex":"#10069f"
  },
  {
    "pantone":"reflex-blue-c",
    "hex":"#001489"
  },
  {
    "pantone":"process-blue-c",
    "hex":"#0085ca"
  },
  {
    "pantone":"green-c",
    "hex":"#00ab84"
  },
  {
    "pantone":"black-c",
    "hex":"#2d2926"
  },
  {
    "pantone":"yellow-0131-c",
    "hex":"#f2f0a1"
  },
  {
    "pantone":"red-0331-c",
    "hex":"#fcaebb"
  },
  {
    "pantone":"magenta-0521-c",
    "hex":"#f1b2dc"
  },
  {
    "pantone":"violet-0631-c",
    "hex":"#bf9bde"
  },
  {
    "pantone":"blue-0821-c",
    "hex":"#74d1ea"
  },
  {
    "pantone":"green-0921-c",
    "hex":"#9de7d7"
  },
  {
    "pantone":"black-0961-c",
    "hex":"#9e978e"
  },
  {
    "pantone":"801-c",
    "hex":"#009ace"
  },
  {
    "pantone":"802-c",
    "hex":"#44d62c"
  },
  {
    "pantone":"803-c",
    "hex":"#ffe900"
  },
  {
    "pantone":"804-c",
    "hex":"#ffaa4d"
  },
  {
    "pantone":"805-c",
    "hex":"#ff7276"
  },
  {
    "pantone":"806-c",
    "hex":"#ff3eb5"
  },
  {
    "pantone":"807-c",
    "hex":"#ea27c2"
  },
  {
    "pantone":"871-c",
    "hex":"#84754e"
  },
  {
    "pantone":"872-c",
    "hex":"#85714d"
  },
  {
    "pantone":"873-c",
    "hex":"#866d4b"
  },
  {
    "pantone":"874-c",
    "hex":"#8b6f4e"
  },
  {
    "pantone":"875-c",
    "hex":"#87674f"
  },
  {
    "pantone":"876-c",
    "hex":"#8b634b"
  },
  {
    "pantone":"877-c",
    "hex":"#8a8d8f"
  },
  {
    "pantone":"medium-yellow-c",
    "hex":"#ffd900"
  },
  {
    "pantone":"bright-orange-c",
    "hex":"#ff5e00"
  },
  {
    "pantone":"bright-red-c",
    "hex":"#f93822"
  },
  {
    "pantone":"strong-red-c",
    "hex":"#ce0056"
  },
  {
    "pantone":"pink-c",
    "hex":"#d62598"
  },
  {
    "pantone":"medium-purple-c",
    "hex":"#4e008e"
  },
  {
    "pantone":"dark-blue-c",
    "hex":"#00239c"
  },
  {
    "pantone":"medium-blue-c",
    "hex":"#0084ca"
  },
  {
    "pantone":"bright-green-c",
    "hex":"#00b08b"
  },
  {
    "pantone":"neutral-black-c",
    "hex":"#222223"
  },
  {
    "pantone":"100-u",
    "hex":"#fef380"
  },
  {
    "pantone":"101-u",
    "hex":"#fff166"
  },
  {
    "pantone":"102-u",
    "hex":"#ffec2d"
  },
  {
    "pantone":"103-u",
    "hex":"#b49f29"
  },
  {
    "pantone":"104-u",
    "hex":"#9b8d39"
  },
  {
    "pantone":"105-u",
    "hex":"#7d7547"
  },
  {
    "pantone":"7401-u",
    "hex":"#fee5a5"
  },
  {
    "pantone":"7402-u",
    "hex":"#f3da9a"
  },
  {
    "pantone":"7403-u",
    "hex":"#f4cf81"
  },
  {
    "pantone":"7404-u",
    "hex":"#fdcf41"
  },
  {
    "pantone":"7405-u",
    "hex":"#e6b10e"
  },
  {
    "pantone":"7406-u",
    "hex":"#f1b828"
  },
  {
    "pantone":"7407-u",
    "hex":"#cca36e"
  },
  {
    "pantone":"106-u",
    "hex":"#ffeb68"
  },
  {
    "pantone":"107-u",
    "hex":"#ffe552"
  },
  {
    "pantone":"108-u",
    "hex":"#ffdd35"
  },
  {
    "pantone":"109-u",
    "hex":"#ffc700"
  },
  {
    "pantone":"110-u",
    "hex":"#cc9f26"
  },
  {
    "pantone":"111-u",
    "hex":"#9c873b"
  },
  {
    "pantone":"112-u",
    "hex":"#8a7a3e"
  },
  {
    "pantone":"113-u",
    "hex":"#ffe15e"
  },
  {
    "pantone":"114-u",
    "hex":"#ffd94a"
  },
  {
    "pantone":"115-u",
    "hex":"#ffce2e"
  },
  {
    "pantone":"116-u",
    "hex":"#ffb511"
  },
  {
    "pantone":"117-u",
    "hex":"#b78c30"
  },
  {
    "pantone":"118-u",
    "hex":"#9e8139"
  },
  {
    "pantone":"119-u",
    "hex":"#847748"
  },
  {
    "pantone":"127-u",
    "hex":"#fce385"
  },
  {
    "pantone":"128-u",
    "hex":"#fccf61"
  },
  {
    "pantone":"129-u",
    "hex":"#faaf3f"
  },
  {
    "pantone":"130-u",
    "hex":"#f79b2e"
  },
  {
    "pantone":"131-u",
    "hex":"#ba8032"
  },
  {
    "pantone":"132-u",
    "hex":"#977a3c"
  },
  {
    "pantone":"133-u",
    "hex":"#7c7047"
  },
  {
    "pantone":"1205-u",
    "hex":"#ffe495"
  },
  {
    "pantone":"1215-u",
    "hex":"#ffda7e"
  },
  {
    "pantone":"1225-u",
    "hex":"#ffbb4f"
  },
  {
    "pantone":"1235-u",
    "hex":"#ffae3b"
  },
  {
    "pantone":"1245-u",
    "hex":"#bb8b41"
  },
  {
    "pantone":"1255-u",
    "hex":"#a08246"
  },
  {
    "pantone":"1265-u",
    "hex":"#887549"
  },
  {
    "pantone":"120-u",
    "hex":"#ffd96a"
  },
  {
    "pantone":"121-u",
    "hex":"#ffcc52"
  },
  {
    "pantone":"122-u",
    "hex":"#ffc03f"
  },
  {
    "pantone":"123-u",
    "hex":"#ffac2a"
  },
  {
    "pantone":"124-u",
    "hex":"#d79133"
  },
  {
    "pantone":"125-u",
    "hex":"#a6813d"
  },
  {
    "pantone":"126-u",
    "hex":"#8e7742"
  },
  {
    "pantone":"7548-u",
    "hex":"#ffc915"
  },
  {
    "pantone":"7549-u",
    "hex":"#ffb838"
  },
  {
    "pantone":"7550-u",
    "hex":"#ce973d"
  },
  {
    "pantone":"7551-u",
    "hex":"#ae8643"
  },
  {
    "pantone":"7552-u",
    "hex":"#826f4b"
  },
  {
    "pantone":"7553-u",
    "hex":"#70654b"
  },
  {
    "pantone":"7554-u",
    "hex":"#6c6558"
  },
  {
    "pantone":"7555-u",
    "hex":"#d7a95a"
  },
  {
    "pantone":"7556-u",
    "hex":"#bc995d"
  },
  {
    "pantone":"7557-u",
    "hex":"#a58d5f"
  },
  {
    "pantone":"7558-u",
    "hex":"#9b835e"
  },
  {
    "pantone":"7559-u",
    "hex":"#977f5e"
  },
  {
    "pantone":"7560-u",
    "hex":"#8e7e62"
  },
  {
    "pantone":"7561-u",
    "hex":"#807964"
  },
  {
    "pantone":"134-u",
    "hex":"#ffd378"
  },
  {
    "pantone":"135-u",
    "hex":"#ffc267"
  },
  {
    "pantone":"136-u",
    "hex":"#ffad4a"
  },
  {
    "pantone":"137-u",
    "hex":"#ff9f37"
  },
  {
    "pantone":"138-u",
    "hex":"#d37c32"
  },
  {
    "pantone":"139-u",
    "hex":"#9d6f3c"
  },
  {
    "pantone":"140-u",
    "hex":"#7f6a45"
  },
  {
    "pantone":"1345-u",
    "hex":"#ffd591"
  },
  {
    "pantone":"1355-u",
    "hex":"#ffc87e"
  },
  {
    "pantone":"1365-u",
    "hex":"#ffad5b"
  },
  {
    "pantone":"1375-u",
    "hex":"#ff9940"
  },
  {
    "pantone":"1385-u",
    "hex":"#cd7e3e"
  },
  {
    "pantone":"1395-u",
    "hex":"#946e43"
  },
  {
    "pantone":"1405-u",
    "hex":"#796648"
  },
  {
    "pantone":"141-u",
    "hex":"#f9c16e"
  },
  {
    "pantone":"142-u",
    "hex":"#f8b05d"
  },
  {
    "pantone":"143-u",
    "hex":"#f6a04d"
  },
  {
    "pantone":"144-u",
    "hex":"#f38b3c"
  },
  {
    "pantone":"145-u",
    "hex":"#c97f3a"
  },
  {
    "pantone":"146-u",
    "hex":"#9d7441"
  },
  {
    "pantone":"147-u",
    "hex":"#76694a"
  },
  {
    "pantone":"7408-u",
    "hex":"#ee9d26"
  },
  {
    "pantone":"7409-u",
    "hex":"#f7ad50"
  },
  {
    "pantone":"7410-u",
    "hex":"#ffa06e"
  },
  {
    "pantone":"7411-u",
    "hex":"#e9a16f"
  },
  {
    "pantone":"7412-u",
    "hex":"#d08c60"
  },
  {
    "pantone":"7413-u",
    "hex":"#de8958"
  },
  {
    "pantone":"7414-u",
    "hex":"#c07f53"
  },
  {
    "pantone":"7562-u",
    "hex":"#bda078"
  },
  {
    "pantone":"7563-u",
    "hex":"#daa563"
  },
  {
    "pantone":"7564-u",
    "hex":"#de9858"
  },
  {
    "pantone":"7565-u",
    "hex":"#c98659"
  },
  {
    "pantone":"7566-u",
    "hex":"#ae7b5e"
  },
  {
    "pantone":"7567-u",
    "hex":"#90705c"
  },
  {
    "pantone":"7568-u",
    "hex":"#826d5e"
  },
  {
    "pantone":"7569-u",
    "hex":"#d28e56"
  },
  {
    "pantone":"7570-u",
    "hex":"#d18d5b"
  },
  {
    "pantone":"7571-u",
    "hex":"#c3895d"
  },
  {
    "pantone":"7572-u",
    "hex":"#b17f5b"
  },
  {
    "pantone":"7573-u",
    "hex":"#a87b59"
  },
  {
    "pantone":"7574-u",
    "hex":"#99775b"
  },
  {
    "pantone":"7575-u",
    "hex":"#86715a"
  },
  {
    "pantone":"712-u",
    "hex":"#ffca9d"
  },
  {
    "pantone":"713-u",
    "hex":"#ffc190"
  },
  {
    "pantone":"714-u",
    "hex":"#ffb07b"
  },
  {
    "pantone":"715-u",
    "hex":"#f99963"
  },
  {
    "pantone":"716-u",
    "hex":"#ea8651"
  },
  {
    "pantone":"717-u",
    "hex":"#d77540"
  },
  {
    "pantone":"718-u",
    "hex":"#c76c3d"
  },
  {
    "pantone":"148-u",
    "hex":"#ffc688"
  },
  {
    "pantone":"149-u",
    "hex":"#ffb575"
  },
  {
    "pantone":"150-u",
    "hex":"#ff9955"
  },
  {
    "pantone":"151-u",
    "hex":"#ff883e"
  },
  {
    "pantone":"152-u",
    "hex":"#e07a3f"
  },
  {
    "pantone":"153-u",
    "hex":"#ac6f42"
  },
  {
    "pantone":"154-u",
    "hex":"#926844"
  },
  {
    "pantone":"155-u",
    "hex":"#f7c995"
  },
  {
    "pantone":"156-u",
    "hex":"#f7b984"
  },
  {
    "pantone":"157-u",
    "hex":"#f39662"
  },
  {
    "pantone":"158-u",
    "hex":"#ee7f4b"
  },
  {
    "pantone":"159-u",
    "hex":"#c97146"
  },
  {
    "pantone":"160-u",
    "hex":"#9d6b47"
  },
  {
    "pantone":"161-u",
    "hex":"#786249"
  },
  {
    "pantone":"1485-u",
    "hex":"#ffa563"
  },
  {
    "pantone":"1495-u",
    "hex":"#ff9351"
  },
  {
    "pantone":"1505-u",
    "hex":"#ff8038"
  },
  {
    "pantone":"1525-u",
    "hex":"#bd6439"
  },
  {
    "pantone":"1535-u",
    "hex":"#976241"
  },
  {
    "pantone":"1545-u",
    "hex":"#7a5f48"
  },
  {
    "pantone":"1555-u",
    "hex":"#ffc29e"
  },
  {
    "pantone":"1565-u",
    "hex":"#ffaa81"
  },
  {
    "pantone":"1575-u",
    "hex":"#ff9665"
  },
  {
    "pantone":"1585-u",
    "hex":"#ff8450"
  },
  {
    "pantone":"1595-u",
    "hex":"#d37046"
  },
  {
    "pantone":"1605-u",
    "hex":"#a76c4c"
  },
  {
    "pantone":"1615-u",
    "hex":"#93654a"
  },
  {
    "pantone":"162-u",
    "hex":"#ffbb9b"
  },
  {
    "pantone":"163-u",
    "hex":"#ff9c76"
  },
  {
    "pantone":"164-u",
    "hex":"#ff865f"
  },
  {
    "pantone":"165-u",
    "hex":"#ff7548"
  },
  {
    "pantone":"166-u",
    "hex":"#e16740"
  },
  {
    "pantone":"167-u",
    "hex":"#b46547"
  },
  {
    "pantone":"168-u",
    "hex":"#8a614b"
  },
  {
    "pantone":"7576-u",
    "hex":"#da8e6b"
  },
  {
    "pantone":"7577-u",
    "hex":"#e18b63"
  },
  {
    "pantone":"7578-u",
    "hex":"#db7d59"
  },
  {
    "pantone":"7579-u",
    "hex":"#df7357"
  },
  {
    "pantone":"7580-u",
    "hex":"#c06d59"
  },
  {
    "pantone":"7581-u",
    "hex":"#916b5d"
  },
  {
    "pantone":"7582-u",
    "hex":"#7a685e"
  },
  {
    "pantone":"1625-u",
    "hex":"#ffa891"
  },
  {
    "pantone":"1635-u",
    "hex":"#ff967e"
  },
  {
    "pantone":"1645-u",
    "hex":"#ff7f61"
  },
  {
    "pantone":"1655-u",
    "hex":"#ff6f4c"
  },
  {
    "pantone":"1665-u",
    "hex":"#e56849"
  },
  {
    "pantone":"1675-u",
    "hex":"#ab614a"
  },
  {
    "pantone":"1685-u",
    "hex":"#95614d"
  },
  {
    "pantone":"169-u",
    "hex":"#ffb7ae"
  },
  {
    "pantone":"170-u",
    "hex":"#ff8d7e"
  },
  {
    "pantone":"171-u",
    "hex":"#ff7865"
  },
  {
    "pantone":"172-u",
    "hex":"#ff674d"
  },
  {
    "pantone":"173-u",
    "hex":"#ce614a"
  },
  {
    "pantone":"174-u",
    "hex":"#9c5b4b"
  },
  {
    "pantone":"175-u",
    "hex":"#7d594d"
  },
  {
    "pantone":"7583-u",
    "hex":"#ca7d5f"
  },
  {
    "pantone":"7584-u",
    "hex":"#c07759"
  },
  {
    "pantone":"7585-u",
    "hex":"#b67965"
  },
  {
    "pantone":"7586-u",
    "hex":"#a2715d"
  },
  {
    "pantone":"7587-u",
    "hex":"#996e5c"
  },
  {
    "pantone":"7588-u",
    "hex":"#896e61"
  },
  {
    "pantone":"7589-u",
    "hex":"#756a63"
  },
  {
    "pantone":"7590-u",
    "hex":"#dbbca9"
  },
  {
    "pantone":"7591-u",
    "hex":"#c68d78"
  },
  {
    "pantone":"7592-u",
    "hex":"#b47260"
  },
  {
    "pantone":"7593-u",
    "hex":"#a26859"
  },
  {
    "pantone":"7594-u",
    "hex":"#8b645a"
  },
  {
    "pantone":"7595-u",
    "hex":"#80665c"
  },
  {
    "pantone":"7596-u",
    "hex":"#776760"
  },
  {
    "pantone":"7597-u",
    "hex":"#d66756"
  },
  {
    "pantone":"7598-u",
    "hex":"#c36d5c"
  },
  {
    "pantone":"7599-u",
    "hex":"#bd695a"
  },
  {
    "pantone":"7600-u",
    "hex":"#9b6a5e"
  },
  {
    "pantone":"7601-u",
    "hex":"#92695c"
  },
  {
    "pantone":"7602-u",
    "hex":"#8d6e61"
  },
  {
    "pantone":"7603-u",
    "hex":"#7c675d"
  },
  {
    "pantone":"7604-u",
    "hex":"#ead8d6"
  },
  {
    "pantone":"7605-u",
    "hex":"#eac4be"
  },
  {
    "pantone":"7606-u",
    "hex":"#dea09a"
  },
  {
    "pantone":"7607-u",
    "hex":"#cb867f"
  },
  {
    "pantone":"7608-u",
    "hex":"#ab6e67"
  },
  {
    "pantone":"7609-u",
    "hex":"#926660"
  },
  {
    "pantone":"7610-u",
    "hex":"#80615e"
  },
  {
    "pantone":"7611-u",
    "hex":"#e7c8be"
  },
  {
    "pantone":"7612-u",
    "hex":"#d4aaa0"
  },
  {
    "pantone":"7613-u",
    "hex":"#c89f97"
  },
  {
    "pantone":"7614-u",
    "hex":"#ae928c"
  },
  {
    "pantone":"7615-u",
    "hex":"#978480"
  },
  {
    "pantone":"7616-u",
    "hex":"#867474"
  },
  {
    "pantone":"7617-u",
    "hex":"#756667"
  },
  {
    "pantone":"7520-u",
    "hex":"#f3c4bf"
  },
  {
    "pantone":"7521-u",
    "hex":"#c4a195"
  },
  {
    "pantone":"7522-u",
    "hex":"#af7871"
  },
  {
    "pantone":"7523-u",
    "hex":"#a97576"
  },
  {
    "pantone":"7524-u",
    "hex":"#a36d6a"
  },
  {
    "pantone":"7525-u",
    "hex":"#997970"
  },
  {
    "pantone":"7526-u",
    "hex":"#925f52"
  },
  {
    "pantone":"489-u",
    "hex":"#f5c7b8"
  },
  {
    "pantone":"488-u",
    "hex":"#f4b9a9"
  },
  {
    "pantone":"487-u",
    "hex":"#f3a293"
  },
  {
    "pantone":"486-u",
    "hex":"#f08d80"
  },
  {
    "pantone":"485-u",
    "hex":"#e45d50"
  },
  {
    "pantone":"484-u",
    "hex":"#a05b4e"
  },
  {
    "pantone":"483-u",
    "hex":"#7d5b4f"
  },
  {
    "pantone":"176-u",
    "hex":"#ffb1ba"
  },
  {
    "pantone":"177-u",
    "hex":"#ff8c91"
  },
  {
    "pantone":"178-u",
    "hex":"#ff7677"
  },
  {
    "pantone":"179-u",
    "hex":"#e15f55"
  },
  {
    "pantone":"180-u",
    "hex":"#bf6059"
  },
  {
    "pantone":"181-u",
    "hex":"#8b5952"
  },
  {
    "pantone":"1765-u",
    "hex":"#ffa7b6"
  },
  {
    "pantone":"1775-u",
    "hex":"#ff8b9a"
  },
  {
    "pantone":"1785-u",
    "hex":"#fe6672"
  },
  {
    "pantone":"1788-u",
    "hex":"#f95d62"
  },
  {
    "pantone":"1795-u",
    "hex":"#da5959"
  },
  {
    "pantone":"1805-u",
    "hex":"#b45858"
  },
  {
    "pantone":"1815-u",
    "hex":"#8f5652"
  },
  {
    "pantone":"1767-u",
    "hex":"#ffbac9"
  },
  {
    "pantone":"1777-u",
    "hex":"#ff8091"
  },
  {
    "pantone":"1787-u",
    "hex":"#fc6371"
  },
  {
    "pantone":"1797-u",
    "hex":"#cb4f53"
  },
  {
    "pantone":"1807-u",
    "hex":"#a75154"
  },
  {
    "pantone":"1817-u",
    "hex":"#795453"
  },
  {
    "pantone":"7618-u",
    "hex":"#d08a77"
  },
  {
    "pantone":"7619-u",
    "hex":"#c87164"
  },
  {
    "pantone":"7620-u",
    "hex":"#c0615b"
  },
  {
    "pantone":"7621-u",
    "hex":"#ba5d5a"
  },
  {
    "pantone":"7622-u",
    "hex":"#a55d5c"
  },
  {
    "pantone":"7623-u",
    "hex":"#9b5c57"
  },
  {
    "pantone":"7624-u",
    "hex":"#8d5a54"
  },
  {
    "pantone":"7625-u",
    "hex":"#ea776c"
  },
  {
    "pantone":"7626-u",
    "hex":"#d2625f"
  },
  {
    "pantone":"7627-u",
    "hex":"#ad5857"
  },
  {
    "pantone":"7628-u",
    "hex":"#a85959"
  },
  {
    "pantone":"7629-u",
    "hex":"#805b5a"
  },
  {
    "pantone":"7630-u",
    "hex":"#765957"
  },
  {
    "pantone":"7631-u",
    "hex":"#6e5555"
  },
  {
    "pantone":"7415-u",
    "hex":"#ebb5a5"
  },
  {
    "pantone":"7416-u",
    "hex":"#ea746a"
  },
  {
    "pantone":"7417-u",
    "hex":"#e76b61"
  },
  {
    "pantone":"7418-u",
    "hex":"#bf6366"
  },
  {
    "pantone":"7419-u",
    "hex":"#a6626b"
  },
  {
    "pantone":"7420-u",
    "hex":"#a45768"
  },
  {
    "pantone":"7421-u",
    "hex":"#7d4e5b"
  },
  {
    "pantone":"182-u",
    "hex":"#ffb8ca"
  },
  {
    "pantone":"183-u",
    "hex":"#ff8da3"
  },
  {
    "pantone":"184-u",
    "hex":"#fc6e83"
  },
  {
    "pantone":"185-u",
    "hex":"#f15060"
  },
  {
    "pantone":"186-u",
    "hex":"#d2515e"
  },
  {
    "pantone":"187-u",
    "hex":"#ae535c"
  },
  {
    "pantone":"188-u",
    "hex":"#895559"
  },
  {
    "pantone":"196-u",
    "hex":"#f4c3cb"
  },
  {
    "pantone":"197-u",
    "hex":"#f2a1b2"
  },
  {
    "pantone":"198-u",
    "hex":"#e76b7c"
  },
  {
    "pantone":"199-u",
    "hex":"#dd5061"
  },
  {
    "pantone":"200-u",
    "hex":"#bd4f5c"
  },
  {
    "pantone":"201-u",
    "hex":"#a15760"
  },
  {
    "pantone":"202-u",
    "hex":"#90585e"
  },
  {
    "pantone":"189-u",
    "hex":"#ffabc2"
  },
  {
    "pantone":"190-u",
    "hex":"#fe87a3"
  },
  {
    "pantone":"191-u",
    "hex":"#f87089"
  },
  {
    "pantone":"192-u",
    "hex":"#ee536b"
  },
  {
    "pantone":"193-u",
    "hex":"#c55265"
  },
  {
    "pantone":"194-u",
    "hex":"#a35965"
  },
  {
    "pantone":"195-u",
    "hex":"#885a61"
  },
  {
    "pantone":"1895-u",
    "hex":"#feb3cd"
  },
  {
    "pantone":"1905-u",
    "hex":"#fd9cba"
  },
  {
    "pantone":"1915-u",
    "hex":"#f66f92"
  },
  {
    "pantone":"1925-u",
    "hex":"#e9506e"
  },
  {
    "pantone":"1935-u",
    "hex":"#c94c63"
  },
  {
    "pantone":"1945-u",
    "hex":"#b05468"
  },
  {
    "pantone":"1955-u",
    "hex":"#975361"
  },
  {
    "pantone":"705-u",
    "hex":"#ffdde2"
  },
  {
    "pantone":"706-u",
    "hex":"#ffcad4"
  },
  {
    "pantone":"707-u",
    "hex":"#ffb0bf"
  },
  {
    "pantone":"708-u",
    "hex":"#fe99a8"
  },
  {
    "pantone":"709-u",
    "hex":"#f47c8a"
  },
  {
    "pantone":"710-u",
    "hex":"#e4636f"
  },
  {
    "pantone":"711-u",
    "hex":"#ce5055"
  },
  {
    "pantone":"698-u",
    "hex":"#fad7da"
  },
  {
    "pantone":"699-u",
    "hex":"#fcc2cc"
  },
  {
    "pantone":"700-u",
    "hex":"#f8aab6"
  },
  {
    "pantone":"701-u",
    "hex":"#e98f9d"
  },
  {
    "pantone":"702-u",
    "hex":"#d87987"
  },
  {
    "pantone":"703-u",
    "hex":"#b45a65"
  },
  {
    "pantone":"704-u",
    "hex":"#a24f56"
  },
  {
    "pantone":"203-u",
    "hex":"#f5b1cc"
  },
  {
    "pantone":"204-u",
    "hex":"#ee82a4"
  },
  {
    "pantone":"205-u",
    "hex":"#e56284"
  },
  {
    "pantone":"206-u",
    "hex":"#d84465"
  },
  {
    "pantone":"207-u",
    "hex":"#af4c64"
  },
  {
    "pantone":"208-u",
    "hex":"#905567"
  },
  {
    "pantone":"209-u",
    "hex":"#825864"
  },
  {
    "pantone":"210-u",
    "hex":"#ffa2cb"
  },
  {
    "pantone":"211-u",
    "hex":"#fc85b6"
  },
  {
    "pantone":"212-u",
    "hex":"#f56d9e"
  },
  {
    "pantone":"213-u",
    "hex":"#e95485"
  },
  {
    "pantone":"214-u",
    "hex":"#d1517a"
  },
  {
    "pantone":"215-u",
    "hex":"#ae5171"
  },
  {
    "pantone":"216-u",
    "hex":"#8a5566"
  },
  {
    "pantone":"7422-u",
    "hex":"#fdd4da"
  },
  {
    "pantone":"7423-u",
    "hex":"#e2758f"
  },
  {
    "pantone":"7424-u",
    "hex":"#d9577d"
  },
  {
    "pantone":"7425-u",
    "hex":"#bb5a73"
  },
  {
    "pantone":"7426-u",
    "hex":"#b1556a"
  },
  {
    "pantone":"7427-u",
    "hex":"#a5525c"
  },
  {
    "pantone":"7428-u",
    "hex":"#805c67"
  },
  {
    "pantone":"7632-u",
    "hex":"#ddcfd0"
  },
  {
    "pantone":"7633-u",
    "hex":"#c9aaae"
  },
  {
    "pantone":"7634-u",
    "hex":"#c77d92"
  },
  {
    "pantone":"7635-u",
    "hex":"#cd627d"
  },
  {
    "pantone":"7636-u",
    "hex":"#c3566d"
  },
  {
    "pantone":"7637-u",
    "hex":"#955864"
  },
  {
    "pantone":"7638-u",
    "hex":"#855660"
  },
  {
    "pantone":"217-u",
    "hex":"#f4c1e1"
  },
  {
    "pantone":"218-u",
    "hex":"#ef84b9"
  },
  {
    "pantone":"219-u",
    "hex":"#e45c96"
  },
  {
    "pantone":"220-u",
    "hex":"#b04c75"
  },
  {
    "pantone":"221-u",
    "hex":"#9e4c6e"
  },
  {
    "pantone":"222-u",
    "hex":"#82566b"
  },
  {
    "pantone":"7639-u",
    "hex":"#a0858a"
  },
  {
    "pantone":"7640-u",
    "hex":"#9b6673"
  },
  {
    "pantone":"7641-u",
    "hex":"#9a5d6d"
  },
  {
    "pantone":"7642-u",
    "hex":"#7e5867"
  },
  {
    "pantone":"7643-u",
    "hex":"#7a5a67"
  },
  {
    "pantone":"7644-u",
    "hex":"#715862"
  },
  {
    "pantone":"7645-u",
    "hex":"#6c5760"
  },
  {
    "pantone":"223-u",
    "hex":"#f9a4d8"
  },
  {
    "pantone":"224-u",
    "hex":"#f587c7"
  },
  {
    "pantone":"225-u",
    "hex":"#ea60a7"
  },
  {
    "pantone":"226-u",
    "hex":"#dc4588"
  },
  {
    "pantone":"227-u",
    "hex":"#af4879"
  },
  {
    "pantone":"228-u",
    "hex":"#8d4d6d"
  },
  {
    "pantone":"229-u",
    "hex":"#7a5466"
  },
  {
    "pantone":"230-u",
    "hex":"#feb2e0"
  },
  {
    "pantone":"231-u",
    "hex":"#f984ca"
  },
  {
    "pantone":"232-u",
    "hex":"#f16ab7"
  },
  {
    "pantone":"233-u",
    "hex":"#c84687"
  },
  {
    "pantone":"234-u",
    "hex":"#aa4c7d"
  },
  {
    "pantone":"235-u",
    "hex":"#914e72"
  },
  {
    "pantone":"670-u",
    "hex":"#f3d6e5"
  },
  {
    "pantone":"671-u",
    "hex":"#efc3dd"
  },
  {
    "pantone":"672-u",
    "hex":"#e8a7cd"
  },
  {
    "pantone":"673-u",
    "hex":"#df8cba"
  },
  {
    "pantone":"674-u",
    "hex":"#cd72a1"
  },
  {
    "pantone":"675-u",
    "hex":"#bd618e"
  },
  {
    "pantone":"676-u",
    "hex":"#a85079"
  },
  {
    "pantone":"677-u",
    "hex":"#edd2e0"
  },
  {
    "pantone":"678-u",
    "hex":"#e5c0d4"
  },
  {
    "pantone":"679-u",
    "hex":"#daacc6"
  },
  {
    "pantone":"680-u",
    "hex":"#c08ba9"
  },
  {
    "pantone":"681-u",
    "hex":"#a5708d"
  },
  {
    "pantone":"682-u",
    "hex":"#905d78"
  },
  {
    "pantone":"683-u",
    "hex":"#805268"
  },
  {
    "pantone":"684-u",
    "hex":"#eccbd9"
  },
  {
    "pantone":"685-u",
    "hex":"#e4bdd0"
  },
  {
    "pantone":"686-u",
    "hex":"#d5a6be"
  },
  {
    "pantone":"687-u",
    "hex":"#bd8ca6"
  },
  {
    "pantone":"688-u",
    "hex":"#a2738c"
  },
  {
    "pantone":"689-u",
    "hex":"#8e6178"
  },
  {
    "pantone":"690-u",
    "hex":"#7c5060"
  },
  {
    "pantone":"510-u",
    "hex":"#f2bfcb"
  },
  {
    "pantone":"509-u",
    "hex":"#eaaebe"
  },
  {
    "pantone":"508-u",
    "hex":"#df9cae"
  },
  {
    "pantone":"507-u",
    "hex":"#cf8fa4"
  },
  {
    "pantone":"506-u",
    "hex":"#9a6372"
  },
  {
    "pantone":"505-u",
    "hex":"#8a5c66"
  },
  {
    "pantone":"504-u",
    "hex":"#7f5d62"
  },
  {
    "pantone":"7429-u",
    "hex":"#eeccd9"
  },
  {
    "pantone":"7430-u",
    "hex":"#e6b5c9"
  },
  {
    "pantone":"7431-u",
    "hex":"#dca2b9"
  },
  {
    "pantone":"7432-u",
    "hex":"#c5819a"
  },
  {
    "pantone":"7433-u",
    "hex":"#b96f89"
  },
  {
    "pantone":"7434-u",
    "hex":"#a8677d"
  },
  {
    "pantone":"7435-u",
    "hex":"#8c566b"
  },
  {
    "pantone":"691-u",
    "hex":"#f1d3d5"
  },
  {
    "pantone":"692-u",
    "hex":"#e9c0c5"
  },
  {
    "pantone":"693-u",
    "hex":"#daa5ad"
  },
  {
    "pantone":"694-u",
    "hex":"#c38d96"
  },
  {
    "pantone":"695-u",
    "hex":"#ac7680"
  },
  {
    "pantone":"696-u",
    "hex":"#98656c"
  },
  {
    "pantone":"697-u",
    "hex":"#87565b"
  },
  {
    "pantone":"496-u",
    "hex":"#f9c2cc"
  },
  {
    "pantone":"495-u",
    "hex":"#f1afbc"
  },
  {
    "pantone":"494-u",
    "hex":"#e59aa8"
  },
  {
    "pantone":"493-u",
    "hex":"#c77c89"
  },
  {
    "pantone":"492-u",
    "hex":"#9d5d60"
  },
  {
    "pantone":"491-u",
    "hex":"#8e595a"
  },
  {
    "pantone":"490-u",
    "hex":"#775554"
  },
  {
    "pantone":"503-u",
    "hex":"#f2cdcf"
  },
  {
    "pantone":"502-u",
    "hex":"#e6b7bd"
  },
  {
    "pantone":"501-u",
    "hex":"#d8a5ac"
  },
  {
    "pantone":"500-u",
    "hex":"#bd898f"
  },
  {
    "pantone":"499-u",
    "hex":"#8d615f"
  },
  {
    "pantone":"498-u",
    "hex":"#805d5b"
  },
  {
    "pantone":"497-u",
    "hex":"#715956"
  },
  {
    "pantone":"5035-u",
    "hex":"#e6c6c7"
  },
  {
    "pantone":"5025-u",
    "hex":"#dcb6ba"
  },
  {
    "pantone":"5015-u",
    "hex":"#caa1a6"
  },
  {
    "pantone":"5005-u",
    "hex":"#b28a90"
  },
  {
    "pantone":"4995-u",
    "hex":"#9f787f"
  },
  {
    "pantone":"4985-u",
    "hex":"#8f6a6f"
  },
  {
    "pantone":"4975-u",
    "hex":"#745654"
  },
  {
    "pantone":"236-u",
    "hex":"#f8a6de"
  },
  {
    "pantone":"237-u",
    "hex":"#f28dd2"
  },
  {
    "pantone":"238-u",
    "hex":"#e971c0"
  },
  {
    "pantone":"239-u",
    "hex":"#db55aa"
  },
  {
    "pantone":"240-u",
    "hex":"#c15598"
  },
  {
    "pantone":"241-u",
    "hex":"#af548b"
  },
  {
    "pantone":"242-u",
    "hex":"#8d5977"
  },
  {
    "pantone":"2365-u",
    "hex":"#f8bfe7"
  },
  {
    "pantone":"2375-u",
    "hex":"#ea88d2"
  },
  {
    "pantone":"2385-u",
    "hex":"#e06fc2"
  },
  {
    "pantone":"2395-u",
    "hex":"#d557af"
  },
  {
    "pantone":"2405-u",
    "hex":"#bb569d"
  },
  {
    "pantone":"2415-u",
    "hex":"#ab5491"
  },
  {
    "pantone":"2425-u",
    "hex":"#975381"
  },
  {
    "pantone":"243-u",
    "hex":"#f1b2e6"
  },
  {
    "pantone":"244-u",
    "hex":"#eb9ade"
  },
  {
    "pantone":"245-u",
    "hex":"#e07fd0"
  },
  {
    "pantone":"246-u",
    "hex":"#ce57b3"
  },
  {
    "pantone":"247-u",
    "hex":"#bd51a2"
  },
  {
    "pantone":"248-u",
    "hex":"#a14f8c"
  },
  {
    "pantone":"249-u",
    "hex":"#885779"
  },
  {
    "pantone":"7646-u",
    "hex":"#b08799"
  },
  {
    "pantone":"7647-u",
    "hex":"#b16889"
  },
  {
    "pantone":"7648-u",
    "hex":"#9e537b"
  },
  {
    "pantone":"7649-u",
    "hex":"#935379"
  },
  {
    "pantone":"7650-u",
    "hex":"#835573"
  },
  {
    "pantone":"7651-u",
    "hex":"#7f5c78"
  },
  {
    "pantone":"7652-u",
    "hex":"#73556c"
  },
  {
    "pantone":"250-u",
    "hex":"#eebae9"
  },
  {
    "pantone":"251-u",
    "hex":"#e096df"
  },
  {
    "pantone":"252-u",
    "hex":"#ce70cc"
  },
  {
    "pantone":"253-u",
    "hex":"#b456ae"
  },
  {
    "pantone":"254-u",
    "hex":"#9e549a"
  },
  {
    "pantone":"255-u",
    "hex":"#83577d"
  },
  {
    "pantone":"517-u",
    "hex":"#f2c8e3"
  },
  {
    "pantone":"516-u",
    "hex":"#e8b6dc"
  },
  {
    "pantone":"515-u",
    "hex":"#e2a5d4"
  },
  {
    "pantone":"514-u",
    "hex":"#ce89c3"
  },
  {
    "pantone":"513-u",
    "hex":"#9e5f98"
  },
  {
    "pantone":"512-u",
    "hex":"#8a587f"
  },
  {
    "pantone":"511-u",
    "hex":"#745568"
  },
  {
    "pantone":"7436-u",
    "hex":"#f3d5ed"
  },
  {
    "pantone":"7437-u",
    "hex":"#d4b6d6"
  },
  {
    "pantone":"7438-u",
    "hex":"#d79bd7"
  },
  {
    "pantone":"7439-u",
    "hex":"#c09cc6"
  },
  {
    "pantone":"7440-u",
    "hex":"#b796ba"
  },
  {
    "pantone":"7441-u",
    "hex":"#ae7eca"
  },
  {
    "pantone":"7442-u",
    "hex":"#9e62be"
  },
  {
    "pantone":"2562-u",
    "hex":"#ddaee9"
  },
  {
    "pantone":"2572-u",
    "hex":"#cd90de"
  },
  {
    "pantone":"2582-u",
    "hex":"#bb76cf"
  },
  {
    "pantone":"2592-u",
    "hex":"#aa60bf"
  },
  {
    "pantone":"2602-u",
    "hex":"#9757a6"
  },
  {
    "pantone":"2612-u",
    "hex":"#86578d"
  },
  {
    "pantone":"2622-u",
    "hex":"#7b5b7a"
  },
  {
    "pantone":"7653-u",
    "hex":"#9e95a0"
  },
  {
    "pantone":"7654-u",
    "hex":"#aa8aa5"
  },
  {
    "pantone":"7655-u",
    "hex":"#a978a0"
  },
  {
    "pantone":"7656-u",
    "hex":"#96648d"
  },
  {
    "pantone":"7657-u",
    "hex":"#7e5978"
  },
  {
    "pantone":"7658-u",
    "hex":"#7c5e77"
  },
  {
    "pantone":"7659-u",
    "hex":"#6e5a6b"
  },
  {
    "pantone":"524-u",
    "hex":"#dac5dc"
  },
  {
    "pantone":"523-u",
    "hex":"#d0b7d5"
  },
  {
    "pantone":"522-u",
    "hex":"#bc9fc6"
  },
  {
    "pantone":"521-u",
    "hex":"#a98bb5"
  },
  {
    "pantone":"520-u",
    "hex":"#815f87"
  },
  {
    "pantone":"519-u",
    "hex":"#775d7a"
  },
  {
    "pantone":"518-u",
    "hex":"#6c5969"
  },
  {
    "pantone":"5245-u",
    "hex":"#e0cfd6"
  },
  {
    "pantone":"5235-u",
    "hex":"#d6c3cc"
  },
  {
    "pantone":"5225-u",
    "hex":"#c2acb9"
  },
  {
    "pantone":"5215-u",
    "hex":"#a28c9c"
  },
  {
    "pantone":"5205-u",
    "hex":"#907b8a"
  },
  {
    "pantone":"5195-u",
    "hex":"#816c78"
  },
  {
    "pantone":"5185-u",
    "hex":"#756069"
  },
  {
    "pantone":"5175-u",
    "hex":"#dac5d0"
  },
  {
    "pantone":"5165-u",
    "hex":"#ccb4c4"
  },
  {
    "pantone":"5155-u",
    "hex":"#b99eb2"
  },
  {
    "pantone":"5145-u",
    "hex":"#a4899f"
  },
  {
    "pantone":"5135-u",
    "hex":"#8c7287"
  },
  {
    "pantone":"5125-u",
    "hex":"#7d6378"
  },
  {
    "pantone":"5115-u",
    "hex":"#6f5564"
  },
  {
    "pantone":"531-u",
    "hex":"#e4c7eb"
  },
  {
    "pantone":"530-u",
    "hex":"#dbb9e8"
  },
  {
    "pantone":"529-u",
    "hex":"#cea5e1"
  },
  {
    "pantone":"528-u",
    "hex":"#b889d2"
  },
  {
    "pantone":"527-u",
    "hex":"#9361b0"
  },
  {
    "pantone":"526-u",
    "hex":"#805791"
  },
  {
    "pantone":"525-u",
    "hex":"#735775"
  },
  {
    "pantone":"256-u",
    "hex":"#d4b4da"
  },
  {
    "pantone":"257-u",
    "hex":"#c29bcb"
  },
  {
    "pantone":"258-u",
    "hex":"#a276ae"
  },
  {
    "pantone":"259-u",
    "hex":"#94679c"
  },
  {
    "pantone":"260-u",
    "hex":"#8a658d"
  },
  {
    "pantone":"261-u",
    "hex":"#7f6282"
  },
  {
    "pantone":"262-u",
    "hex":"#755e74"
  },
  {
    "pantone":"2563-u",
    "hex":"#cda2d9"
  },
  {
    "pantone":"2573-u",
    "hex":"#b989cb"
  },
  {
    "pantone":"2583-u",
    "hex":"#a372b5"
  },
  {
    "pantone":"2593-u",
    "hex":"#8e5da0"
  },
  {
    "pantone":"2603-u",
    "hex":"#845991"
  },
  {
    "pantone":"2613-u",
    "hex":"#7d5787"
  },
  {
    "pantone":"2623-u",
    "hex":"#75557a"
  },
  {
    "pantone":"7660-u",
    "hex":"#9c97a8"
  },
  {
    "pantone":"7661-u",
    "hex":"#947f9d"
  },
  {
    "pantone":"7662-u",
    "hex":"#84668c"
  },
  {
    "pantone":"7663-u",
    "hex":"#7a5c83"
  },
  {
    "pantone":"7664-u",
    "hex":"#765d84"
  },
  {
    "pantone":"7665-u",
    "hex":"#725e7c"
  },
  {
    "pantone":"7666-u",
    "hex":"#706977"
  },
  {
    "pantone":"2567-u",
    "hex":"#c09fdb"
  },
  {
    "pantone":"2577-u",
    "hex":"#a47ec6"
  },
  {
    "pantone":"2587-u",
    "hex":"#936db7"
  },
  {
    "pantone":"2597-u",
    "hex":"#825aa4"
  },
  {
    "pantone":"2607-u",
    "hex":"#7a5896"
  },
  {
    "pantone":"2617-u",
    "hex":"#735489"
  },
  {
    "pantone":"2627-u",
    "hex":"#6e527c"
  },
  {
    "pantone":"263-u",
    "hex":"#dcc6ea"
  },
  {
    "pantone":"264-u",
    "hex":"#bfa1e3"
  },
  {
    "pantone":"265-u",
    "hex":"#9d7ad2"
  },
  {
    "pantone":"266-u",
    "hex":"#8a65c4"
  },
  {
    "pantone":"267-u",
    "hex":"#7f5dae"
  },
  {
    "pantone":"268-u",
    "hex":"#735990"
  },
  {
    "pantone":"269-u",
    "hex":"#6e587f"
  },
  {
    "pantone":"2635-u",
    "hex":"#c9b7e8"
  },
  {
    "pantone":"2645-u",
    "hex":"#b9a3e3"
  },
  {
    "pantone":"2655-u",
    "hex":"#a288d9"
  },
  {
    "pantone":"2665-u",
    "hex":"#8c6fca"
  },
  {
    "pantone":"2685-u",
    "hex":"#765ba7"
  },
  {
    "pantone":"2695-u",
    "hex":"#6c5d80"
  },
  {
    "pantone":"270-u",
    "hex":"#adaede"
  },
  {
    "pantone":"271-u",
    "hex":"#9a9bd4"
  },
  {
    "pantone":"272-u",
    "hex":"#8586c6"
  },
  {
    "pantone":"273-u",
    "hex":"#645d9b"
  },
  {
    "pantone":"274-u",
    "hex":"#5f578b"
  },
  {
    "pantone":"275-u",
    "hex":"#5d5683"
  },
  {
    "pantone":"276-u",
    "hex":"#5c556f"
  },
  {
    "pantone":"2705-u",
    "hex":"#bab6e9"
  },
  {
    "pantone":"2715-u",
    "hex":"#9f98df"
  },
  {
    "pantone":"2725-u",
    "hex":"#8980d4"
  },
  {
    "pantone":"2735-u",
    "hex":"#6857b2"
  },
  {
    "pantone":"2745-u",
    "hex":"#61559a"
  },
  {
    "pantone":"2755-u",
    "hex":"#5d538b"
  },
  {
    "pantone":"2765-u",
    "hex":"#574f77"
  },
  {
    "pantone":"7667-u",
    "hex":"#828ca8"
  },
  {
    "pantone":"7668-u",
    "hex":"#7b81a4"
  },
  {
    "pantone":"7669-u",
    "hex":"#7878a2"
  },
  {
    "pantone":"7670-u",
    "hex":"#706e9a"
  },
  {
    "pantone":"7671-u",
    "hex":"#6e6993"
  },
  {
    "pantone":"7672-u",
    "hex":"#6b668e"
  },
  {
    "pantone":"7673-u",
    "hex":"#6c6d8d"
  },
  {
    "pantone":"7443-u",
    "hex":"#ddd8eb"
  },
  {
    "pantone":"7444-u",
    "hex":"#bcbde2"
  },
  {
    "pantone":"7445-u",
    "hex":"#aca8c7"
  },
  {
    "pantone":"7446-u",
    "hex":"#9493cf"
  },
  {
    "pantone":"7447-u",
    "hex":"#7f7392"
  },
  {
    "pantone":"7448-u",
    "hex":"#726874"
  },
  {
    "pantone":"7449-u",
    "hex":"#63515c"
  },
  {
    "pantone":"7674-u",
    "hex":"#9296b8"
  },
  {
    "pantone":"7675-u",
    "hex":"#888caf"
  },
  {
    "pantone":"7676-u",
    "hex":"#827aa3"
  },
  {
    "pantone":"7677-u",
    "hex":"#7c6d96"
  },
  {
    "pantone":"7678-u",
    "hex":"#766691"
  },
  {
    "pantone":"7679-u",
    "hex":"#6e628b"
  },
  {
    "pantone":"7680-u",
    "hex":"#695981"
  },
  {
    "pantone":"663-u",
    "hex":"#e2d9e3"
  },
  {
    "pantone":"664-u",
    "hex":"#dacfdd"
  },
  {
    "pantone":"665-u",
    "hex":"#c5b8ce"
  },
  {
    "pantone":"666-u",
    "hex":"#aea1bc"
  },
  {
    "pantone":"667-u",
    "hex":"#9083a1"
  },
  {
    "pantone":"668-u",
    "hex":"#817391"
  },
  {
    "pantone":"669-u",
    "hex":"#71637f"
  },
  {
    "pantone":"5315-u",
    "hex":"#dbd8e1"
  },
  {
    "pantone":"5305-u",
    "hex":"#c5c2d2"
  },
  {
    "pantone":"5295-u",
    "hex":"#b1afc3"
  },
  {
    "pantone":"5285-u",
    "hex":"#9694ac"
  },
  {
    "pantone":"5275-u",
    "hex":"#7b7992"
  },
  {
    "pantone":"5265-u",
    "hex":"#6d6b82"
  },
  {
    "pantone":"5255-u",
    "hex":"#5d566c"
  },
  {
    "pantone":"538-u",
    "hex":"#cdd7e1"
  },
  {
    "pantone":"537-u",
    "hex":"#bdcada"
  },
  {
    "pantone":"536-u",
    "hex":"#a4b5cb"
  },
  {
    "pantone":"535-u",
    "hex":"#8c9db8"
  },
  {
    "pantone":"534-u",
    "hex":"#5b6983"
  },
  {
    "pantone":"533-u",
    "hex":"#5e6578"
  },
  {
    "pantone":"532-u",
    "hex":"#5b5c64"
  },
  {
    "pantone":"7541-u",
    "hex":"#dde4e6"
  },
  {
    "pantone":"7542-u",
    "hex":"#b0c5cc"
  },
  {
    "pantone":"7543-u",
    "hex":"#aeb8c0"
  },
  {
    "pantone":"7544-u",
    "hex":"#9aa5af"
  },
  {
    "pantone":"7545-u",
    "hex":"#78838e"
  },
  {
    "pantone":"7546-u",
    "hex":"#67707a"
  },
  {
    "pantone":"7547-u",
    "hex":"#51545d"
  },
  {
    "pantone":"552-u",
    "hex":"#b0d0dc"
  },
  {
    "pantone":"551-u",
    "hex":"#96c0ce"
  },
  {
    "pantone":"550-u",
    "hex":"#7aaabe"
  },
  {
    "pantone":"549-u",
    "hex":"#6899ae"
  },
  {
    "pantone":"548-u",
    "hex":"#3e5e6f"
  },
  {
    "pantone":"547-u",
    "hex":"#415866"
  },
  {
    "pantone":"546-u",
    "hex":"#465058"
  },
  {
    "pantone":"5455-u",
    "hex":"#c7d7e0"
  },
  {
    "pantone":"5445-u",
    "hex":"#b4c7d3"
  },
  {
    "pantone":"5435-u",
    "hex":"#9db4c4"
  },
  {
    "pantone":"5425-u",
    "hex":"#7993a5"
  },
  {
    "pantone":"5415-u",
    "hex":"#677f91"
  },
  {
    "pantone":"5405-u",
    "hex":"#5b6f80"
  },
  {
    "pantone":"5395-u",
    "hex":"#464c59"
  },
  {
    "pantone":"642-u",
    "hex":"#d3e0ea"
  },
  {
    "pantone":"643-u",
    "hex":"#bfd2e4"
  },
  {
    "pantone":"644-u",
    "hex":"#9db9d5"
  },
  {
    "pantone":"645-u",
    "hex":"#84a3c4"
  },
  {
    "pantone":"646-u",
    "hex":"#6e8db0"
  },
  {
    "pantone":"647-u",
    "hex":"#5f7a9d"
  },
  {
    "pantone":"648-u",
    "hex":"#4e6282"
  },
  {
    "pantone":"649-u",
    "hex":"#e1e7ee"
  },
  {
    "pantone":"650-u",
    "hex":"#d7e0eb"
  },
  {
    "pantone":"651-u",
    "hex":"#afc3dc"
  },
  {
    "pantone":"652-u",
    "hex":"#89a2c4"
  },
  {
    "pantone":"653-u",
    "hex":"#6780a4"
  },
  {
    "pantone":"654-u",
    "hex":"#55688b"
  },
  {
    "pantone":"655-u",
    "hex":"#4e5d7f"
  },
  {
    "pantone":"656-u",
    "hex":"#e2eaf2"
  },
  {
    "pantone":"657-u",
    "hex":"#d6e2f2"
  },
  {
    "pantone":"658-u",
    "hex":"#b8cfee"
  },
  {
    "pantone":"659-u",
    "hex":"#96b6e5"
  },
  {
    "pantone":"660-u",
    "hex":"#658bcc"
  },
  {
    "pantone":"661-u",
    "hex":"#4967aa"
  },
  {
    "pantone":"662-u",
    "hex":"#425390"
  },
  {
    "pantone":"7450-u",
    "hex":"#c3cbe0"
  },
  {
    "pantone":"7451-u",
    "hex":"#94b3ea"
  },
  {
    "pantone":"7452-u",
    "hex":"#91a0e4"
  },
  {
    "pantone":"7453-u",
    "hex":"#88ade3"
  },
  {
    "pantone":"7454-u",
    "hex":"#7599bb"
  },
  {
    "pantone":"7455-u",
    "hex":"#6b7db9"
  },
  {
    "pantone":"7456-u",
    "hex":"#8089c0"
  },
  {
    "pantone":"2706-u",
    "hex":"#ccd4f1"
  },
  {
    "pantone":"2716-u",
    "hex":"#a2afe9"
  },
  {
    "pantone":"2726-u",
    "hex":"#717acf"
  },
  {
    "pantone":"2736-u",
    "hex":"#5e60ba"
  },
  {
    "pantone":"2746-u",
    "hex":"#595ca5"
  },
  {
    "pantone":"2756-u",
    "hex":"#585c8c"
  },
  {
    "pantone":"2766-u",
    "hex":"#575a7c"
  },
  {
    "pantone":"2708-u",
    "hex":"#b2c9ef"
  },
  {
    "pantone":"2718-u",
    "hex":"#6a87d8"
  },
  {
    "pantone":"2728-u",
    "hex":"#5268c2"
  },
  {
    "pantone":"2738-u",
    "hex":"#474da4"
  },
  {
    "pantone":"2748-u",
    "hex":"#484f8c"
  },
  {
    "pantone":"2758-u",
    "hex":"#484d7a"
  },
  {
    "pantone":"2768-u",
    "hex":"#4a4e6d"
  },
  {
    "pantone":"2707-u",
    "hex":"#c7dbf4"
  },
  {
    "pantone":"2717-u",
    "hex":"#a9c8f4"
  },
  {
    "pantone":"2727-u",
    "hex":"#6490e8"
  },
  {
    "pantone":"2747-u",
    "hex":"#424f90"
  },
  {
    "pantone":"2757-u",
    "hex":"#454f7e"
  },
  {
    "pantone":"2767-u",
    "hex":"#4a4c64"
  },
  {
    "pantone":"277-u",
    "hex":"#adcff1"
  },
  {
    "pantone":"278-u",
    "hex":"#8dbaee"
  },
  {
    "pantone":"279-u",
    "hex":"#5b8edb"
  },
  {
    "pantone":"280-u",
    "hex":"#3c4981"
  },
  {
    "pantone":"281-u",
    "hex":"#3f4a75"
  },
  {
    "pantone":"282-u",
    "hex":"#434967"
  },
  {
    "pantone":"283-u",
    "hex":"#9bc7ee"
  },
  {
    "pantone":"284-u",
    "hex":"#7ab1e8"
  },
  {
    "pantone":"285-u",
    "hex":"#4982cf"
  },
  {
    "pantone":"286-u",
    "hex":"#3255a4"
  },
  {
    "pantone":"287-u",
    "hex":"#3c5896"
  },
  {
    "pantone":"288-u",
    "hex":"#3d5588"
  },
  {
    "pantone":"289-u",
    "hex":"#434f69"
  },
  {
    "pantone":"7681-u",
    "hex":"#9db0d0"
  },
  {
    "pantone":"7682-u",
    "hex":"#8097bf"
  },
  {
    "pantone":"7683-u",
    "hex":"#6982b0"
  },
  {
    "pantone":"7684-u",
    "hex":"#6276a3"
  },
  {
    "pantone":"7685-u",
    "hex":"#5e719d"
  },
  {
    "pantone":"7686-u",
    "hex":"#556995"
  },
  {
    "pantone":"7687-u",
    "hex":"#525f8d"
  },
  {
    "pantone":"545-u",
    "hex":"#aecfe6"
  },
  {
    "pantone":"544-u",
    "hex":"#97c1df"
  },
  {
    "pantone":"543-u",
    "hex":"#79abd2"
  },
  {
    "pantone":"542-u",
    "hex":"#699cc6"
  },
  {
    "pantone":"541-u",
    "hex":"#3a557c"
  },
  {
    "pantone":"540-u",
    "hex":"#3f526f"
  },
  {
    "pantone":"539-u",
    "hex":"#465062"
  },
  {
    "pantone":"290-u",
    "hex":"#a7d4ee"
  },
  {
    "pantone":"291-u",
    "hex":"#7fbeeb"
  },
  {
    "pantone":"292-u",
    "hex":"#62a8e5"
  },
  {
    "pantone":"293-u",
    "hex":"#235ba8"
  },
  {
    "pantone":"294-u",
    "hex":"#385988"
  },
  {
    "pantone":"295-u",
    "hex":"#375172"
  },
  {
    "pantone":"296-u",
    "hex":"#435060"
  },
  {
    "pantone":"2905-u",
    "hex":"#8ac9ed"
  },
  {
    "pantone":"2915-u",
    "hex":"#64b3e8"
  },
  {
    "pantone":"2925-u",
    "hex":"#4097db"
  },
  {
    "pantone":"2935-u",
    "hex":"#1b5faa"
  },
  {
    "pantone":"2945-u",
    "hex":"#29588c"
  },
  {
    "pantone":"2955-u",
    "hex":"#395775"
  },
  {
    "pantone":"2965-u",
    "hex":"#3d5265"
  },
  {
    "pantone":"297-u",
    "hex":"#7eccee"
  },
  {
    "pantone":"298-u",
    "hex":"#4cb4e7"
  },
  {
    "pantone":"299-u",
    "hex":"#1295d8"
  },
  {
    "pantone":"300-u",
    "hex":"#006eb6"
  },
  {
    "pantone":"301-u",
    "hex":"#28628e"
  },
  {
    "pantone":"302-u",
    "hex":"#375e77"
  },
  {
    "pantone":"303-u",
    "hex":"#3f5666"
  },
  {
    "pantone":"7688-u",
    "hex":"#5e9aca"
  },
  {
    "pantone":"7689-u",
    "hex":"#5693c1"
  },
  {
    "pantone":"7690-u",
    "hex":"#4c7fa7"
  },
  {
    "pantone":"7691-u",
    "hex":"#467198"
  },
  {
    "pantone":"7692-u",
    "hex":"#4c6b8b"
  },
  {
    "pantone":"7693-u",
    "hex":"#4d6480"
  },
  {
    "pantone":"7694-u",
    "hex":"#4d6179"
  },
  {
    "pantone":"2975-u",
    "hex":"#8bd5ee"
  },
  {
    "pantone":"2985-u",
    "hex":"#48b8e7"
  },
  {
    "pantone":"2995-u",
    "hex":"#0d9ddb"
  },
  {
    "pantone":"3005-u",
    "hex":"#0078bf"
  },
  {
    "pantone":"3015-u",
    "hex":"#216a95"
  },
  {
    "pantone":"3025-u",
    "hex":"#37617a"
  },
  {
    "pantone":"3035-u",
    "hex":"#405866"
  },
  {
    "pantone":"7695-u",
    "hex":"#82a8bd"
  },
  {
    "pantone":"7696-u",
    "hex":"#719baf"
  },
  {
    "pantone":"7697-u",
    "hex":"#698fa4"
  },
  {
    "pantone":"7698-u",
    "hex":"#637f92"
  },
  {
    "pantone":"7699-u",
    "hex":"#5e7688"
  },
  {
    "pantone":"7700-u",
    "hex":"#557288"
  },
  {
    "pantone":"7701-u",
    "hex":"#496b80"
  },
  {
    "pantone":"7457-u",
    "hex":"#bfe3ed"
  },
  {
    "pantone":"7458-u",
    "hex":"#67a5bf"
  },
  {
    "pantone":"7459-u",
    "hex":"#518eaa"
  },
  {
    "pantone":"7460-u",
    "hex":"#008ec0"
  },
  {
    "pantone":"7461-u",
    "hex":"#4492c6"
  },
  {
    "pantone":"7462-u",
    "hex":"#547aa3"
  },
  {
    "pantone":"7463-u",
    "hex":"#51657d"
  },
  {
    "pantone":"304-u",
    "hex":"#8edded"
  },
  {
    "pantone":"305-u",
    "hex":"#53caec"
  },
  {
    "pantone":"306-u",
    "hex":"#00b4e4"
  },
  {
    "pantone":"307-u",
    "hex":"#0074a2"
  },
  {
    "pantone":"308-u",
    "hex":"#266782"
  },
  {
    "pantone":"309-u",
    "hex":"#3f5864"
  },
  {
    "pantone":"635-u",
    "hex":"#ace3ef"
  },
  {
    "pantone":"636-u",
    "hex":"#8ad8ed"
  },
  {
    "pantone":"637-u",
    "hex":"#5ec8e5"
  },
  {
    "pantone":"638-u",
    "hex":"#32b8df"
  },
  {
    "pantone":"639-u",
    "hex":"#009ecc"
  },
  {
    "pantone":"640-u",
    "hex":"#008aba"
  },
  {
    "pantone":"641-u",
    "hex":"#0078a7"
  },
  {
    "pantone":"7702-u",
    "hex":"#5dabc6"
  },
  {
    "pantone":"7703-u",
    "hex":"#46a0bf"
  },
  {
    "pantone":"7704-u",
    "hex":"#348bac"
  },
  {
    "pantone":"7705-u",
    "hex":"#3c7d9a"
  },
  {
    "pantone":"7706-u",
    "hex":"#437a94"
  },
  {
    "pantone":"7707-u",
    "hex":"#477388"
  },
  {
    "pantone":"7708-u",
    "hex":"#456b7d"
  },
  {
    "pantone":"628-u",
    "hex":"#b4e0e6"
  },
  {
    "pantone":"629-u",
    "hex":"#8dd0de"
  },
  {
    "pantone":"630-u",
    "hex":"#74c4d7"
  },
  {
    "pantone":"631-u",
    "hex":"#56b2cb"
  },
  {
    "pantone":"632-u",
    "hex":"#3998b5"
  },
  {
    "pantone":"633-u",
    "hex":"#27829e"
  },
  {
    "pantone":"634-u",
    "hex":"#226e8a"
  },
  {
    "pantone":"310-u",
    "hex":"#5bd0e6"
  },
  {
    "pantone":"311-u",
    "hex":"#01bedb"
  },
  {
    "pantone":"312-u",
    "hex":"#00afd0"
  },
  {
    "pantone":"313-u",
    "hex":"#008db1"
  },
  {
    "pantone":"314-u",
    "hex":"#007d99"
  },
  {
    "pantone":"315-u",
    "hex":"#206779"
  },
  {
    "pantone":"316-u",
    "hex":"#3e5a62"
  },
  {
    "pantone":"3105-u",
    "hex":"#4ccede"
  },
  {
    "pantone":"3115-u",
    "hex":"#00bfd3"
  },
  {
    "pantone":"3125-u",
    "hex":"#00abc2"
  },
  {
    "pantone":"3135-u",
    "hex":"#008ea6"
  },
  {
    "pantone":"3145-u",
    "hex":"#007788"
  },
  {
    "pantone":"3155-u",
    "hex":"#1b6875"
  },
  {
    "pantone":"3165-u",
    "hex":"#2f5c66"
  },
  {
    "pantone":"7709-u",
    "hex":"#6eb2bd"
  },
  {
    "pantone":"7710-u",
    "hex":"#40aab8"
  },
  {
    "pantone":"7711-u",
    "hex":"#179dab"
  },
  {
    "pantone":"7712-u",
    "hex":"#228b9d"
  },
  {
    "pantone":"7713-u",
    "hex":"#2d8692"
  },
  {
    "pantone":"7714-u",
    "hex":"#358189"
  },
  {
    "pantone":"7715-u",
    "hex":"#417178"
  },
  {
    "pantone":"317-u",
    "hex":"#aee9e8"
  },
  {
    "pantone":"318-u",
    "hex":"#6bd9de"
  },
  {
    "pantone":"319-u",
    "hex":"#25c9d0"
  },
  {
    "pantone":"320-u",
    "hex":"#009da5"
  },
  {
    "pantone":"321-u",
    "hex":"#00838a"
  },
  {
    "pantone":"322-u",
    "hex":"#167378"
  },
  {
    "pantone":"323-u",
    "hex":"#2f6165"
  },
  {
    "pantone":"7464-u",
    "hex":"#aadbd7"
  },
  {
    "pantone":"7465-u",
    "hex":"#55c7b5"
  },
  {
    "pantone":"7466-u",
    "hex":"#00b4bc"
  },
  {
    "pantone":"7467-u",
    "hex":"#00a8b0"
  },
  {
    "pantone":"7468-u",
    "hex":"#3f7793"
  },
  {
    "pantone":"7469-u",
    "hex":"#3c6e89"
  },
  {
    "pantone":"7470-u",
    "hex":"#437083"
  },
  {
    "pantone":"7471-u",
    "hex":"#7fe2d8"
  },
  {
    "pantone":"7472-u",
    "hex":"#6bbdb9"
  },
  {
    "pantone":"7473-u",
    "hex":"#5ea59a"
  },
  {
    "pantone":"7474-u",
    "hex":"#458a94"
  },
  {
    "pantone":"7475-u",
    "hex":"#6b8b8d"
  },
  {
    "pantone":"7476-u",
    "hex":"#5a777b"
  },
  {
    "pantone":"7477-u",
    "hex":"#5d7079"
  },
  {
    "pantone":"5523-u",
    "hex":"#bcd5d6"
  },
  {
    "pantone":"5513-u",
    "hex":"#accacd"
  },
  {
    "pantone":"5503-u",
    "hex":"#94b7bc"
  },
  {
    "pantone":"5493-u",
    "hex":"#769ca3"
  },
  {
    "pantone":"5483-u",
    "hex":"#5f8289"
  },
  {
    "pantone":"5473-u",
    "hex":"#516d75"
  },
  {
    "pantone":"5463-u",
    "hex":"#3e4e56"
  },
  {
    "pantone":"7716-u",
    "hex":"#499996"
  },
  {
    "pantone":"7717-u",
    "hex":"#3e8e8b"
  },
  {
    "pantone":"7718-u",
    "hex":"#358282"
  },
  {
    "pantone":"7719-u",
    "hex":"#417b7b"
  },
  {
    "pantone":"7720-u",
    "hex":"#477675"
  },
  {
    "pantone":"7721-u",
    "hex":"#497375"
  },
  {
    "pantone":"7722-u",
    "hex":"#4a6b6e"
  },
  {
    "pantone":"324-u",
    "hex":"#82d8d5"
  },
  {
    "pantone":"325-u",
    "hex":"#40c1bb"
  },
  {
    "pantone":"326-u",
    "hex":"#00aaa1"
  },
  {
    "pantone":"327-u",
    "hex":"#008f85"
  },
  {
    "pantone":"328-u",
    "hex":"#137d79"
  },
  {
    "pantone":"329-u",
    "hex":"#2e7572"
  },
  {
    "pantone":"330-u",
    "hex":"#446463"
  },
  {
    "pantone":"3242-u",
    "hex":"#5ddbd3"
  },
  {
    "pantone":"3252-u",
    "hex":"#00cdc2"
  },
  {
    "pantone":"3262-u",
    "hex":"#00baae"
  },
  {
    "pantone":"3272-u",
    "hex":"#00a49a"
  },
  {
    "pantone":"3282-u",
    "hex":"#008780"
  },
  {
    "pantone":"3292-u",
    "hex":"#346e6a"
  },
  {
    "pantone":"3302-u",
    "hex":"#41615f"
  },
  {
    "pantone":"3245-u",
    "hex":"#4edcca"
  },
  {
    "pantone":"3255-u",
    "hex":"#00cfbb"
  },
  {
    "pantone":"3265-u",
    "hex":"#00c0aa"
  },
  {
    "pantone":"3275-u",
    "hex":"#00aa93"
  },
  {
    "pantone":"3285-u",
    "hex":"#009081"
  },
  {
    "pantone":"3295-u",
    "hex":"#237e74"
  },
  {
    "pantone":"3305-u",
    "hex":"#466964"
  },
  {
    "pantone":"3248-u",
    "hex":"#6aceb9"
  },
  {
    "pantone":"3258-u",
    "hex":"#48c1ac"
  },
  {
    "pantone":"3268-u",
    "hex":"#28b29a"
  },
  {
    "pantone":"3278-u",
    "hex":"#009c82"
  },
  {
    "pantone":"3288-u",
    "hex":"#208776"
  },
  {
    "pantone":"3298-u",
    "hex":"#387469"
  },
  {
    "pantone":"3308-u",
    "hex":"#48615b"
  },
  {
    "pantone":"566-u",
    "hex":"#b4e1d6"
  },
  {
    "pantone":"565-u",
    "hex":"#91d1c5"
  },
  {
    "pantone":"564-u",
    "hex":"#88c6bc"
  },
  {
    "pantone":"563-u",
    "hex":"#76b9af"
  },
  {
    "pantone":"562-u",
    "hex":"#43807a"
  },
  {
    "pantone":"561-u",
    "hex":"#466d69"
  },
  {
    "pantone":"560-u",
    "hex":"#4b5e5b"
  },
  {
    "pantone":"573-u",
    "hex":"#bbe9de"
  },
  {
    "pantone":"572-u",
    "hex":"#95decf"
  },
  {
    "pantone":"571-u",
    "hex":"#85d8c8"
  },
  {
    "pantone":"570-u",
    "hex":"#62c2b1"
  },
  {
    "pantone":"569-u",
    "hex":"#2c8f82"
  },
  {
    "pantone":"568-u",
    "hex":"#458075"
  },
  {
    "pantone":"567-u",
    "hex":"#4a635d"
  },
  {
    "pantone":"559-u",
    "hex":"#b5d1c0"
  },
  {
    "pantone":"558-u",
    "hex":"#9ac0ae"
  },
  {
    "pantone":"557-u",
    "hex":"#88b29f"
  },
  {
    "pantone":"556-u",
    "hex":"#719e8b"
  },
  {
    "pantone":"555-u",
    "hex":"#567e6a"
  },
  {
    "pantone":"554-u",
    "hex":"#577565"
  },
  {
    "pantone":"553-u",
    "hex":"#5a685d"
  },
  {
    "pantone":"5595-u",
    "hex":"#c1d2c7"
  },
  {
    "pantone":"5585-u",
    "hex":"#a2b9af"
  },
  {
    "pantone":"5575-u",
    "hex":"#9db4ab"
  },
  {
    "pantone":"5565-u",
    "hex":"#8aa29a"
  },
  {
    "pantone":"5555-u",
    "hex":"#768e87"
  },
  {
    "pantone":"5545-u",
    "hex":"#60766f"
  },
  {
    "pantone":"5535-u",
    "hex":"#485956"
  },
  {
    "pantone":"5665-u",
    "hex":"#bcc8bd"
  },
  {
    "pantone":"5655-u",
    "hex":"#b3c0b6"
  },
  {
    "pantone":"5645-u",
    "hex":"#9fafa5"
  },
  {
    "pantone":"5635-u",
    "hex":"#8d9d94"
  },
  {
    "pantone":"5625-u",
    "hex":"#798981"
  },
  {
    "pantone":"5615-u",
    "hex":"#6a7970"
  },
  {
    "pantone":"5605-u",
    "hex":"#5e695e"
  },
  {
    "pantone":"5527-u",
    "hex":"#b8c7c4"
  },
  {
    "pantone":"5517-u",
    "hex":"#a9bab7"
  },
  {
    "pantone":"5507-u",
    "hex":"#96a9a7"
  },
  {
    "pantone":"5497-u",
    "hex":"#819595"
  },
  {
    "pantone":"5487-u",
    "hex":"#697c7d"
  },
  {
    "pantone":"5477-u",
    "hex":"#5f7070"
  },
  {
    "pantone":"5467-u",
    "hex":"#545f5f"
  },
  {
    "pantone":"621-u",
    "hex":"#cadfd4"
  },
  {
    "pantone":"622-u",
    "hex":"#b3cbc1"
  },
  {
    "pantone":"623-u",
    "hex":"#96b5ab"
  },
  {
    "pantone":"624-u",
    "hex":"#82a198"
  },
  {
    "pantone":"625-u",
    "hex":"#6c8a82"
  },
  {
    "pantone":"626-u",
    "hex":"#59756f"
  },
  {
    "pantone":"627-u",
    "hex":"#455d58"
  },
  {
    "pantone":"331-u",
    "hex":"#93e8d3"
  },
  {
    "pantone":"332-u",
    "hex":"#70e2cb"
  },
  {
    "pantone":"333-u",
    "hex":"#00d2b3"
  },
  {
    "pantone":"334-u",
    "hex":"#00957e"
  },
  {
    "pantone":"335-u",
    "hex":"#247e6f"
  },
  {
    "pantone":"336-u",
    "hex":"#3a7267"
  },
  {
    "pantone":"337-u",
    "hex":"#82d5ba"
  },
  {
    "pantone":"338-u",
    "hex":"#4cc1a1"
  },
  {
    "pantone":"339-u",
    "hex":"#22ae8a"
  },
  {
    "pantone":"340-u",
    "hex":"#009e77"
  },
  {
    "pantone":"341-u",
    "hex":"#347963"
  },
  {
    "pantone":"342-u",
    "hex":"#407060"
  },
  {
    "pantone":"343-u",
    "hex":"#48655b"
  },
  {
    "pantone":"7723-u",
    "hex":"#6bac92"
  },
  {
    "pantone":"7724-u",
    "hex":"#4e9b80"
  },
  {
    "pantone":"7725-u",
    "hex":"#379272"
  },
  {
    "pantone":"7726-u",
    "hex":"#348569"
  },
  {
    "pantone":"7727-u",
    "hex":"#3e7c65"
  },
  {
    "pantone":"7728-u",
    "hex":"#457865"
  },
  {
    "pantone":"7729-u",
    "hex":"#486f67"
  },
  {
    "pantone":"3375-u",
    "hex":"#5fe0b7"
  },
  {
    "pantone":"3385-u",
    "hex":"#3ad4a7"
  },
  {
    "pantone":"3395-u",
    "hex":"#00c795"
  },
  {
    "pantone":"3405-u",
    "hex":"#00b27a"
  },
  {
    "pantone":"3415-u",
    "hex":"#308167"
  },
  {
    "pantone":"3425-u",
    "hex":"#417764"
  },
  {
    "pantone":"3435-u",
    "hex":"#4b675b"
  },
  {
    "pantone":"344-u",
    "hex":"#8ed8ac"
  },
  {
    "pantone":"345-u",
    "hex":"#6ecd9c"
  },
  {
    "pantone":"346-u",
    "hex":"#4ebd88"
  },
  {
    "pantone":"347-u",
    "hex":"#169b62"
  },
  {
    "pantone":"348-u",
    "hex":"#34855b"
  },
  {
    "pantone":"349-u",
    "hex":"#477258"
  },
  {
    "pantone":"350-u",
    "hex":"#546758"
  },
  {
    "pantone":"351-u",
    "hex":"#93e6b4"
  },
  {
    "pantone":"352-u",
    "hex":"#70e0a3"
  },
  {
    "pantone":"353-u",
    "hex":"#50d691"
  },
  {
    "pantone":"354-u",
    "hex":"#00a95c"
  },
  {
    "pantone":"355-u",
    "hex":"#19975d"
  },
  {
    "pantone":"356-u",
    "hex":"#397e58"
  },
  {
    "pantone":"357-u",
    "hex":"#516e5a"
  },
  {
    "pantone":"7478-u",
    "hex":"#a0eac5"
  },
  {
    "pantone":"7479-u",
    "hex":"#29cb7e"
  },
  {
    "pantone":"7480-u",
    "hex":"#00c281"
  },
  {
    "pantone":"7481-u",
    "hex":"#00ba6e"
  },
  {
    "pantone":"7482-u",
    "hex":"#27a770"
  },
  {
    "pantone":"7483-u",
    "hex":"#587762"
  },
  {
    "pantone":"7484-u",
    "hex":"#456e60"
  },
  {
    "pantone":"7730-u",
    "hex":"#689c7a"
  },
  {
    "pantone":"7731-u",
    "hex":"#58926b"
  },
  {
    "pantone":"7732-u",
    "hex":"#498564"
  },
  {
    "pantone":"7733-u",
    "hex":"#4b7c63"
  },
  {
    "pantone":"7734-u",
    "hex":"#597765"
  },
  {
    "pantone":"7735-u",
    "hex":"#5f7163"
  },
  {
    "pantone":"7736-u",
    "hex":"#5c6b62"
  },
  {
    "pantone":"7737-u",
    "hex":"#7bac66"
  },
  {
    "pantone":"7738-u",
    "hex":"#65a969"
  },
  {
    "pantone":"7739-u",
    "hex":"#5ca369"
  },
  {
    "pantone":"7740-u",
    "hex":"#5e9865"
  },
  {
    "pantone":"7741-u",
    "hex":"#659267"
  },
  {
    "pantone":"7742-u",
    "hex":"#688564"
  },
  {
    "pantone":"7743-u",
    "hex":"#5e745d"
  },
  {
    "pantone":"358-u",
    "hex":"#97d88a"
  },
  {
    "pantone":"359-u",
    "hex":"#7dcc77"
  },
  {
    "pantone":"360-u",
    "hex":"#5db860"
  },
  {
    "pantone":"361-u",
    "hex":"#4daa50"
  },
  {
    "pantone":"362-u",
    "hex":"#56944f"
  },
  {
    "pantone":"363-u",
    "hex":"#57854e"
  },
  {
    "pantone":"364-u",
    "hex":"#5b794e"
  },
  {
    "pantone":"7485-u",
    "hex":"#d5e4c0"
  },
  {
    "pantone":"7486-u",
    "hex":"#b7e394"
  },
  {
    "pantone":"7487-u",
    "hex":"#8be076"
  },
  {
    "pantone":"7488-u",
    "hex":"#63d05a"
  },
  {
    "pantone":"7489-u",
    "hex":"#7aab6d"
  },
  {
    "pantone":"7490-u",
    "hex":"#7b9e6b"
  },
  {
    "pantone":"7491-u",
    "hex":"#818c61"
  },
  {
    "pantone":"365-u",
    "hex":"#c2e692"
  },
  {
    "pantone":"366-u",
    "hex":"#a8dc7d"
  },
  {
    "pantone":"367-u",
    "hex":"#8fd16a"
  },
  {
    "pantone":"368-u",
    "hex":"#67b346"
  },
  {
    "pantone":"369-u",
    "hex":"#62a044"
  },
  {
    "pantone":"370-u",
    "hex":"#698a48"
  },
  {
    "pantone":"371-u",
    "hex":"#68724d"
  },
  {
    "pantone":"372-u",
    "hex":"#d1f08f"
  },
  {
    "pantone":"373-u",
    "hex":"#b9e972"
  },
  {
    "pantone":"374-u",
    "hex":"#a6e35f"
  },
  {
    "pantone":"375-u",
    "hex":"#73c92d"
  },
  {
    "pantone":"376-u",
    "hex":"#70ab37"
  },
  {
    "pantone":"377-u",
    "hex":"#728f41"
  },
  {
    "pantone":"378-u",
    "hex":"#747b4d"
  },
  {
    "pantone":"580-u",
    "hex":"#c9dcac"
  },
  {
    "pantone":"579-u",
    "hex":"#bad29e"
  },
  {
    "pantone":"578-u",
    "hex":"#a7c58e"
  },
  {
    "pantone":"577-u",
    "hex":"#93b479"
  },
  {
    "pantone":"576-u",
    "hex":"#7a9b62"
  },
  {
    "pantone":"575-u",
    "hex":"#6f8456"
  },
  {
    "pantone":"574-u",
    "hex":"#6a7355"
  },
  {
    "pantone":"5807-u",
    "hex":"#d1d3a9"
  },
  {
    "pantone":"5797-u",
    "hex":"#c7ca9c"
  },
  {
    "pantone":"5787-u",
    "hex":"#babe8f"
  },
  {
    "pantone":"5777-u",
    "hex":"#a6a97b"
  },
  {
    "pantone":"5767-u",
    "hex":"#94986c"
  },
  {
    "pantone":"5757-u",
    "hex":"#81855c"
  },
  {
    "pantone":"5747-u",
    "hex":"#70744e"
  },
  {
    "pantone":"5875-u",
    "hex":"#d7d3a1"
  },
  {
    "pantone":"5865-u",
    "hex":"#ccc895"
  },
  {
    "pantone":"5855-u",
    "hex":"#bdb889"
  },
  {
    "pantone":"5845-u",
    "hex":"#a7a375"
  },
  {
    "pantone":"5835-u",
    "hex":"#938f66"
  },
  {
    "pantone":"5825-u",
    "hex":"#8b865d"
  },
  {
    "pantone":"5815-u",
    "hex":"#736f4c"
  },
  {
    "pantone":"5803-u",
    "hex":"#cfd3b8"
  },
  {
    "pantone":"5793-u",
    "hex":"#c5caaf"
  },
  {
    "pantone":"5783-u",
    "hex":"#b5bb9f"
  },
  {
    "pantone":"5773-u",
    "hex":"#9aa184"
  },
  {
    "pantone":"5763-u",
    "hex":"#7e876d"
  },
  {
    "pantone":"5753-u",
    "hex":"#747c61"
  },
  {
    "pantone":"5743-u",
    "hex":"#636a51"
  },
  {
    "pantone":"7492-u",
    "hex":"#bcca87"
  },
  {
    "pantone":"7493-u",
    "hex":"#b7c194"
  },
  {
    "pantone":"7494-u",
    "hex":"#9eb091"
  },
  {
    "pantone":"7495-u",
    "hex":"#838e59"
  },
  {
    "pantone":"7496-u",
    "hex":"#758448"
  },
  {
    "pantone":"7497-u",
    "hex":"#8c8778"
  },
  {
    "pantone":"7498-u",
    "hex":"#777d64"
  },
  {
    "pantone":"7744-u",
    "hex":"#b9be56"
  },
  {
    "pantone":"7745-u",
    "hex":"#afb35d"
  },
  {
    "pantone":"7746-u",
    "hex":"#9b9f60"
  },
  {
    "pantone":"7747-u",
    "hex":"#909661"
  },
  {
    "pantone":"7748-u",
    "hex":"#878c62"
  },
  {
    "pantone":"7749-u",
    "hex":"#808363"
  },
  {
    "pantone":"7750-u",
    "hex":"#777a61"
  },
  {
    "pantone":"379-u",
    "hex":"#e7ee7b"
  },
  {
    "pantone":"380-u",
    "hex":"#d4e458"
  },
  {
    "pantone":"381-u",
    "hex":"#bad739"
  },
  {
    "pantone":"382-u",
    "hex":"#99c221"
  },
  {
    "pantone":"383-u",
    "hex":"#8e9a36"
  },
  {
    "pantone":"384-u",
    "hex":"#868b3c"
  },
  {
    "pantone":"385-u",
    "hex":"#7e7b4b"
  },
  {
    "pantone":"386-u",
    "hex":"#eff178"
  },
  {
    "pantone":"387-u",
    "hex":"#e3ed55"
  },
  {
    "pantone":"388-u",
    "hex":"#d5e739"
  },
  {
    "pantone":"389-u",
    "hex":"#bddc04"
  },
  {
    "pantone":"390-u",
    "hex":"#97a926"
  },
  {
    "pantone":"391-u",
    "hex":"#888a3b"
  },
  {
    "pantone":"392-u",
    "hex":"#7e7d41"
  },
  {
    "pantone":"587-u",
    "hex":"#eaec97"
  },
  {
    "pantone":"586-u",
    "hex":"#e7e988"
  },
  {
    "pantone":"585-u",
    "hex":"#e3e685"
  },
  {
    "pantone":"584-u",
    "hex":"#ced665"
  },
  {
    "pantone":"583-u",
    "hex":"#a6b340"
  },
  {
    "pantone":"582-u",
    "hex":"#919145"
  },
  {
    "pantone":"581-u",
    "hex":"#78754a"
  },
  {
    "pantone":"393-u",
    "hex":"#f8f283"
  },
  {
    "pantone":"394-u",
    "hex":"#f2ee56"
  },
  {
    "pantone":"395-u",
    "hex":"#edec3f"
  },
  {
    "pantone":"396-u",
    "hex":"#dbe200"
  },
  {
    "pantone":"397-u",
    "hex":"#a8aa31"
  },
  {
    "pantone":"398-u",
    "hex":"#959539"
  },
  {
    "pantone":"399-u",
    "hex":"#8a8537"
  },
  {
    "pantone":"3935-u",
    "hex":"#fcf389"
  },
  {
    "pantone":"3945-u",
    "hex":"#fcf05f"
  },
  {
    "pantone":"3955-u",
    "hex":"#faeb37"
  },
  {
    "pantone":"3965-u",
    "hex":"#f8e815"
  },
  {
    "pantone":"3975-u",
    "hex":"#b6a72d"
  },
  {
    "pantone":"3985-u",
    "hex":"#9c903f"
  },
  {
    "pantone":"3995-u",
    "hex":"#837b4a"
  },
  {
    "pantone":"600-u",
    "hex":"#f9f29d"
  },
  {
    "pantone":"601-u",
    "hex":"#f7ef8f"
  },
  {
    "pantone":"602-u",
    "hex":"#f7ee83"
  },
  {
    "pantone":"603-u",
    "hex":"#f3e564"
  },
  {
    "pantone":"604-u",
    "hex":"#eddc4d"
  },
  {
    "pantone":"605-u",
    "hex":"#e0cc39"
  },
  {
    "pantone":"606-u",
    "hex":"#ceb829"
  },
  {
    "pantone":"607-u",
    "hex":"#f3eaa1"
  },
  {
    "pantone":"608-u",
    "hex":"#f0e691"
  },
  {
    "pantone":"609-u",
    "hex":"#ebe081"
  },
  {
    "pantone":"610-u",
    "hex":"#e0d268"
  },
  {
    "pantone":"611-u",
    "hex":"#c8b94e"
  },
  {
    "pantone":"612-u",
    "hex":"#b7a73f"
  },
  {
    "pantone":"613-u",
    "hex":"#a29438"
  },
  {
    "pantone":"461-u",
    "hex":"#eee29f"
  },
  {
    "pantone":"460-u",
    "hex":"#e8d98b"
  },
  {
    "pantone":"459-u",
    "hex":"#ddcb77"
  },
  {
    "pantone":"458-u",
    "hex":"#ceb964"
  },
  {
    "pantone":"457-u",
    "hex":"#ad9844"
  },
  {
    "pantone":"456-u",
    "hex":"#908145"
  },
  {
    "pantone":"455-u",
    "hex":"#776f48"
  },
  {
    "pantone":"614-u",
    "hex":"#e1d9a1"
  },
  {
    "pantone":"615-u",
    "hex":"#d8d096"
  },
  {
    "pantone":"616-u",
    "hex":"#cdc588"
  },
  {
    "pantone":"617-u",
    "hex":"#bbb275"
  },
  {
    "pantone":"618-u",
    "hex":"#a69d62"
  },
  {
    "pantone":"619-u",
    "hex":"#968d54"
  },
  {
    "pantone":"620-u",
    "hex":"#877f49"
  },
  {
    "pantone":"7751-u",
    "hex":"#d1bd71"
  },
  {
    "pantone":"7752-u",
    "hex":"#d5b961"
  },
  {
    "pantone":"7753-u",
    "hex":"#c6aa5d"
  },
  {
    "pantone":"7754-u",
    "hex":"#a4915e"
  },
  {
    "pantone":"7755-u",
    "hex":"#90855f"
  },
  {
    "pantone":"7756-u",
    "hex":"#837d62"
  },
  {
    "pantone":"7757-u",
    "hex":"#7a755f"
  },
  {
    "pantone":"7758-u",
    "hex":"#dac958"
  },
  {
    "pantone":"7759-u",
    "hex":"#c8b852"
  },
  {
    "pantone":"7760-u",
    "hex":"#968f5e"
  },
  {
    "pantone":"7761-u",
    "hex":"#828162"
  },
  {
    "pantone":"7762-u",
    "hex":"#747a63"
  },
  {
    "pantone":"7763-u",
    "hex":"#717463"
  },
  {
    "pantone":"7764-u",
    "hex":"#6c6e60"
  },
  {
    "pantone":"7765-u",
    "hex":"#c0ba5e"
  },
  {
    "pantone":"7766-u",
    "hex":"#bbb35f"
  },
  {
    "pantone":"7767-u",
    "hex":"#b1a763"
  },
  {
    "pantone":"7768-u",
    "hex":"#958b62"
  },
  {
    "pantone":"7769-u",
    "hex":"#81775f"
  },
  {
    "pantone":"7770-u",
    "hex":"#777161"
  },
  {
    "pantone":"7771-u",
    "hex":"#67655a"
  },
  {
    "pantone":"4545-u",
    "hex":"#d6cca6"
  },
  {
    "pantone":"4535-u",
    "hex":"#cabe96"
  },
  {
    "pantone":"4525-u",
    "hex":"#c1b58c"
  },
  {
    "pantone":"4515-u",
    "hex":"#b1a57e"
  },
  {
    "pantone":"4505-u",
    "hex":"#a39771"
  },
  {
    "pantone":"4495-u",
    "hex":"#90845f"
  },
  {
    "pantone":"4485-u",
    "hex":"#7b6f4b"
  },
  {
    "pantone":"454-u",
    "hex":"#cac8ac"
  },
  {
    "pantone":"453-u",
    "hex":"#bcb999"
  },
  {
    "pantone":"452-u",
    "hex":"#a8a687"
  },
  {
    "pantone":"451-u",
    "hex":"#929172"
  },
  {
    "pantone":"450-u",
    "hex":"#7e785a"
  },
  {
    "pantone":"449-u",
    "hex":"#716b54"
  },
  {
    "pantone":"448-u",
    "hex":"#66614e"
  },
  {
    "pantone":"7499-u",
    "hex":"#faedbc"
  },
  {
    "pantone":"7500-u",
    "hex":"#e6d5ab"
  },
  {
    "pantone":"7501-u",
    "hex":"#decba5"
  },
  {
    "pantone":"7502-u",
    "hex":"#c7af87"
  },
  {
    "pantone":"7503-u",
    "hex":"#9d9272"
  },
  {
    "pantone":"7504-u",
    "hex":"#948272"
  },
  {
    "pantone":"7505-u",
    "hex":"#887566"
  },
  {
    "pantone":"468-u",
    "hex":"#e0ceaa"
  },
  {
    "pantone":"467-u",
    "hex":"#d2ba92"
  },
  {
    "pantone":"466-u",
    "hex":"#c1a67f"
  },
  {
    "pantone":"465-u",
    "hex":"#b0946f"
  },
  {
    "pantone":"464-u",
    "hex":"#9b7c56"
  },
  {
    "pantone":"463-u",
    "hex":"#856f51"
  },
  {
    "pantone":"462-u",
    "hex":"#70624d"
  },
  {
    "pantone":"7506-u",
    "hex":"#f9e1b7"
  },
  {
    "pantone":"7507-u",
    "hex":"#ffddaa"
  },
  {
    "pantone":"7508-u",
    "hex":"#e0b384"
  },
  {
    "pantone":"7509-u",
    "hex":"#d2a273"
  },
  {
    "pantone":"7510-u",
    "hex":"#be8b60"
  },
  {
    "pantone":"7511-u",
    "hex":"#a77750"
  },
  {
    "pantone":"7512-u",
    "hex":"#966b47"
  },
  {
    "pantone":"719-u",
    "hex":"#f2c6a2"
  },
  {
    "pantone":"720-u",
    "hex":"#ecba93"
  },
  {
    "pantone":"721-u",
    "hex":"#dfa880"
  },
  {
    "pantone":"722-u",
    "hex":"#ca916c"
  },
  {
    "pantone":"723-u",
    "hex":"#b9825f"
  },
  {
    "pantone":"724-u",
    "hex":"#a57350"
  },
  {
    "pantone":"725-u",
    "hex":"#946747"
  },
  {
    "pantone":"475-u",
    "hex":"#faccad"
  },
  {
    "pantone":"474-u",
    "hex":"#f6bd9d"
  },
  {
    "pantone":"473-u",
    "hex":"#eeab88"
  },
  {
    "pantone":"472-u",
    "hex":"#db9271"
  },
  {
    "pantone":"471-u",
    "hex":"#be7b54"
  },
  {
    "pantone":"470-u",
    "hex":"#a37052"
  },
  {
    "pantone":"469-u",
    "hex":"#7b604b"
  },
  {
    "pantone":"726-u",
    "hex":"#e8c6a9"
  },
  {
    "pantone":"727-u",
    "hex":"#dcb596"
  },
  {
    "pantone":"728-u",
    "hex":"#caa182"
  },
  {
    "pantone":"729-u",
    "hex":"#bb9275"
  },
  {
    "pantone":"730-u",
    "hex":"#a57e62"
  },
  {
    "pantone":"731-u",
    "hex":"#957156"
  },
  {
    "pantone":"732-u",
    "hex":"#88674d"
  },
  {
    "pantone":"4685-u",
    "hex":"#e6cab4"
  },
  {
    "pantone":"4675-u",
    "hex":"#dab9a1"
  },
  {
    "pantone":"4665-u",
    "hex":"#caa58e"
  },
  {
    "pantone":"4655-u",
    "hex":"#b28e7b"
  },
  {
    "pantone":"4645-u",
    "hex":"#a07d6b"
  },
  {
    "pantone":"4635-u",
    "hex":"#92715e"
  },
  {
    "pantone":"4625-u",
    "hex":"#715845"
  },
  {
    "pantone":"7513-u",
    "hex":"#e7bbb4"
  },
  {
    "pantone":"7514-u",
    "hex":"#daab9c"
  },
  {
    "pantone":"7515-u",
    "hex":"#c2907f"
  },
  {
    "pantone":"7516-u",
    "hex":"#a07462"
  },
  {
    "pantone":"7517-u",
    "hex":"#936957"
  },
  {
    "pantone":"7518-u",
    "hex":"#817172"
  },
  {
    "pantone":"7519-u",
    "hex":"#756b66"
  },
  {
    "pantone":"4755-u",
    "hex":"#dcc6bb"
  },
  {
    "pantone":"4745-u",
    "hex":"#ceb4a9"
  },
  {
    "pantone":"4735-u",
    "hex":"#bda195"
  },
  {
    "pantone":"4725-u",
    "hex":"#ae9188"
  },
  {
    "pantone":"4715-u",
    "hex":"#997d73"
  },
  {
    "pantone":"4705-u",
    "hex":"#8b6f66"
  },
  {
    "pantone":"4695-u",
    "hex":"#775c50"
  },
  {
    "pantone":"482-u",
    "hex":"#dfc8b7"
  },
  {
    "pantone":"481-u",
    "hex":"#d3b7a7"
  },
  {
    "pantone":"480-u",
    "hex":"#c3a492"
  },
  {
    "pantone":"479-u",
    "hex":"#ac8c7e"
  },
  {
    "pantone":"478-u",
    "hex":"#8e6e5c"
  },
  {
    "pantone":"477-u",
    "hex":"#7d6556"
  },
  {
    "pantone":"476-u",
    "hex":"#6e5e52"
  },
  {
    "pantone":"7527-u",
    "hex":"#dcd7d2"
  },
  {
    "pantone":"7528-u",
    "hex":"#d2c7c4"
  },
  {
    "pantone":"7529-u",
    "hex":"#bbafa9"
  },
  {
    "pantone":"7530-u",
    "hex":"#a99c95"
  },
  {
    "pantone":"7531-u",
    "hex":"#8b7f79"
  },
  {
    "pantone":"7532-u",
    "hex":"#786e66"
  },
  {
    "pantone":"7533-u",
    "hex":"#6e645c"
  },
  {
    "pantone":"7534-u",
    "hex":"#d0cbc3"
  },
  {
    "pantone":"7535-u",
    "hex":"#c0bab0"
  },
  {
    "pantone":"7536-u",
    "hex":"#afa89d"
  },
  {
    "pantone":"7537-u",
    "hex":"#b4b8b6"
  },
  {
    "pantone":"7538-u",
    "hex":"#a5aaa8"
  },
  {
    "pantone":"7539-u",
    "hex":"#9c9ea0"
  },
  {
    "pantone":"7540-u",
    "hex":"#70747c"
  },
  {
    "pantone":"427-u",
    "hex":"#c2c7ca"
  },
  {
    "pantone":"428-u",
    "hex":"#acb3b8"
  },
  {
    "pantone":"429-u",
    "hex":"#91999f"
  },
  {
    "pantone":"430-u",
    "hex":"#808991"
  },
  {
    "pantone":"431-u",
    "hex":"#737b82"
  },
  {
    "pantone":"432-u",
    "hex":"#676c73"
  },
  {
    "pantone":"433-u",
    "hex":"#5b5d62"
  },
  {
    "pantone":"420-u",
    "hex":"#bdbebd"
  },
  {
    "pantone":"421-u",
    "hex":"#b3b5b5"
  },
  {
    "pantone":"422-u",
    "hex":"#9ea1a2"
  },
  {
    "pantone":"423-u",
    "hex":"#909496"
  },
  {
    "pantone":"424-u",
    "hex":"#88898a"
  },
  {
    "pantone":"425-u",
    "hex":"#7c7e7f"
  },
  {
    "pantone":"426-u",
    "hex":"#686869"
  },
  {
    "pantone":"441-u",
    "hex":"#b9c2c1"
  },
  {
    "pantone":"442-u",
    "hex":"#acb6b6"
  },
  {
    "pantone":"443-u",
    "hex":"#8f9a9b"
  },
  {
    "pantone":"444-u",
    "hex":"#7e8689"
  },
  {
    "pantone":"445-u",
    "hex":"#6b7173"
  },
  {
    "pantone":"446-u",
    "hex":"#636968"
  },
  {
    "pantone":"447-u",
    "hex":"#5f625f"
  },
  {
    "pantone":"413-u",
    "hex":"#bcbdb4"
  },
  {
    "pantone":"414-u",
    "hex":"#abaca5"
  },
  {
    "pantone":"415-u",
    "hex":"#9d9f99"
  },
  {
    "pantone":"416-u",
    "hex":"#91928c"
  },
  {
    "pantone":"417-u",
    "hex":"#82847f"
  },
  {
    "pantone":"418-u",
    "hex":"#7a7b75"
  },
  {
    "pantone":"419-u",
    "hex":"#595955"
  },
  {
    "pantone":"400-u",
    "hex":"#c7c1ba"
  },
  {
    "pantone":"401-u",
    "hex":"#b4aea7"
  },
  {
    "pantone":"402-u",
    "hex":"#a39e98"
  },
  {
    "pantone":"403-u",
    "hex":"#928d88"
  },
  {
    "pantone":"404-u",
    "hex":"#8b8681"
  },
  {
    "pantone":"405-u",
    "hex":"#77726d"
  },
  {
    "pantone":"406-u",
    "hex":"#c7beba"
  },
  {
    "pantone":"407-u",
    "hex":"#aba2a0"
  },
  {
    "pantone":"408-u",
    "hex":"#9d9594"
  },
  {
    "pantone":"409-u",
    "hex":"#948b8a"
  },
  {
    "pantone":"410-u",
    "hex":"#8a8280"
  },
  {
    "pantone":"411-u",
    "hex":"#7a726f"
  },
  {
    "pantone":"412-u",
    "hex":"#645c59"
  },
  {
    "pantone":"434-u",
    "hex":"#d6cacb"
  },
  {
    "pantone":"435-u",
    "hex":"#b7a9ad"
  },
  {
    "pantone":"436-u",
    "hex":"#a99b9f"
  },
  {
    "pantone":"437-u",
    "hex":"#8d7f83"
  },
  {
    "pantone":"438-u",
    "hex":"#817275"
  },
  {
    "pantone":"439-u",
    "hex":"#736869"
  },
  {
    "pantone":"440-u",
    "hex":"#69615f"
  },
  {
    "pantone":"warm-gray-1-u",
    "hex":"#dbd5cd"
  },
  {
    "pantone":"warm-gray-2-u",
    "hex":"#cfc7c0"
  },
  {
    "pantone":"warm-gray-3-u",
    "hex":"#beb6af"
  },
  {
    "pantone":"warm-gray-4-u",
    "hex":"#b4aca6"
  },
  {
    "pantone":"warm-gray-5-u",
    "hex":"#a9a19c"
  },
  {
    "pantone":"warm-gray-6-u",
    "hex":"#a29b96"
  },
  {
    "pantone":"warm-gray-7-u",
    "hex":"#968f8b"
  },
  {
    "pantone":"warm-gray-8-u",
    "hex":"#8f8884"
  },
  {
    "pantone":"warm-gray-9-u",
    "hex":"#867f7c"
  },
  {
    "pantone":"warm-gray-10-u",
    "hex":"#827c78"
  },
  {
    "pantone":"warm-gray-11-u",
    "hex":"#7d7773"
  },
  {
    "pantone":"cool-gray-1-u",
    "hex":"#dad9d6"
  },
  {
    "pantone":"cool-gray-2-u",
    "hex":"#cacac8"
  },
  {
    "pantone":"cool-gray-3-u",
    "hex":"#c5c5c5"
  },
  {
    "pantone":"cool-gray-4-u",
    "hex":"#b7b8b9"
  },
  {
    "pantone":"cool-gray-5-u",
    "hex":"#adaeb0"
  },
  {
    "pantone":"cool-gray-6-u",
    "hex":"#a4a6a8"
  },
  {
    "pantone":"cool-gray-7-u",
    "hex":"#9b9ea0"
  },
  {
    "pantone":"cool-gray-8-u",
    "hex":"#939598"
  },
  {
    "pantone":"cool-gray-9-u",
    "hex":"#898b8e"
  },
  {
    "pantone":"cool-gray-10-u",
    "hex":"#818387"
  },
  {
    "pantone":"cool-gray-11-u",
    "hex":"#7a7d81"
  },
  {
    "pantone":"black-2-u",
    "hex":"#646052"
  },
  {
    "pantone":"black-3-u",
    "hex":"#595d59"
  },
  {
    "pantone":"black-4-u",
    "hex":"#696056"
  },
  {
    "pantone":"black-5-u",
    "hex":"#685a5c"
  },
  {
    "pantone":"black-6-u",
    "hex":"#4c4e56"
  },
  {
    "pantone":"black-7-u",
    "hex":"#6c6864"
  },
  {
    "pantone":"yellow-u",
    "hex":"#ffe800"
  },
  {
    "pantone":"yellow-012-u",
    "hex":"#ffe000"
  },
  {
    "pantone":"orange-021-u",
    "hex":"#ff6c2f"
  },
  {
    "pantone":"warm-red-u",
    "hex":"#ff665e"
  },
  {
    "pantone":"red-032-u",
    "hex":"#f65058"
  },
  {
    "pantone":"rubine-red-u",
    "hex":"#db487e"
  },
  {
    "pantone":"rhodamine-red-u",
    "hex":"#e44c9a"
  },
  {
    "pantone":"purple-u",
    "hex":"#bf53b6"
  },
  {
    "pantone":"violet-u",
    "hex":"#7758b3"
  },
  {
    "pantone":"blue-072-u",
    "hex":"#3f43ad"
  },
  {
    "pantone":"reflex-blue-u",
    "hex":"#39499c"
  },
  {
    "pantone":"process-blue-u",
    "hex":"#0083c3"
  },
  {
    "pantone":"green-u",
    "hex":"#00ac8c"
  },
  {
    "pantone":"black-u",
    "hex":"#615d59"
  },
  {
    "pantone":"yellow-0131-u",
    "hex":"#fbf59b"
  },
  {
    "pantone":"red-0331-u",
    "hex":"#ffb1be"
  },
  {
    "pantone":"magenta-0521-u",
    "hex":"#f8aadd"
  },
  {
    "pantone":"violet-0631-u",
    "hex":"#ba93df"
  },
  {
    "pantone":"blue-0821-u",
    "hex":"#6cd1ef"
  },
  {
    "pantone":"green-0921-u",
    "hex":"#78e6d0"
  },
  {
    "pantone":"black-0961-u",
    "hex":"#9d9994"
  },
  {
    "pantone":"801-u",
    "hex":"#009ccd"
  },
  {
    "pantone":"802-u",
    "hex":"#3bd23d"
  },
  {
    "pantone":"803-u",
    "hex":"#ffe916"
  },
  {
    "pantone":"804-u",
    "hex":"#ffaa52"
  },
  {
    "pantone":"805-u",
    "hex":"#ff7477"
  },
  {
    "pantone":"806-u",
    "hex":"#ff48b0"
  },
  {
    "pantone":"807-u",
    "hex":"#e838bf"
  },
  {
    "pantone":"871-u",
    "hex":"#ad986e"
  },
  {
    "pantone":"872-u",
    "hex":"#ac936e"
  },
  {
    "pantone":"873-u",
    "hex":"#ae906f"
  },
  {
    "pantone":"874-u",
    "hex":"#ae8f6f"
  },
  {
    "pantone":"875-u",
    "hex":"#b18b74"
  },
  {
    "pantone":"876-u",
    "hex":"#b08770"
  },
  {
    "pantone":"877-u",
    "hex":"#b4b7b9"
  },
  {
    "pantone":"medium-yellow-u",
    "hex":"#ffe100"
  },
  {
    "pantone":"bright-orange-u",
    "hex":"#ff7133"
  },
  {
    "pantone":"bright-red-u",
    "hex":"#fe5442"
  },
  {
    "pantone":"strong-red-u",
    "hex":"#d23b6a"
  },
  {
    "pantone":"pink-u",
    "hex":"#d1428d"
  },
  {
    "pantone":"medium-purple-u",
    "hex":"#65428a"
  },
  {
    "pantone":"dark-blue-u",
    "hex":"#444795"
  },
  {
    "pantone":"medium-blue-u",
    "hex":"#0087c7"
  },
  {
    "pantone":"bright-green-u",
    "hex":"#00ae8f"
  },
  {
    "pantone":"neutral-black-u",
    "hex":"#4c4845"
  }
]


// WEBPACK FOOTER //
// ./src/services/PantoneService.js